/* istanbul ignore file */
import React, {
  useState,
  useEffect,
  useReducer,
  useRef,
  useCallback,
  useImperativeHandle,
  forwardRef,
} from "react";
import _ from "lodash";
import embLabels from "../config/emb-labels-en.json";
import ACTIONS from "./DesignAssets/Design_Asset_Actions.json";
import PROJECT_ACTION from "./DesignAssets/Actions/projectKind.json"
import { upDateProjectType } from "../redux/features/projectTypeSlice";
//* reducer import

import {
  initialCBAssetList,
  CBAssetListReducer,
} from "./DesignAssets/Reducers/CBAssetListReducer";
import {
  initialCBEVList,
  CBEVListReducer,
} from "./DesignAssets/Reducers/CBEVListReducer";
import {
  initialCBLoadList,
  CBLoadListReducer,
} from "./DesignAssets/CBLoadListReducer";
import {
  initialPVDetails,
  PVDetailsReducer,
} from "./DesignAssets/Reducers/PVDetailsReducer";

import {
  initialCount,
  countReducer,
} from "./DesignAssets/Reducers/CountReducer";

import {
  initialTypes,
  projectKindReducer,
} from './DesignAssets/Reducers/projectKindReducer'

//* custom hook

import useMountEffect from "./CustomHooks/useMountEffect";
import userScope from "./CustomHooks/userScope";

//* context api

import {
  DesignAssetProvider,
  AssetBlockContextProvider,
} from "./CustomHooks/ContextApi";
import Snackbar from "./SE-Component/Snackbar";
import AlertIcon from "./SE-Component/AlertIcon";
import Confirm from "./SE-Component/Confirm";

//* child import

import IslandableSLD from "./DesignAssets/IslandableSLD";
import GridConnectedRosette from "./DesignAssets/GridConnectedRosette";
import PVHybridizationSLD from "./DesignAssets/PVHybridizationSLD";
import PvGensetAtsSLD from "./DesignAssets/PvGensetAtsSLD";
import PvBessNrSLD from "./DesignAssets/PvBessNrSLD";
import A2ESLD from "./DesignAssets/A2ESLD";
import AddEquipment from "./DesignAssets/AddEquipment";
import DesignAssetDescription from "./DesignAssets/DesignAssetDescription";
import UtilityAsset from "./DesignAssets/UtilityAsset";
import GensetAsset from "./DesignAssets/GensetAsset";
import GensetAssetPvHyb from "./DesignAssets/GensetAssetPvHyb";
import BatteryAsset from "./DesignAssets/BatteryAsset";
import PVAsset from "./DesignAssets/PVAsset";
import CHPAsset from "./DesignAssets/CHPAsset";
import HybridAsset from "./DesignAssets/HybridAsset";
import CircuitBreakerDetails from "./DesignAssets/CircuitBreakerDetails";
import GsxNewSBCbDetails from "./DesignAssets/GsxNewSBCbDetails";
import CbPmDetailsA2E from "./DesignAssets/CbPmDetailsA2E";
import CbPmDetailsGrid from "./DesignAssets/CbPmDetailsGrid";
import LoadAsset from "./DesignAssets/LoadAsset";
import LoadCB from "./DesignAssets/LoadCB";
import EvCluster from "./DesignAssets/EvCluster";
import EvCB from "./DesignAssets/EvCB";
import NoAssetSelected from "./DesignAssets/NoAssetSelected";
import AssetSelectionDER from "../components/AssetSelectionDer";
import AssetSelectionPV from "../components/AssetSelectionPV";
import AddPvModals from "../components/AddPvModals";

//*api call
import ApiSession from "../api/ApiSession";
import GensetPvBessSLD from "./DesignAssets/GensetPvBessSLD";
import HardWiredSBCbDetails from "./DesignAssets/HardWiredSBCbDetails";
import { useDispatch, useSelector } from "react-redux";
import ExistingPmDetailsGrid from "./DesignAssets/ExistingPmDetailsGrid";
import MyErrorBoundary from "../utils/ErrorBoundary";
import BessHybridAsset from "./DesignAssets/BessHybridAsset";
import { coOrdinateValidator } from "../utils/coOrdinateValidator";
import { getTooltipData } from "../redux/features/getTooltipDataSlice";
import "./designAssethook.scss";
import { assignIpAddress } from "../utils/assignIPAddress";
import { generateRandom } from "../utils/randomGenerator";
import { getProject, getProjectId, getProjectTypeValue } from "../utils/project";
import GridEtoSLD from "./DesignAssets/GridEtoSLD";
import IslandableEtoSLD from "./DesignAssets/IslandableEtoSLD";
import { projectAtomList } from "../atoms";
import { useAtom } from "jotai";
import useProjectTypeValue from "../utils/useCurrentProjectValue";
import ProjectStatus from "../components/ProjectStatus";
import { ComponentDataReducer, initialComponentData } from "./DesignAssets/Reducers/ComponentDataReducer";
import GensetPvHybridEto from "./DesignAssets/GensetPvHybridEto";
import DraggableModal from "./utils/DraggableModal";
import LoadAssetDetails from "./DesignAssets/LoadAssetDetails";
import LoadConfigDetailsModal from "../components/LoadConfigDetailsModal";
import RemoteLoadCbDetails from "./DesignAssets/RemoteLoadCbDetails";
import { MGaaS_A2E, MGAAS_ANSI, MGAAS_ETO, MGaaS_IEC, NMGAAS_ETO } from "../utils/application.constants";

const apiSession = new ApiSession();

const alphanumericRegWithHyphen = /^[-_0-9a-zA-Z]+$/;
const DesignAsset = forwardRef((props, ref) => {
  const projectTypeValue = useProjectTypeValue();

  //*state hooks
  const dispatch = useDispatch();
  const UserScope = userScope();
  const [loading, setLoading] = useState(false);
  const [displayPage, setDisplayPage] = useState(false);
  const [sldLoadCompleted, setSldLoadCompleted] = useState(false);
  const [useCaseValidGenset, setUseCaseValidGenset] = useState(false);
  const [deleteOneDER, setDeleteOneDER] = useState(false);
  const [defaultConfigurationStatus, setDefaultConfigurationStatus] =
    useState(false);
  const [siteCreated, setSiteCreated] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [siteType, setSiteType] = useState("");
  const [evceDiagramChangeRequired, setEvceDiagramChangeRequired] = useState(false);
  const [isAllowMultipleLoads, setIsAllowMultipleLoads] = useState(false);
  const [isExportOptimization, setIsExportOptimization] = useState(false);
  const [switchboardType, setSwitchboardType] = useState("");
  const [clientType, setClientType] = useState("");
  const [architectureType, setArchitectureType] = useState(null);
  const [nominalVoltage, setNominalVoltage] = useState("");
  const [isSelectSpanishCode, setIsSelectSpanishCode] = useState(false);
  const [defaultPreFillData, setDefaultPreFillData] = useState([]);
  const [availableDer, setAvailableDer] = useState([]);
  const [useCases, setUseCases] = useState([]);
  const { projectType } = useSelector((state) => state.projectType);
  const [isEvce, setIsEvce] = useState(false);
  const [prevPvGroupNames, setPrevPvGroupNames] = useState([]);
  const [batteryCommunicationData, setBatteryCommunicationData] = useState({
    ipaddress: "",
    subnetmask: "",
    defaultGateway: "",
    modbusSlaveId: "",
  });
  const [evCommunicationData, setEvCommunicationData] = useState({
    ipaddress: "",
    subnetmask: "",
    defaultGateway: "",
    modbusSlaveId: "",
  });

  const [powerMeter, setPowerMeter] = useState({
    assetId: "",
    assetType: "Power Meter",
    manufacturer: "",
    communicationModel: "PM3250",
    imageLink: null,
    assetInfo: "",
    assetEnabled: false,
    assetProperties: [],
    assetAttributes: [],
    comments: null,
  });
  const [communicationState, setCommunicationState] = useState({
    ifeIpAddress1: "",
    ifeIpAddress2: "",
    ifeIpAddress3: "",
    ifeIpAddress4: "",
    ifeIpAddress5: "",
    ifeIpAddress6: "",
    ifeIpAddress7: "",
    ifeIpAddress8: "",
    ifeIpAddress9: "",
    ifeIpAddress10: "",
    ifeIpAddress11: "",
    ifeIpAddress12: "",
    ifeIpAddress13: "",
    ifeIpAddress14: "",
    ifeIpAddress15: "",
    ifeIpAddress16: "",
    ifeIpAddress17: "",
    ifeIpAddress18: "",
    ifeIpAddress19: "",
    ifeIpAddress20: "",
    ifeIpAddress21: "",
    ifeIpAddress22: "",
    ifeIpAddress23: "",
    ifeIpAddress24: "",
    ifeSubnetMask: "",
    ifeSubnetMask2: "",
    ifeSubnetMask3: "",
    ifeSubnetMask4: "",
    ifeGateway: "",
    ifeGateway2: "",
    ifeGateway3: "",
    ifeGateway4: "",
  });
  const [cbCommunicationValues, setCbCommunicationValues] = useState({
    allIps: [],
    availableIps: [],
    usedIps: [],
    ifeIpSets: {},
  });
  const [detailsBlock, setDetailsBlock] = useState({
    cbAssetDetailsBlock: false,
    cbLoadDetailsBlock: false,
    cbEvDetailsBlock: false,
    loadDetailsBlock: false,
    evDetailsBlock: false,
    assetUtilityDetailsBlock: false,
    assetGensetDetailsBlock: false,
    assetBatteryDetailsBlock: false,
    assetPvDetailsBlock: false,
    assetCHPDetailsBlock: false,
    assetHybridDetailsBlock: false,
    newSBCbAssetDetailsBlock: false,
    cbAssetDetailsBlockA2E: false,
    cbAssetDetailsBlockGrid: false,
    pmAssetDetailsBlockA2E: false,
    pmAssetDetailsBlockGrid: false,
    existingPmAssetDetailsBlockGrid: false,
    hardWiredCbDetailsBlockGrid: false,
    assetBessHybridDetailsBlock: false,
  });
  const [selectedValues, setSelectedValues] = useState({
    selectedAsset: "",
    selectedAssetCB: "",
    selectedAssetPM: "",
    selectedLoad: "",
    selectedLoadPM: "",
    selectedLoadCB: "",
    selectedEv: "",
    selectedEvCB: "",
    selectedEvPM: "",
    selectedPv: "",
    selectSubPv: "",
  });

  const [configData, setConfigData] = useState({
    utilityConfigData: {
      name: "",
      description: "",
      utilityCO2: "",
      maximum_available_power: 10,
    },
    gensetConfigData: {
      name: "",
      description: "",
      min_power: "",
      max_power: "",
      gensetCO2: "",
      starting_timer: "",
      cooling_timer: "",
      minimum_running_period: "",
    },
    batteryConfigData: {
      name: "",
      description: "",
      min_power: "",
      max_power: "",
      capacity: 0,
      soc_max: 90,
      soc_min: 10,
      SoC_min_optimization:0,
      soc_nominal_power: 60,
      SoC_fallback: 60,
      starting_timer: "",
      quantityOfBess:1,
      perUnitMaxPower:0,
      perUnitMaxEnergy:0,
    },
    loadConfigData: {
      name: "",
      description: "",
      maximum_available_power: 0,
    },
    evConfigData: {
      name: "",
      description: "",
      maximum_available_power: 0,
    },
    cbConfigData: {
      name: "",
      description: "",
      motorized: true,
      contactor: false,
      loadCategory: 0,
      loadPriority: 0,
    },
    contactorConfigData: {
      name: "",
      description: "",
      loadCategory: 0,
      loadPriority: 0,
    },
    sampleContactorConfigData: {
      name: "",
      description: "",
      loadCategory: 0,
      loadPriority: 0,
    },
    cbConfigDataSample: {
      name: "",
      description: "",
      motorized: true,
      loadCategory: 0,
      loadPriority: 0,
    },
    sampleCbConfigData: {
      name: "",
      description: "",
      motorized: true,
      loadCategory: 0,
      loadPriority: 0,
    },
    sampleConfigData: {
      name: "",
      description: "",
      min_power: "",
      max_power: "",
    },
    configData: {
      name: "",
      description: "",
      min_power: "",
      max_power: 62.5,
    },
    powerMeterData: {
      name: "",
      description: "",
      powerMeterModbusId: "",
    },
    chpConfigData: {
      name: "",
      description: "",
      nominal_power: "",
    },
    hybridConfigData: {
      capacity: 0,
      name: "",
      description: "",
      pcu_ac_rated_power: "",
      storage_capacity:"",
      model:"",
      max_capacity: "",
      max_solar_power: "",
      max_inverter_output_power: "",
      corresponding_name_plate_capacity_value: "",
      corresponding_name_plate_capacity:[],
      hybridModels:[],
      name_plate_energy:[],
      storage_capacity_hr:[],
      time_capacity:""
    },
  });
const [isLoadNameUnique, setIsLoadNameUnique] = useState(false);
  const [gsxExternalId, setGsxExternalId] = useState({
    utilityExternalId: "",
    gensetExternalId: "",
    pvAssetExternalId: "",
    batteryExternalId: "",
  });
 const [isBessController,setIsBessController ] = useState(false);
  const [assetDetailsDisplay, setAssetDetailsDisplay] = useState({
    assetId: "",
    assetName: "",
    assetType: "",
    manufacturer: "",
    assetInfo: "",
    communicationModel: "",
    imageLink: "",
    assetProperties: [],
  });

  const [assetInfo, setAssetInfo] = useState({
    assetSelected: false,
    manufacturerLoading: false,
    assets: [],
    assetManufacturer: [],
    assetModelType: [],
    selectedManufacturer: "",
    selectdModelType: "",
  });
  const[bessControllerPrevValue,setBessControllerPrevValue] = useState({
    max_power:"",
    capacity:""
  })
  const [cbDer, setCbder] = useState("");
  const [CBValues, setCBValues] = useState({});
  const [defaultsMinMax, setDefaultsMinMax] = useState({});
  const [coordinates, setCoordinates] = useState({
    xDer: 8,
    xDerGrid: 370,
    yDerGrid: 141,
    xDerGridPM: 495,
    yDerGridPM: 127.5,
    xDerCBDiff: 590,
    yDerCBDiff: 269,
    xDerCB: 108,
    derDiff: 110,
    derDiffGrid: 120,
    xDerPvHyb: 380,
    xDerCBPvHyb: 480,
    xDerPMPvHyb:480,
    derDiffPvHyb: 120,
    xLoad: 10,
    xLoadCB: 55,
    xLoadEM: 446,
    xLoadNew: 65,
    xLoadCBNew: 110,
    xLoadPM: 345,
    xLoadPMNew: 345,
    loadDiff: 130,
    xAxisLoadCBDiff: 55,
    cbEV: {
      xDerEV: 529.5,
      yDerEV: 488,
      xDerPM: 480,
      yDerPM: 407.5,
      x1DerEVCB: 555,
      y1DerEVCB: 463,
      x2DerEVCB: 555,
      y2DerEVCB: 367,
    },

    ecc: {
      width: 690,
    },
    busbar: {
      x2: 755,
    },
    eccwidth: 208,
    busbarx2: 208,
    CX: 600,
    CY: 350,
    radius: 46,
    angle: 0,
    busbarCordinates: {
      x11: 168,
      y11: 335,
      x21: 408,
      y21: 335,
      x12: 650,
      y12: 425,
      x22: 890,
      y22: 425,
    },
  });
  const [rectangleWidth, setRectangleWidth] = useState(null);
  const [snackBar, setSnackBar] = useState({ type: "", message: "" });
  const [alert, setAlert] = useState({
    message: "",
    alertPopUpStatus: false,
    title: "",
    isRoute: false,
    routePath: "",
  });
  const [confirm, setConfirm] = useState({
    confirmMessage: "",
    confirmPopupStatus: false,
  });

  const [remoteConfirm, setRemoteConfirm] = useState({
    confirmMessage: "",
    confirmPopupStatus: false,
  });

  const [duplicateUpdate, setDuplicateUpdate] = useState({
    der: "",
    load: "",
    pv: "",
    ev: "",
  });

  const [runCalculateCoordinates, setRunCalculateCoordinates] = useState({
    componentPush: false,
  });
  const [runGenerateComponentsBlock, setRunGenerateComponentsBlock] = useState({
    generateComponentsBlock: false,
  });
  

  const [batteryRack, setBatteryRack] = useState("1");
  // const [namePlateEnergy, setNamePlateEnergy] = useState("1.1");
  const [batterySystemA2EConfig, setBatterySystemA2EConfig] = useState({
    model:[],
    namePlateEnergy:[],
  });
  const [isOpenLoadConfig, setIsOpenLoadConfig] = useState(false);
  const [loadSide, setLoadSide] = useState("LINE_SIDE");
  const [isAntiIslandingRelayEnable,setIsAntiIslandingRelayEnable] =useState(false);
  const [defaultCbData, setDefaultCbData] = useState({});
  const [defaultPmData, setDefaultPmData] = useState({});
  const [defaultDummyCbData, setDefaultDummyCbData] = useState({});
  const [gensetAssetData, setGensetAssetData] = useState({});
  const [evContactorData, setEVContactorData] = useState({});
  const [evDefaultData, setEVDefaultData] = useState({});
  const [evPMData, setEVPMData] = useState({});
  const [jsonData,setJsonData] = useState({});
  const [isContactorEnabled,setIsContactorEnabled] = useState(false);
  const [cbLoadData,setCBLoadData] = useState(null);
  const [currentProject, setCurrentProject] = useAtom(projectAtomList);
  const [defaultComponentData, setDefaultComponentData] = useAtom(projectAtomList);
  const [updateComponents, setUpdateComponents] = useAtom(projectAtomList);
  const [cbCount, setCbCount] = useAtom(projectAtomList);
  const [spanishCodeRealTime, setSpanishCodeRealTime] = useState(false);
  const [assetDefaultValues, setAssetDefaultValues] = useState();
  const [isAssetConfigChanged, setIsAssetConfigChanged] = useState(null);
  const projectStatusData = currentProject?.projectStatus;
  
const [deploymentReady, setDeploymentReady] = useState(sessionStorage.getItem("deploymentReady"));


  //* reducer hooks
  const [ComponentData, ComponentDataDispatch] = useReducer(ComponentDataReducer, initialComponentData);
 
  const [CBAssetList, CBAssetListDispatch] = useReducer(
    CBAssetListReducer,
    initialCBAssetList
  );
  const [CBEVList, CBEVListDispatch] = useReducer(
    CBEVListReducer,
    initialCBEVList
  );
  const [CBLoadList, CBLoadListDispatch] = useReducer(
    CBLoadListReducer,
    initialCBLoadList
  );

  const [firstTimeCall, setFirstTimecall] = useState(false);
const [multipleLoads, setMultipleLoads] = useState(false);
  const [count, countDispatch] = useReducer(countReducer, initialCount);

  const [projectKind, projectKindDispatch] = useReducer(projectKindReducer, initialTypes)

  const [PVDetails, PVDetailsDispatch] = useReducer(
    PVDetailsReducer,
    initialPVDetails
  );
 const [selectedLoadIndx,setSelectedLoadIndx] = useState();

  //* ref hook
  const projectId = props?.match?.params?.projectId || getProjectId()

  const initialRenderCoordinates = useRef(true);
  const initialRenderPvConfigured = useRef(true);
  const snackBarRef = useRef(null);
  const isUpdatingComponent = useRef(false);
  const {
    isMgaasAnsi,
    isDaasAnsi,
    isDaasEto,
    isMgaasIec,
    isDaasIec,
    isMgaasAnsiGrid,
    isDaasAnsiGrid,
    isDaasEtoGrid,
    isMgaasAnsiIsland,
    isDaasAnsiIsland,
    isDaasEtoIsland,
    isMgaasIecGrid,
    isDaasIecGrid,
    isMgaasIecIsland,
    isGridConnected,
    isGridConnectedGSX,
    isIslandable,
    isIslandableGSX,
    isA2E,
    isLineSide,
    isExistingSwitchBoard,
    isLoadSide,
    isNewSwitchBoard,
    isGreenStruxure,
    isGeneric,
    isGreenStruxureMicrogrid,
    isPVGensetATS,
    isFuelSaver,
    isPVBessNR,
    isPVHybrid,
    isPVGensetA2E,
    isGensetMainNoBess,
    isNoFuel,
    isETO,
    isMGaaSETOGrid,
    isMGaaSETOIsland,
    isMGaaSETO,
    isMGaaSETOGensetPvHybrid,
  } = projectKind;

  const [remoteMain, setRemoteMain] = useState(false);
  const [considerSelected, setConsiderSelected] = useState(true);

   const [assetDetails, setAssetDetails] = useState({
      assets: [],
      assetsData: [],
    });
   useEffect(()=>{
        listAssets();
      },[])
  
      const listAssets = () => {
     try {
      apiSession
      .getAssets()
      .then(response => {
        setAssetDetails(prevState => ({
          ...prevState,
          assets: response,
          assetsData: response,
        }));
  
  
        
      })
      .catch(() => {
        setLoading(false);
      });
     } catch (error) {
      console.log(error)
     }
    };
 
  useEffect(()=>{  
    if(considerSelected){
   
    if(selectedValues?.selectedAsset === 0 ||[0,1,2,3,4,5].includes(selectedValues?.selectedAsset) ){  
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_ASSET_MODIFIED,
              payload: {
                selectedAsset: selectedValues?.selectedAsset,
                configData: configData?.configData,
              },
            });
            const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
          }
      if(selectedValues?.selectedAssetCB === 0 ||[0,1,2,3,4,5].includes(selectedValues?.selectedAssetCB) ){
        
        CBAssetListDispatch({
          type:ACTIONS.UPDATE_HANDLE_CB_CONFIG,
          payload: {
            selectedAssetCB: selectedValues?.selectedAssetCB,
            cbConfigData: configData?.cbConfigData,
          },
        });
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
      if( selectedValues?.selectedAssetPM === 0 ||[0,1,2,3,4,5].includes(selectedValues?.selectedAssetPM)){
        CBAssetListDispatch({
          type:ACTIONS.UPDATE_HANDLE_POWERMETER_CONFIG,
          payload: {
            selectedAssetPM: selectedValues?.selectedAssetPM,
            cbConfigData: configData?.cbConfigData,
          },
        });
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
      if(selectedValues?.selectedLoad === 0 || selectedValues?.selectedLoad){
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_HANDLE_LOAD_CONFIG,
          payload: {
            selectedLoad: selectedValues?.selectedLoad,
            configData: configData?.configData,
          },
        });
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
      if(selectedValues?.selectedLoadCB === 0 || selectedValues?.selectedLoadCB){
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_HANDLE_LOAD_CB_CONFIG,
          payload: {
            selectedLoadCB: selectedValues?.selectedLoadCB,
            cbConfigData: configData?.cbConfigData,
          },
        });
        // CBLoadListDispatch({
        //   type: ACTIONS.UPDATE_HANDLE_LOAD_CONFIG,
        //   payload: {
        //     selectedLoad: selectedValues.selectedLoadCB,
        //     configData: configData.configData,
        //   },
        // });
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
      if(selectedValues?.selectedLoadPM === 0 || selectedValues?.selectedLoadPM){
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_LOAD_HANDLE_POWERMETER_CONFIG,
          payload: {
            selectedAssetPM: selectedValues?.selectedLoadPM,
            cbConfigData: configData?.cbConfigData,
          },
        });
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
      if(selectedValues?.selectedEv === 0 || selectedValues?.selectedEv){
        CBEVListDispatch({
          type: ACTIONS.UPDATE_HANDLE_EV_CONFIG,
          payload: {
            selectedEv: selectedValues?.selectedEv,
            configData: configData?.configData,
          },
        });
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
      if(selectedValues?.selectedEvPM === 0 || selectedValues?.selectedEvPM){
        CBEVListDispatch({
          type: ACTIONS.UPDATE_HANDLE_EV_PM,
          payload: {
            selectedAssetPM: selectedValues?.selectedEvPM,
            cbConfigData: configData?.cbConfigData,
          },
        });
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
      if(selectedValues?.selectedEvCB === 0 || selectedValues?.selectedEvCB){
        CBEVListDispatch({
          type: ACTIONS.UPDATE_HANDLE_EV_CB_CONFIG,
          payload: {
            selectedEvCB: selectedValues?.selectedEvCB,
            cbConfigData: configData?.cbConfigData,
          },
        });
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
      if(selectedValues?.selectedPv === 0 || selectedValues?.selectedPv){
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
      if(selectedValues?.selectedAssetCB === 0 ||[3,4,5].includes(selectedValues?.selectedAssetCB) ){
        
        CBAssetListDispatch({
          type:ACTIONS.UPDATE_HANDLE_CB_CONFIG,
          payload: {
            selectedAssetCB: selectedValues?.selectedAssetCB,
            cbConfigData: configData?.cbConfigData,
          },
        });
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      }
    }
     
      sessionStorage.setItem("componentDataModified",true);
   },[isAssetConfigChanged]);
  
    useEffect(() => {
       if (deploymentReady !== "true") {
         setCurrentProject((prev) => ({
            ...prev,
            showUseCase: false,
            showSystems: false,
            showBOM: false,
            showDeploy: false,
          })); 
        }
      }, [deploymentReady]);

    useEffect(() => {
      if(document.getElementsByClassName("stickyProgressBar")?.[1]){
        document.getElementsByClassName("stickyProgressBar")[1].style.display ="none";
      }
      if(document.getElementsByClassName('sticky-button')?.[1]){
        document.getElementsByClassName('sticky-button')[1].style.display = "none";

      }
      
    }, [document.getElementsByClassName("stickyProgressBar")[1],document.getElementsByClassName('sticky-button')?.[1]]);

  useEffect(() => {

    if (isGridConnected) {
      if (isMgaasAnsi) {

        CBAssetListDispatch({
          type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
          payload: {
            switchType: switchboardType,
            mode: "",
            clientType:"",
            loadSide:projectKind?.isLoadSide?"LOAD_SIDE":"LINE_SIDE",
            projectKind:projectKind
          }
        });
        CBEVListDispatch({
          type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
          payload: { coordinates: coordinates },
        });
        
      } else {
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GRIDCONNECTED,
          payload: { coordinates: coordinates },
        });
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GRIDCONNECTED,
        });
        CBEVListDispatch({
          type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
          payload: { coordinates: coordinates },
        });
      }
    }else if(isIslandable &&
      isMgaasAnsi &&
      isNoFuel){
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
          payload: {
            switchType: switchboardType,
            mode: defaultPreFillData[1]?.mode,
            clientType: "GENERIC",
            projectKind:projectKind
          },
        });
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
          payload: {
            switchType: switchboardType,
            mode: defaultPreFillData[1]?.mode,
            clientType: "GENERIC",
            loadSide:loadSide,
          },
        });
      }else{
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
        payload: { coordinates: coordinates },
      });
    }

  }, [coordinates]);
  
  useEffect(() => {
    sessionStorage.setItem("externalId", null);
   
  }, []);
  useEffect(() => {
    dispatch(getTooltipData(null));
  }, []);
  
    
  useEffect(() => {
    sessionStorage.removeItem("componentJsonData");
    if (projectId && projectTypeValue) {
      fetchDefaultDataValues();
      setDisplayPage(true);
      getExternalID();
    
    } else {
      // setAlertMessage(
      //   `Asset Page`,
      //   true,
      //   `information`,
      //   `Please create project and then visit asset page.`
      // );
    }
    sessionStorage.setItem("componentDataModified",false);
    sessionStorage.setItem(
      "derStatus",
      JSON.stringify([
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ])
    );
    sessionStorage.setItem(
      "derHistory",
      JSON.stringify({
        Utility: {},
        Genset: {},
        BESS: {},
        EV: {},
        CHP: {},
        Hybrid: {},
      })
    );
    sessionStorage.setItem(
      "pvHistory",
      JSON.stringify({ pv1: [], pv2: [], pv3: [] })
    );
    sessionStorage.setItem("cbEvHistory", []);
    sessionStorage.setItem("cbLoadHistory", []);
    sessionStorage.setItem("cbAssetHistory", []);
    sessionStorage.setItem("pmAssetHistory", []);
    sessionStorage.setItem("pmEvHistory", []);
    sessionStorage.setItem("loadHistory", []);
    sessionStorage.setItem("assetEditStatus", "");
    sessionStorage.setItem(
      "pvGroupPower",
      JSON.stringify({ pv1: "", pv2: "", pv3: "" })
    );
  }, [projectTypeValue]);

  //* To calculate coordinates

  useMountEffect(() => {
    if (initialRenderCoordinates.current) {
      initialRenderCoordinates.current = false;
    } else {
      calculateCoOridinates(runCalculateCoordinates.componentPush);
    }
  }, [runCalculateCoordinates,switchboardType]);

  useMountEffect(() => {
    if (runGenerateComponentsBlock.generateComponentsBlock) {
       generateComponentsBlock();
    }
  }, [runGenerateComponentsBlock]);

  useEffect(() => {
    if (initialRenderPvConfigured.current) {
      initialRenderPvConfigured.current = false;
    } else {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_PV_CONFIRGURED,
        payload: { PVDetails },
      });
    }
  }, [PVDetails]);

  useMountEffect(() => {
    if (availableDer?.length) {
      checkUseCaseChangeByUser();
    }
  }, [availableDer]);
 useEffect(()=>{
  getProjectDetailStatus();
  loadToolTip();
 },[])
  //* functions
  const loadToolTip = () => {
    setLoading(true);
    apiSession
      .getToolTip("information", "EN")
      .then((json) => {
        if(json){
          setCurrentProject(prev=>{
            return{
              ...prev,
              tooltipData: json
            }
          });
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const getProjectDetailStatus = () => {

    try {
      if (projectId) {
        apiSession
          .getProjectStatus(projectId)
          .then((response) => {
            if (response) {
              setCurrentProject((prevData) => ({
                ...prevData,
                projectStatus: response,
              }));
              // dispatch(upDateProjectType(response));
            }
          })
 
          .catch((error) => {
            if (error?.response?.status === 412) {
                callSnackbar("error", `${error?.message}`);  
              }
          });
      }
    } catch (error) {
      console.log(error);
    }
 
   };
   


  const getExternalID = async () => {
   try {
    await apiSession
    .getProjectExternalId()
    .then((response) => {
      setGsxExternalId((prevState) => ({
        ...prevState,
        utilityExternalId: response["1"],
        gensetExternalId: response["2"],
        pvAssetExternalId: response,
        batteryExternalId: response["3"],
      }));

      sessionStorage.setItem("externalId", JSON.stringify(response));
    })
    .catch((error) => {
       if (error?.response) {
          callSnackbar("error", `${error?.message}`);
        }
    });
   } catch (error) {
    console.log(error);
   }
  };
  const upDateCbcount = (components)=>{
    let count = 0;

    components.forEach(component => {       
        const uiAttributes = JSON.parse(component.uiAttributes);
        if (component.componentType === "Circuit Breaker" && uiAttributes.cbRequired ) {
            count += 1;
        }
    });

    setCbCount(prev=>({
      ...prev,
      assetCbCount: count <=24?count:24 ,
    }));
  }
  const fetchDefaultDataValues =() => {
    setLoading(true);   
    try {
      apiSession
      .getAssetDefaultValues(projectId)
      .then(async (json) => {
        projectKindDispatch({
          type: PROJECT_ACTION.UPDATE_PROJECT_KIND,
          payload: { ...json, projectTypeValue },
        });
        setSpanishCodeRealTime(json?.gridSettings?.spanishCodeRealTime);
        setAssetDefaultValues(json.defaultValues);

        setDefaultComponentData((prevData) => {
          return {
          ...prevData,
          defaultComponentData: json?.hybrid,
        }});
        if(json?.hybrid){
          setBatterySystemA2EConfig(prev=>{
            const hybridModels = json?.hybrid?.assetAttributes.find(
              (assetType) => assetType.type === "hybridModels"
            )?.value.split(",");
            const {storageCapacity, timeCapacity} = filterHybridModel(json?.hybrid?.assetAttributes, hybridModels?.[0]);
            
            setConfigData((prevState) => ({
              ...prevState,
              configData:{ 
                ...prevState.configData,
                hybridModels:hybridModels,
                namePlateEnergy:storageCapacity,
                time_capacity:timeCapacity
                },
            }));
            sessionStorage.setItem("bessData",JSON.stringify({hybridModels,storageCapacity, timeCapacity}));
            return {
              ...prev,
              model:hybridModels,
              namePlateEnergy:storageCapacity,
            }
          });
         
        }
       setClientType(json?.clientType);
        assignDefaultValues(
          json.defaultValues,
          json.gridSettings,
          json.defaults,
          json.siteType,
          json.switchboardType,
          json.genset,
          json.powerMeter,
          json.architecture,
          json.clientType,
          json.pm_Utility,
          json.pm_Genset,
          json.pm_PV,
          json.nominalVoltage,
          json.bess,
          json.hybrid,
          json.cb,
          json.pm_Bess,
          json.contactor,
          json.dummyCB,
          json.ev,
          json.pm_EV,
          json.remoteMain,
          json.cb_Load,
          json.cb_Utility,
          json.gridSettings?.exportOptimization
        );
      })
      .catch(() => callSnackbar("error", embLabels.errorInLoadingData));
    } catch (error) {
      console.log(error)
    }
  };

  const assignDefaultValues = (
    defaultValues,
    gridSettings,
    defaults,
    type,
    switchboardType,
    genset,
    powerMeter,
    architecture,
    clientType,
    pmUtility,
    pmGenset,
    pmPv,
    nominalVoltage,
    bess,
    hybrid,
    cb,
    pmBess,
    contactor,
    dummyCB,ev,
    pmEV,
    remoteMain,
    cb_Load,
    cb_Utility,
    isExportOptimization
  ) => {
    const dataPreFill = [];
    dataPreFill[0] = defaultValues;
    dataPreFill[1] = gridSettings;
    dataPreFill[2] = defaults;
    dataPreFill[3] = contactor;
    setCBLoadData(cb_Load);
    setDefaultPreFillData(dataPreFill);
    CBAssetListDispatch({
      type: ACTIONS.ASSIGN_DEFAULT_VALUES,
      payload: {
        defaultValues,
        defaults,
        type,
        architecture,
        genset,
        defaults,
        pmUtility,
        pmGenset,
        pmPv,
        bess,
        hybrid,
        cb,
        pmBess,
        gridSettings,
        powerMeter,
        contactor,
        clientType,
        mode: defaultPreFillData[1]?.mode,
        cb_Utility,
        projectTypeValue: projectTypeValue,
        isEvce,
      },
    });
    setDefaultCbData({ ...cb });
    setDefaultPmData({ ...powerMeter });
    setDefaultDummyCbData({ ...dummyCB });
    setEVContactorData({...contactor})
    setGensetAssetData({...genset});
    setEVPMData({...pmEV})
    setEVDefaultData({...ev})
    setBatteryCommunicationData({
      ipaddress: defaultValues.BESS.ipAddress,
      subnetmask: defaultValues.BESS.subnetMask,
      defaultGateway: defaultValues.BESS.defaultGateway,
      modbusSlaveId: defaultValues.BESS.modbusId,
    });
    if ([embLabels.PV_HYBRIDIZATION, embLabels.GRID_CONNECTED, embLabels.ISLANDABLE].includes(type)) {
      setPowerMeter({
        assetAttributes: powerMeter.assetAttributes,
        assetEnabled: powerMeter.assetEnabled,
        assetId: powerMeter.assetId,
        assetInfo: powerMeter.assetInfo,
        assetProperties: powerMeter.assetProperties,
        assetType: powerMeter.assetType,
        comments: powerMeter.comments,
        communicationModel: powerMeter.communicationModel,
        imageLink: powerMeter.imageLink,
        manufacturer: powerMeter.manufacturer,
      });
    }
    CBEVListDispatch({
      type: ACTIONS.ASSIGN_DEFAULT_VALUES,
      payload: {
        defaultValues,
        cb,
        contactor:contactor,
        ev,
        pmEV,
        isEvce,
      },
    });
    setEvCommunicationData({
      ipaddress: defaultValues.EV_charging_station.ipAddress,
      subnetmask: defaultValues.EV_charging_station.subnetMask,
      defaultGateway: defaultValues.EV_charging_station.defaultGateway,
      modbusSlaveId: defaultValues.EV_charging_station.modbusId,
    });
    CBLoadListDispatch({
      type: ACTIONS.ASSIGN_DEFAULT_VALUES,
      payload: {
        defaultValues,
        type,
        defaults,
        cb,
        dummyCB,
        pmAssetData: powerMeter,
        contactor: contactor,
        cb_Load,
        projectTypeValue,
        isEvce,
        isExportOptimization
      },
    });

    PVDetailsDispatch({
      type: ACTIONS.ASSIGN_DEFAULT_VALUES,
      payload: {
        defaultValues,
        gsxExternalId,
        isEvce
      },
    });

    setCommunicationState({
      ...communicationState,
      ifeIpAddress1: defaultValues["Circuit Breaker"].ipAddress1,
      ifeIpAddress2: defaultValues["Circuit Breaker"].ipAddress2,
      ifeIpAddress3: defaultValues["Circuit Breaker"].ipAddress3,
      ifeIpAddress4: defaultValues["Circuit Breaker"].ipAddress4,
      ifeIpAddress5: defaultValues["Circuit Breaker"].ipAddress5,
      ifeIpAddress6: defaultValues["Circuit Breaker"].ipAddress6,
      ifeIpAddress7: defaultValues["Circuit Breaker"].ipAddress7,
      ifeIpAddress8: defaultValues["Circuit Breaker"].ipAddress8,
      ifeIpAddress9: defaultValues["Circuit Breaker"].ipAddress9,
      ifeIpAddress10: defaultValues["Circuit Breaker"].ipAddress10,
      ifeIpAddress11: defaultValues["Circuit Breaker"].ipAddress11,
      ifeIpAddress12: defaultValues["Circuit Breaker"].ipAddress12,
      ifeIpAddress13: defaultValues["Circuit Breaker"].ipAddress13,
      ifeIpAddress14: defaultValues["Circuit Breaker"].ipAddress14,
      ifeIpAddress15: defaultValues["Circuit Breaker"].ipAddress15,
      ifeIpAddress16: defaultValues["Circuit Breaker"].ipAddress16,
      ifeIpAddress17: defaultValues["Circuit Breaker"].ipAddress17,
      ifeIpAddress18: defaultValues["Circuit Breaker"].ipAddress18,
      ifeIpAddress19: defaultValues["Circuit Breaker"].ipAddress19,
      ifeIpAddress20: defaultValues["Circuit Breaker"].ipAddress20,
      ifeIpAddress21: defaultValues["Circuit Breaker"].ipAddress21,
      ifeIpAddress22: defaultValues["Circuit Breaker"].ipAddress22,
      ifeIpAddress23: defaultValues["Circuit Breaker"].ipAddress23,
      ifeIpAddress24: defaultValues["Circuit Breaker"].ipAddress24,
      ifeSubnetMask: defaultValues["Circuit Breaker"].subnetMask,
      ifeSubnetMask2: defaultValues["Circuit Breaker"].subnetMask2,
      ifeSubnetMask3: defaultValues["Circuit Breaker"].subnetMask3,
      ifeSubnetMask4: defaultValues["Circuit Breaker"].subnetMask4,
      ifeGateway: defaultValues["Circuit Breaker"].defaultGateway,
      ifeGateway2: defaultValues["Circuit Breaker"].defaultGateway2,
      ifeGateway3: defaultValues["Circuit Breaker"].defaultGateway3,
      ifeGateway4: defaultValues["Circuit Breaker"].defaultGateway4,
    });

    const allIps = [];
    for (let i = 0; i < 24; i++) {
      const value = `ipAddress${i + 1}`;
      allIps.push(defaultValues["Circuit Breaker"][value]);
    }
    setCbCommunicationValues((prevState) => ({
      ...prevState,
      allIps,
      availableIps: allIps,
    }));

    setNominalVoltage(nominalVoltage);

    const defaultsData = {};

    for (let defaultData of defaults) {
      defaultsData[defaultData["param"]] = defaultData["value"];
    }
   let isBoostPro = bess?.assetAttributes?.filter(
    (item) => item?.type === "isBoostPro"
  )[0]?.value;
  isBoostPro =
    typeof isBoostPro === "string" ? JSON.parse(isBoostPro) : false;

    if(isBoostPro){
       setDefaultsMinMax( prev =>{
      // based logic on program page, refer getProgramData function
      if(defaultsData.socEmergencyDefault !== undefined && defaultsData.socEssentialDefault !== undefined){
    defaultsData.socEmergencyDefault  = Number(defaultsData.socEmergencyDefault) ;
    defaultsData.socEssentialDefault =  Number( defaultsData.socEssentialDefault);
    defaultsData.SoC_min_optimization =  Number( defaultsData.socMinOptimizationDefault);
   defaultsData.socMinMin = Number(defaultsData.socMinEstar);
    defaultsData.socMinMax = Number(defaultsData.socMaxEstar);
  }
      return  defaultsData
      }
    );
    }else{
      setDefaultsMinMax( prev =>{
      // based logic on program page, refer getProgramData function
      if(defaultsData.socEmergencyDefault !== undefined && defaultsData.socEssentialDefault !== undefined){
    defaultsData.socEmergencyDefault  = Number(defaultsData.socEmergencyDefault) ;
    defaultsData.socEssentialDefault =  Number( defaultsData.socEssentialDefault);
    defaultsData.SoC_min_optimization =  Number( defaultsData.socMinOptimizationDefault);
      }
      return  defaultsData
      }
    );
    }
    
    fetchComponentsExisted(defaultValues,contactor,dummyCB,cb);
    setSiteType(type);
    setSwitchboardType(switchboardType);
    setRemoteMain(remoteMain);
    // setClientType(clientType);
    setArchitectureType(architecture);
  };
  //fetch the all component list step 3
  const fetchComponentsExisted = (defaultValues,contactor,dummyCB,cb) => {
    apiSession
      .getComponents(projectId)
      .then((data) => {
        const json = data;
        setJsonData(json.components);
        upDateCbcount(json.components);
         projectKindDispatch({
          type: PROJECT_ACTION.UPDATE_PROJECT_KIND,
          payload: { ...json, projectTypeValue },
        });
        try {
            setUpdateComponents(prev=>{
              return {
          ...prev,
          updateComponents:json.components
        }})
        } catch (error) {
          //nothing doing here
        }
        
        if(json){
          setIsAntiIslandingRelayEnable(json?.antiIslandingDetection);
          setIsSelectSpanishCode(json?.isSpanishCodeRealTime);
        }
        if(json?.components?.length > 0){
          const isBessAvailable = json?.components?.find(item=> item["componentName"] === "BESS");
          if(isBessAvailable){
            try {
              const bessConfigData = JSON.parse(isBessAvailable?.attributes);
              if(bessConfigData?.soc_emergency && bessConfigData?.soc_essential){
                setDefaultsMinMax(prev=>{
                  return {
                    ...prev,
                    socEmergencyDefault:bessConfigData?.soc_emergency,
                    socEssentialDefault:bessConfigData?.soc_essential
                  }
        
                });
              
                setBessControllerPrevValue({
                  max_power:Number(bessConfigData?.max_power),
                  capacity:Number(bessConfigData?.capacity)
                })
              }
            } catch (error) {
              callSnackbar("error", "Bess data is not available");
            }
           
          }         
         
        }
        // projectKindDispatch({
        //   type: PROJECT_ACTION.UPDATE_PROJECT_KIND,
        //   payload: { ...json, projectTypeValue },
        // });
        ComponentDataDispatch({
          type: ACTIONS.UPDATE_COMPONENT_DATA,
          payload: json,
        })
        sessionStorage.setItem("programPage", json?.programPage);
        sessionStorage.setItem("communicationValidated", json?.systemsPage);
        setSiteCreated(json?.siteCreated);
        setUpdateComponents(prev=>({
          ...prev,
          isSiteCreated:json?.siteCreated
        }))
        setSwitchboardType(json?.switchboardType);
        setIsEvce(json?.isElectricalVehicleEnergyManagement)
        
        setRemoteMain(json?.remoteMain);
        setSiteType(json?.siteType);
        setEvceDiagramChangeRequired(json?.evceDiagramChangeRequired);
        setIsAllowMultipleLoads(json?.isAllowMultipleLoads);
        setIsExportOptimization(json?.isExportOptimization);
        if (
          (json?.components.length > 0 && json?.siteType === "GENSET_PVBESS_A2E") 
        ) {
           const bessConfigData = JSON.parse(sessionStorage.getItem("bessData"));
             const storageObj = {};
             bessConfigData?.storageCapacity.forEach((value, index) => {
                                storageObj[index] = value;
                              })
          const configData = JSON.parse(
              json?.components?.filter((item) =>
                ["Hybrid", "BESS"].includes(item["componentType"])
              )[0].attributes
            );
          // const hybridModels = configData?.hybridModels?(JSON.parse(configData?.hybridModels)):(bessConfigData?.hybridModels);
          const timeCapacity =  configData?.time_capacity?Object.keys(JSON.parse(configData?.time_capacity)):Object.values(storageObj);
          setBatterySystemA2EConfig(prev=>{
            return {
              ...prev,
              // model:[...hybridModels],
             namePlateEnergy:[...timeCapacity],
            }
          });
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_EXISTING_BATTERY_CONFIG,
            payload: {
              index: 7,
              data:configData,
            },
          });
        }
        if (
          json?.components.length > 0 &&
          json?.diagramChangeRequired === false
        ) {
          getCBDetails(json?.components);
          assignComponents(json, contactor,json?.isAllowMultipleLoads,json?.isExportOptimization);
          setMultipleLoads(json?.isAllowMultipleLoads)
          const defaultConfigurationStatusNew =false;
         setTimeout(() => {
            fetchUseCase(
            defaultConfigurationStatusNew,
            defaultValues,
            json?.siteType,
            json?.diagramChangeRequired,
            json?.isAllowMultipleLoads,
            dummyCB,
            cb,
            json?.isExportOptimization,
            projectTypeValue
          );
          }, 1000);

          setLoadSide(json?.connectionType);
         
          
        } else {
          const defaultConfigurationStatusNew = true;
          setFirstTimecall(true);
          setMultipleLoads(json?.isAllowMultipleLoads)
          setDefaultConfigurationStatus(defaultConfigurationStatusNew);
          setTimeout(() => {
            fetchUseCase(
            defaultConfigurationStatusNew,
            defaultValues,
            json?.siteType,
            json?.diagramChangeRequired,
            json?.isAllowMultipleLoads,
             dummyCB,
            cb,
            json?.isExportOptimization,
            projectTypeValue
          );
          },1000)
        
        }
       if( json?.components.length > 0 &&
          json?.evceDiagramChangeRequired  ){
          //  CBEVListDispatch({
          //   type: ACTIONS.REMOVE_ASSET_EV,
          //   payload: {
          //     index: 0,
          //     configData,
          //   },
          // });
          CBEVListDispatch({
              type: ACTIONS.REMOVE_ASSET_EV_CHANGED,
              payload: {
              index: 0,
              configData,
            },
            });
          setDetailsBlock((prevState) => ({
            ...prevState,
            evDetailsBlock: false,
          }));

            countDispatch({
              type: ACTIONS.RESET_EV_COUNT,
              payload: { count: 0 },
            });
             const runCalculateCoordinatesNew = { componentPush: true };
           const runGenerateComponentsBlockNew = { generateComponentsBlock: true };

          setTimeout(() => {
          setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);

            setRunCalculateCoordinates(runCalculateCoordinatesNew);
            // setLoading(false);
          }, 1000);
          }
       
      })
      .catch(() => {
        setLoading(false);
        setSldLoadCompleted(false);
        callSnackbar("error", embLabels.errorInLoadingData);
      });
  };

  const fetchUseCase = (
    defaultConfigurationStatusNew,
    defaultValues,
    siteType,
    diagramChangeRequired,
    isAllowMultipleLoads,
    dummyCB,
    cb,
    isExportOptimization,
    projectTypeValue
  ) => {
    apiSession
      .fetchUseCase(projectId)
      .then((json) => {
        setSldLoadCompleted(true);
        setUseCases(json);
        if (defaultConfigurationStatusNew) {
          loadUseCase(
            json,
            defaultConfigurationStatusNew,
            defaultValues,
            siteType,
            diagramChangeRequired,
            isAllowMultipleLoads,
            dummyCB,
              cb,
            isExportOptimization,
          );
          
        } else {
          // setLoading(true);
          setAvailableDer(json);
         const tempProjectTypeValue1 = getProjectTypeValue()
        if((tempProjectTypeValue1 === MGAAS_ANSI ||  tempProjectTypeValue1 === MGAAS_ETO  || tempProjectTypeValue1 === NMGAAS_ETO || tempProjectTypeValue1 === MGaaS_IEC) && CBLoadList.length >0 && siteType === "GRID_CONNECTED" && (isAllowMultipleLoads || diagramChangeRequired)){
          CBLoadListDispatch({
            type: ACTIONS.REMOVE_ASSET_LOADS,
            payload: {
              dummyCB:dummyCB ||[],
              cb:cb ||[],
              isAllowMultipleLoads:isAllowMultipleLoads || false,
              isExportOptimization:isExportOptimization || false,
              projectTypeValue:projectTypeValue || "",
              siteType:siteType || "",
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_LOAD_COUNT_ONLY_ONE,
            payload: { count: 1 },
          });
         }
          if(isAllowMultipleLoads){
            const runCalculateCoordinatesNew = { componentPush: true };
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };

          setTimeout(() => {
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);

            setRunCalculateCoordinates(runCalculateCoordinatesNew);
            // setLoading(false);
          }, 1000);
        
          }
          checkUseCase(json);
         
        }
        
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const loadUseCase = (
    usecase,
    defaultConfigurationStatusNew,
    defaultValues,
    siteType,
    diagramChangeRequired,
    isAllowMultipleLoads,
      dummyCB,
    cb,
    isExportOptimization,
  ) => {
    usecase.forEach((usecaseData) => {
      switch (usecaseData) {
        case embLabels.UTILITY:
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_UTILITY,
            payload: { defaultValues, projectTypeValue,siteType },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          break;

        case embLabels.GENERATOR:
          const projectTypeA2E = projectTypeValue ?? getProject()?.projectType
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_GENSET,
            payload: { defaultValues, projectTypeA2E, siteType },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          setUseCaseValidGenset(true);
          break;

        case embLabels.BESS:
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_BESS,
            payload: { defaultValues, projectTypeValue, siteType },
          });
          break;

        case embLabels.PV_INVERTER:
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_PV,
            payload: { defaultValues, projectTypeValue, siteType },
          });

          //* assign pv to pvset1

          const externalIds = JSON.parse(sessionStorage.getItem("externalId"));

          PVDetailsDispatch({
            type: ACTIONS.ASSIGN_USECASE_PVSET1,
            payload: {
              count: 3,
              externalIds: externalIds,
              projectTypeValue: projectTypeValue
            },
          });

          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          break;

        case embLabels.HYBRID:
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          CBAssetListDispatch({
            type: ACTIONS.ASSIGN_USECASE_HYBRID,
            payload: { defaultValues, projectTypeValue, siteType },
          });
          break;

        case embLabels.LOAD:
          CBLoadListDispatch({
            type: ACTIONS.ASSIGN_USECASE_LOAD,
            payload: {
              defaultValues,
              defaultCbData,
              siteType,
              defaultDummyCbData,
              projectTypeValue
            },
          });
          //  countDispatch({
          //   type: ACTIONS.UPDATE_LOAD_COUNT,
          //   payload: { count: 1 },
          // });
          const tempProjectTypeValue = getProjectTypeValue()
        if((tempProjectTypeValue === MGAAS_ANSI ||  tempProjectTypeValue === MGAAS_ETO  || tempProjectTypeValue === NMGAAS_ETO || tempProjectTypeValue === MGaaS_IEC) && CBLoadList.length >0 && siteType === "GRID_CONNECTED" && (isAllowMultipleLoads || diagramChangeRequired)){
          CBLoadListDispatch({
            type: ACTIONS.REMOVE_ASSET_LOADS,
             payload: {
              dummyCB:dummyCB ||[],
              cb:cb ||[],
              isAllowMultipleLoads:isAllowMultipleLoads || false,
              isExportOptimization:isExportOptimization || false,
                projectTypeValue:projectTypeValue || "",
              siteType:siteType || "",
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_LOAD_COUNT_ONLY_ONE,
            payload: { count: 1 },
          });
         }else
          {
           countDispatch({
            type: ACTIONS.UPDATE_LOAD_COUNT,
            payload: { count: 1 },
          });

         }
         
          break;
         
        default:
          break;
      }
    });

    if (defaultConfigurationStatusNew) {
      const runCalculateCoordinatesNew = { componentPush: true };
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    } else {
      const runCalculateCoordinatesNew = { componentPush: false };
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }

    setLoading(false);
  };
  const checkUseCaseChangeByUser = () => {
    const foundGenerator = availableDer.indexOf(embLabels.GENERATOR);
    const foundBESS = availableDer.indexOf(embLabels.BESS);

    if (foundGenerator === -1 && siteType === embLabels.ISLANDABLE) {
      if (CBAssetList[1].uiData.status) {
        removeGenset();
      }
    } else if (foundGenerator !== -1) {
      if (
        !CBAssetList[1].uiData.status &&
        sessionStorage.getItem("useCaseChanged") === "true"
      ) {
        checkGensetDeleteOneDER(true);
      }
    }

    if (foundBESS !== -1) {
      if (
        !CBAssetList[2].uiData.status &&
        sessionStorage.getItem("useCaseChanged") === "true"
      ) {
        if (checkSLDCount()) {
          setLoading(true);
          setTimeout(() => {
            if (UserScope.access.saveSLD === true) {
              if (siteType === embLabels.ISLANDABLE) {
                addBattery();
              }
            }
            setLoading(false);
          }, 800);
        } else {
          setAlertMessage(`Alert`, false, ``, embLabels.deleteOneDERToAddGeset);
        }
      }
    }
    sessionStorage.setItem("useCaseChanged", false);
  };

  const checkGensetDeleteOneDER = (existedInUsecase) => {
    if (existedInUsecase) {
      if (checkSLDCount()) {
        setDeleteOneDER(false);
        setLoading(false);
        setTimeout(() => {
          if (siteType === embLabels.ISLANDABLE) {
            addGenset();
          }
        }, 800);
      } else {
        setAlertMessage(`Alert`, false, ``, embLabels.deleteOneDERToAddGeset);
        sessionStorage.setItem("deploymentReady", false);
         setDeploymentReady("false");
        setDeleteOneDER(true);
      }
    }
  };

  const checkUseCase = (usecase) => {
    const hasGenerator = usecase.includes(embLabels.GENERATOR);
    if (hasGenerator) setUseCaseValidGenset(true);
  };

  const calculateCoOridinates = (componentPush) => {

    if (
      isIslandable &&
      !isMgaasAnsi
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count ,siteType:siteType, projectKind: projectKind,switchboardType},
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count },
      });

      let ecc = { ...coordinates.ecc };
      let busbar = { ...coordinates.busbar };
      const totalLoads = count.loadCount + count.evCount;

      if (count.derCount > count.loadCount + count.evCount) {
        if (totalLoads >= 10) {
          ecc.width = 1250;
          busbar.x2 = 1255;
        } else {
          ecc.width = coordinates.eccwidth + (count.derCount - 1) * 110;
          busbar.x2 = coordinates.busbarx2 + (count.derCount - 1) * 110;
        }
      } else {
        if (totalLoads >= 11) {
          ecc.width = 1250;
          busbar.x2 = 1255;
        } else {
          ecc.width = coordinates.eccwidth + (totalLoads - 1) * 110;
          busbar.x2 = coordinates.busbarx2 + (totalLoads - 1) * 110;
        }
      }

      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        ecc,
        busbar,
      }));

      if (componentPush) {
        generateComponentsBlock();
      }
      checkAssetStatus();
    }

    if 
     ( isGridConnected && 
      !isMgaasAnsi
    ) {
      let x21 =
        count.derCount === 2
          ? "695"
          : count.derCount === 3
          ? "870"
          : count.derCount === 4
          ? "985"
          : count.derCount === 5
          ? switchboardType === embLabels.EXISTING_SWITCHBOARD
            ? "1145"
            : "1045"
          : "795";

      if (switchboardType === embLabels.EXISTING_SWITCHBOARD) {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          xDerGrid: "480",
          xDerCBDiff: "700",
          yDerGrid: "243",
          yDerCBDiff: "370",
          xDerGridPM: "605",
          yDerGridPM: "227.5",
          cbEV: {
            xDerEV: 597.5,
            yDerEV: 492,
            xDerPM: 545,
            yDerPM: 487.5,
            x1DerEVCB: 675,
            y1DerEVCB: 570,
            x2DerEVCB: 675,
            y2DerEVCB: 464,
          },
          busbarCordinates: {
            ...prevCoordinates.busbarCordinates,
            x11: "126",
            y11: "280",
            x21: "345",
            y21: "280",
            x12: "620",
            y12: "470",
            x22: x21,
            y22: "470",
          },
        }));
      } else {
        let x21 =
          count.derCount === 2
            ? "695"
            : count.derCount === 3
            ? "810"
            : count.derCount === 4
            ? "915"
            : count.derCount === 5
            ? "1045"
            : "795";

        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          xDerGrid: "370",
          xDerCBDiff: "590",
          yDerGrid: "141",
          yDerCBDiff: "269",
          xDerGridPM: "495",
          yDerGridPM: "127.5",
          cbEV: {
            xDerEV: 707.5,
            yDerEV: 553,
            xDerPM: 655,
            yDerPM: 555.5,
            x1DerEVCB: 555,
            y1DerEVCB: 463,
            x2DerEVCB: 555,
            y2DerEVCB: 367,
          },
          busbarCordinates: {
            ...prevCoordinates.busbarCordinates,
            x11: "426",
            y11: "370",
            x21: x21,
            y21: "370",
          },
        }));
      }

      // CBAssetListDispatch({
      //   type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GRIDCONNECTED,
      //   payload: { coordinates: coordinates },
      // });
      // CBLoadListDispatch({
      //   type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GRIDCONNECTED,
      // });
      // CBEVListDispatch({
      //   type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
      // });

      if (componentPush) {
        generateComponentsBlock();
      }
      checkAssetStatus();
    }

    if (isMgaasAnsiGrid) {
      if(isExistingSwitchBoard){
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        cbEV: {
          xDerEV: 530,
          yDerEV: 490,
          xDerPM: 475,
          yDerPM: 490,
          x1DerEVCB: 608,
          y1DerEVCB: 570,
          x2DerEVCB: 608,
          y2DerEVCB: 470,
        },
              
      }));
    }else{
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        cbEV: {
          xDerEV: 300,
          yDerEV: 320,
          xDerPM: 245,
          yDerPM: 320,
          x1DerEVCB: 377.5,
          y1DerEVCB: 398.5,
          x2DerEVCB: 378.5,
          y2DerEVCB: 300,
        },  
           
      }));
    }
    }else if(isMgaasAnsiIsland){
      if(isExistingSwitchBoard){
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 635,
            yDerEV: 450,
            xDerPM: 475,
            yDerPM: 490,
            x1DerEVCB: 608,
            y1DerEVCB: 570,
            x2DerEVCB: 608,
            y2DerEVCB: 470,
          },
                
        }));
      }else{
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 80,
            yDerEV: 320,
            xDerPM: 25,
            yDerPM: 320,
            x1DerEVCB: 377.5,
            y1DerEVCB: 398.5,
            x2DerEVCB: 378.5,
            y2DerEVCB: 300,
          },  
             
        }));
      }
    }

    if (siteType === embLabels.PV_HYBRIDIZATION) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVHYBRIDIZATION,
        payload: { coordinates: coordinates, switchType:switchboardType },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVHYBRIDIZATION,
      });
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "426",
          y11: "360",
          x21: "815",
          y21: "360",
        },
      }));
      if (componentPush) {
        generateComponentsBlock();
      }
      checkAssetStatus();
    }

    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      clientType === embLabels.GREENSTRUXURE_PROJECT &&
      architectureType === embLabels.PV_GENSET_ATS &&
      defaultPreFillData[1].mode !== "FUEL_SAVER"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS,
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS,
      });
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "168",
          y11: "290",
          x21: "408",
          y21: "290",
          x12: "670",
          y12: "430",
          x22: "840",
          y22: "430",
        },
      }));
      if (componentPush) {
        generateComponentsBlock();
      }
      checkAssetStatus();
    }

    if (
      (siteType === embLabels.ISLANDABLE_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1].mode === "FUEL_SAVER") ||
      (siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType:switchboardType,
          clientType,
          mode: defaultPreFillData[1]?.mode,
          loadSide:loadSide,
        }
      });
      // CBLoadListDispatch({
      //   type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS,
      // });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });
      if(switchboardType===embLabels.EXISTING_SWITCHBOARD&&(isMgaasAnsiIsland||isDaasAnsiIsland  ||isDaasEtoIsland)){
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
          payload: { coordinates: coordinates,loadSide:loadSide, count: count ,siteType:siteType, projectKind: projectKind,switchboardType},
        });
      }

      let x22;
      if (count.derCount <= 3 && count.loadCount <= 4) {
        x22 = "1095";
      } else if (count.derCount <= 4 && count.loadCount <= 4) {
        siteType === "GRID_CONNECTED_GSX" ||
        (["ISLANDABLE_GSX", "ISLANDABLE"].includes(siteType) &&
          (switchboardType === "" ||
            switchboardType === embLabels.EXISTING_SWITCHBOARD))
          ? (x22 = "1095")
          : (x22 = "510");
      } else if (count.derCount <= 4 && count.loadCount === 5) {
        switchboardType === embLabels.NEW_SWITCHBOARD &&
        ["ISLANDABLE_GSX", "ISLANDABLE"].includes(siteType)
          ? (x22 = 570)
          : (x22 = "1170");
      } else if (count.loadCount === 10) {
        switchboardType === embLabels.NEW_SWITCHBOARD &&
        ["ISLANDABLE_GSX", "ISLANDABLE"].includes(siteType)
          ? (x22 = 650)
          : (x22 = "1250");
      } else {
        {
          ["ISLANDABLE_GSX", "ISLANDABLE"].includes(siteType) &&
          switchboardType === embLabels.NEW_SWITCHBOARD
            ? (x22 = "620")
            : (x22 = "1170");
        }
      }

      // x21: "594",

      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "158",
          y11: "285",
          x21: "330",
          y21: "285",
          x12: "630",
          y12: "430",
          x22: x22,
          y22: "430",
        },
      }));
      if (componentPush) {
        generateComponentsBlock();
      }
      checkAssetStatus();
    }

    if (
      (siteType === embLabels.GRID_CONNECTED_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_BESS_NR) ||
      (siteType === embLabels.GRID_CONNECTED &&
        projectTypeValue === "MGaaS ANSI")
    ) {
      const x21 = count.derCount === 2 ? "815" : "715";
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType: switchboardType,
          mode: "",
          clientType:"",
          loadSide:projectKind?.isLoadSide?"LOAD_SIDE":"LINE_SIDE",
          projectKind:projectKind
        }
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVBESS_NR,
        payload: switchboardType,
      });
      let x22;
      if (count.derCount > 3) {
        setRectangleWidth(530);
        if (
          ["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) &&
          (switchboardType === "" ||
            switchboardType === embLabels.EXISTING_SWITCHBOARD)
        ) {
          x22 = 1065;
        } else {
          ["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) &&
          switchboardType === embLabels.NEW_SWITCHBOARD
            ? (x22 = 690)
            : (x22 = 640);
          setRectangleWidth(730);
        }
      } else {
        if (
          !["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) ||
          (siteType !== "ISLANDABLE_GSX" &&
            (switchboardType === "" ||
              switchboardType === embLabels.EXISTING_SWITCHBOARD))
        ) {
          setRectangleWidth(420);
          x22 = 965;
        } else {
          setRectangleWidth(580);
          !["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) ||
          (siteType !== "ISLANDABLE_GSX" &&
            (switchboardType !== "" ||
              switchboardType !== embLabels.EXISTING_SWITCHBOARD))
            ? (x22 = 510)
            : (x22 = 965);
        }
      }
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "168",
          y11: "283",
          x21: "408",
          y21: "283",
          x12: "630",
          y12: "430",
          x22,
          y22: "430",
        },
      }));

      if (componentPush) {
        generateComponentsBlock();
      }
      checkAssetStatus();
    }
    if(siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI"){
      if(switchboardType === embLabels.EXISTING_SWITCHBOARD){
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 250,
            yDerEV: 290,
            xDerPM: 195,
            yDerPM: 330,
            x1DerEVCB: 608,
            y1DerEVCB: 570,
            x2DerEVCB: 608,
            y2DerEVCB: 470,
          },
                
        }));
      }else{
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 80,
            yDerEV: 320,
            xDerPM: 25,
            yDerPM: 320,
            x1DerEVCB: 377.5,
            y1DerEVCB: 398.5,
            x2DerEVCB: 378.5,
            y2DerEVCB: 300,
          },  
             
        }));
      }
    }
    if((projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland)){
      if(switchboardType === embLabels.EXISTING_SWITCHBOARD){
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 310,
            yDerEV: 475,
            xDerPM: 255,
            yDerPM: 515,
            x1DerEVCB: 355,
            y1DerEVCB: 470,
            x2DerEVCB: 355,
            y2DerEVCB: 470,
          },
                
        }));
      }else{
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 300,
            yDerEV: 365,
            xDerPM: 245,
            yDerPM:isMgaasIecIsland ?384: 370,
            x1DerEVCB: isMgaasIecIsland || isMGaaSETOIsland?379:345,
            y1DerEVCB: 370,
            x2DerEVCB: 378,
            y2DerEVCB: isMgaasIecIsland || isMGaaSETOIsland?460:300,
          },  
             
        }));
      }
    }
    CBEVListDispatch({
      type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
      payload: { coordinates: coordinates, count: count },
    }); 
    if (
      siteType === embLabels.GENSET_PVBESS_A2E &&
      clientType === embLabels.A2E_PROJECT
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GENSET_PVBESS_A2E,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type:ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GENSET_PVBESS_A2E,
      });
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "426",
          y11: "360",
          x21: "815",
          y21: "360",
        },
      }));
      checkAssetStatus();

    }
    if(isMgaasIecIsland || isMGaaSETOIsland){
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_ISLANDABLE,
        payload: {
          switchType: switchboardType,
          mode: defaultPreFillData[1]?.mode,
          projectKind: projectKind,
        },
      });
    }
    if(switchboardType===embLabels.EXISTING_SWITCHBOARD&&(isMgaasAnsiIsland||isDaasAnsiIsland ||isDaasEtoIsland)){
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
        payload: { coordinates: coordinates,loadSide:loadSide, count: count ,siteType:siteType, projectKind: projectKind,switchboardType},
      });
    }
    let x11, y11, x21, y21, x12, y12, x22, y22;
    let coOrdinates = { x11, y11, x21, y21, x12, y12, x22, y22 };
    const coOrdinateLists = coOrdinateValidator(
      coOrdinates,
      switchboardType,
      siteType,
      projectType || projectTypeValue,
      count,
      rectangleWidth,
      loadSide,
      clientType,
      defaultPreFillData[1]?.mode,
      projectKind,
    );
    setRectangleWidth(coOrdinateLists.rectangleWidth);
    setCoordinates((prevCoordinates) => ({
      ...prevCoordinates,
      busbarCordinates: {
        ...prevCoordinates.busbarCordinates,
        ...coOrdinateLists.cooridinates,
      },
    }));
  };

  const checkAssetStatus = () => {
    let componentConfigStatus = true;
    CBAssetList?.forEach((componentData, index) => {
      if(!componentData) return;
      if (componentData.uiData.status && [0, 1, 2,3,4,5, 6, 7].includes(index)) {
        if (!componentData.uiData.configured) {
          componentConfigStatus = false;
        }
      }
      if (componentData?.uiData?.status) {
        if ( 
          !componentData?.uiData?.CBConfigured &&
          componentData?.uiData?.cbRequired
        ) {
          componentConfigStatus = false;
        }
        // if ( 
        //   !componentData?.uiData?.CBConfigured && ( siteType === embLabels.PV_HYBRIDIZATION)
        // ) {
        //   componentConfigStatus = false;
        // }
        // if (
        //   !componentData?.uiData?.pmRequired &&
        //   !(componentData?.uiData?.pmConfiguredGrid === undefined||componentData?.uiData?.pmConfiguredGrid)
        // ) {
        //   componentConfigStatus = false;
        // }
        if (
          componentData?.uiData?.pmRequired &&
          !componentData?.uiData?.pmConfiguredGrid&&['DaaS ANSI','DaaS ETO','DaaS IEC','MGaaS ANSI','MGaaS IEC','MGaaS ETO'].includes(projectTypeValue)
        ) {
          componentConfigStatus = false;
        }
        if(componentData?.uiData?.pmRequired && !componentData.uiData.pmConfigured &&
          !componentData?.uiData?.pmConfigured && ["MGaaS AccessToEnergy"].includes(projectTypeValue )){
            componentConfigStatus = false;
        }
       
      }
    });
    CBEVList?.forEach((componentData) => {
      if(componentData)return;
      if (componentData?.uiData?.status) {
        if (
          !componentData?.uiData?.configured ||
          (componentData?.uiData?.cbRequired && !componentData?.uiData?.CBConfigured) ||
          (componentData?.uiData?.pmRequired &&
            !componentData?.uiData?.pmConfiguredGrid)
        ) {
          componentConfigStatus = false;
        }
      }
    });
    if (
      [
        embLabels.ISLANDABLE,
        embLabels.GRID_CONNECTED,
        embLabels.GENSET_PVBESS_A2E,
        embLabels.PV_HYBRIDIZATION
      ].includes(siteType) ||
      (siteType === embLabels.ISLANDABLE_GSX &&
        defaultPreFillData[1].mode === "FUEL_SAVER")
    ) {
    CBLoadList.forEach((componentData) => {
        if (componentData?.uiData?.status) {
          if (
            !componentData?.uiData?.configured&&
            !(isMgaasAnsi )
            && !isGridConnected
          ) {
            componentConfigStatus = false;
          }
          if(!componentData?.uiData?.configured &&(isMGaaSETO || isMgaasIec || isMgaasAnsi) ){
            componentConfigStatus = false;
          }
          if((isMgaasIecIsland || isMGaaSETOIsland)&& (componentData.uiData.pmRequired &&
            !componentData.uiData.pmConfiguredGrid)){
            componentConfigStatus = false;

          }
          if((isMgaasAnsiIsland || isDaasAnsiIsland || isDaasEtoIsland) &&  (componentData.uiData.pmRequired &&
            !componentData.uiData.pmConfiguredGrid)){
            componentConfigStatus = false;

          }
          if(!componentData?.uiData?.CBConfigured && !(isMGaaSETOIsland || isMgaasIecIsland ||isMgaasIecGrid || isA2E ||isMGaaSETOGensetPvHybrid) && !isGridConnected){
            componentConfigStatus = false;
          }else if((isMGaaSETOIsland || isMgaasIecIsland) &&componentData?.uiData?.cbRequired&&!componentData?.uiData?.CBConfigured){
            componentConfigStatus = false;
          }
        }
      });
    }

    PVDetails?.pvset1Data.forEach((pvData) => {
      if (!pvData.status) {
        componentConfigStatus = false;
      }
    });
    PVDetails?.pvset2Data.forEach((pvData) => {
      if (!pvData.status) {
        componentConfigStatus = false;
      }
    });
    PVDetails?.pvset3Data.forEach((pvData) => {
      if (!pvData.status) {
        componentConfigStatus = false;
      }
    });
    sessionStorage.setItem("deploymentReady", componentConfigStatus);
    setDeploymentReady(`${componentConfigStatus}`);
    return componentConfigStatus;
  };

  const checkExportOptimizationCondition = () => {
    if (
      defaultPreFillData[1]?.exportOptimization &&
      !CBAssetList[2]?.uiData?.status
    ) {
      if (UserScope.access.saveSLD) {
        setTimeout(() => {
          if (siteType !== embLabels.GRID_CONNECTED) {
            addBattery();
          }
        }, 300);
      }
    }
  };

  const padNumberFormat = (number) => (number < 10 ? "0" : "") + number;
  
const isDuplicates = (arr)=> {
  const filtered = arr?.filter(item => item !== null && item !== undefined);
  return filtered.length !== new Set(filtered).size;
}

  const pvSetGroupName = (component) => {
   let  pv1 = []
    let pv2 = []
    let pv3 = []
    const pvData = component?.components?.filter(
      (item) => item.componentType === "Inverter"
    );
    pvData?.forEach((item) => {
      var set = JSON.parse(item.uiAttributes).set;
      var name = JSON.parse(item.attributes).groupName;
      if(set === 1){
          pv1.push(name)
      }else if(set === 2){
          pv2.push(name);
      }else{
          pv3.push(name);
      }
    });
    
 const pvGroupData = [pv1[0],pv2[0],pv3[0]];
  return isDuplicates(pvGroupData)


  };

  const saveDraftComponentData = ()=>{
    sessionStorage.setItem("componentDataModified",false);
    localStorage.setItem("assetEditStatus", `"",false`);
    const componentJson = JSON.parse(sessionStorage.getItem("componentJsonData"));
    let checkUniqueName =  pvSetGroupName(componentJson);
     setTimeout(()=>{
      if(componentJson){
        updateComponentRemote(componentJson);
      }     
    },200)
    // if(checkUniqueName){
      
    //  callSnackbar(
    //     `error`,
    //     `Duplicate PV group names detected. Each set must have a unique group name to proceed with configuration.`
    //   );
    // }else{
      

    // }
   
   
  }
  const DER = ["Utility","BESS","Genset","Load","Inverter","EV_charging_station"]
  const prorityRules = {
    "Utility": {
      derPriority: 0,
      pmPriority: 1,
      cbPriority: 2
    },
    "BESS": {
      derPriority: 3,
      pmPriority: 1,
      cbPriority: 2
    },
    "Genset": {
      derPriority: 3,
      pmPriority: 1,
      cbPriority: 2
    },
    "Load": {
      derPriority: 0,
      pmPriority: 1,
      cbPriority: 2
      },
      "Inverter": {
        derPriority: 3,
        pmPriority: 1,
        cbPriority: 2
        },
        "EV_charging_station": {
          derPriority: 3,
          pmPriority: 1,
          cbPriority: 2
          }
  }

  const generateComponentsBlock = () => {
    const componentJson = {
      projectId: "",
      deploymentReady: true,
      programPage: true,
      components: [],
      switchboardType: switchboardType,
      remoteMain:remoteMain,
      connectionType: null,
    };

    if (
      siteType === embLabels.GRID_CONNECTED_GSX ||
      siteType === embLabels.ISLANDABLE ||siteType === embLabels.ISLANDABLE_GSX ||
      siteType === embLabels.GRID_CONNECTED
    ) {
      componentJson.connectionType = loadSide;
    }
    componentJson.projectId = projectId
      ? projectId
      : "1";
    componentJson.userId = 1;
    let arrayComponent = [];
    let assetCB = 10;
    let assetI = 1;
    //* assets
    const CBAssetListNew = _.cloneDeep(CBAssetList);
    //cb conncetion done here
    CBAssetListNew.map((cbData, key) => {
      if (cbData?.uiData.status) {
        let CBComponentIdx = "CB_10";
        let CRComponentIdx = "Contactor_10";
        let PMComponentIdx = "PM_10";
        switch (cbData?.assetType) {
          case embLabels.UTILITY:
          case embLabels.GENSET:
          case embLabels.BESS:

          case embLabels.CHP:
          case embLabels.HYBRID:
            let asset = {};
            if (cbData?.assetType === embLabels.UTILITY) {
              asset.assetId = 1;
              CBComponentIdx = "CB_10";
              CRComponentIdx = "Contactor_10";
              PMComponentIdx = "PM_10";
              asset.componentType = "Utility";
              asset.externalId = gsxExternalId?.utilityExternalId
                ? gsxExternalId?.utilityExternalId
                : null;
            }
            if (cbData?.assetType === embLabels.GENSET) {
              if (cbData?.assetDetails?.length) {
                asset.assetId = cbData?.assetDetails[0]?.assetId;
              } else {
                asset.assetId = 2;
              }
              CBComponentIdx = "CB_20";
              CRComponentIdx = "Contactor_20";
              PMComponentIdx = "PM_20";
              asset.componentType = "Genset";
              asset.externalId = gsxExternalId?.gensetExternalId
                ? gsxExternalId.gensetExternalId
                : null;
            }
            if (cbData?.assetType === embLabels.BESS) {
              if (cbData?.assetDetails?.length) {
                asset.assetId = cbData?.assetDetails?.[0]?.assetId;
              } else {
                asset.assetId = 3;
              }
              CBComponentIdx = "CB_30";
              CRComponentIdx = "Contactor_30";
              PMComponentIdx = "PM_30";
              asset.componentType = "BESS";
              asset.externalId = gsxExternalId?.utilityExternalId
                ? gsxExternalId.batteryExternalId
                : null;
            }

            //* CHP

            if (cbData?.assetType === embLabels.CHP) {
              if (cbData?.assetDetails?.length) {
                asset.assetId = cbData?.assetDetails?.[0]?.assetId;
              } else {
                asset.assetId = 3;
              }
              CBComponentIdx = "CB_80";
              PMComponentIdx = "PM_80";
              asset.componentType = "CHP";
            }

            if (cbData?.assetType === embLabels.HYBRID) {
              if (cbData?.assetDetails?.length) {
                asset.assetId = cbData?.assetDetails?.[0]?.assetId;
              } else {
                asset.assetId = 3;
              }
              CBComponentIdx = "CB_90";
              PMComponentIdx = "PM_90";
              asset.componentType = "Hybrid";
              
            }
            asset.userId = 1;
            asset.componentIdx = "ASSET_" + padNumberFormat(assetI);
            asset.componentName = cbData?.configData?.name;
            if(projectTypeValue === "DaaS ANSI" || projectTypeValue === "DaaS ETO"){
              asset.deviceName = cbData?.configData?.deviceName;
            }
            componentJson.deploymentReady =
              componentJson?.deploymentReady && cbData?.uiData?.configured
                ? true
                : false;
            asset.connections = [];
            asset.communications = [];
            asset.uiAttributes = JSON.stringify(cbData?.uiData);

            let assetConnections = {
              componentIdx: CBComponentIdx,
              endpointIdX: "1",
              connectionType: "electrical_connection",
            };
            let assetAttributes = {};
            if(cbData?.configData?.max_power!=undefined&&cbData?.configData?.max_power!=""){
                   let values;
              if(cbData?.configData?.max_power){
                values = JSON.parse(cbData?.configData?.max_power)||"0"
              }
         

              if(Array.isArray(values)){
                const configDataNew = {...cbData.configData}
                configDataNew.max_power = values[0];
                cbData.configData = configDataNew
              }
            }
            assetAttributes = cbData?.configData;
            if (cbData?.assetType === embLabels.GENSET) {
              delete assetAttributes?.min_power;
            }
            asset.attributes = JSON.stringify(assetAttributes);
            if (
              [
                embLabels.ISLANDABLE,
                embLabels.PV_HYBRIDIZATION,
                embLabels.GENSET_PVBESS_A2E,
                embLabels.GRID_CONNECTED_GSX,
                embLabels.GRID_CONNECTED,
              ].includes(siteType) ||
              architectureType === embLabels.PV_GENSET_ATS
            ) {
              asset.connections.push(assetConnections);
            }

            if (cbData?.assetType === embLabels.GENSET) {
              if (
                cbData?.assetDetails.length && cbData?.assetDetails?.[0] && 
                cbData?.assetDetails?.[0]?.assetInfo === "Hardwired"
              ) {
                //*do nothing
              }
            }
            if (cbData?.assetType === embLabels.HYBRID) {
              asset.communications = [
                {
                  ip: cbData?.communicationDataBess?.ipaddress,
                  subnetmask: cbData?.communicationDataBess?.subnetmask,
                  defaultGateway: cbData?.communicationDataBess?.defaultGateway,
                  modbusSlaveId: cbData?.communicationDataBess?.modbusSlaveId,
                  type: "BESS",
                },
                {
                  ip: cbData?.communicationDataPv?.ipaddress,
                  subnetmask: cbData?.communicationDataPv?.subnetmask,
                  defaultGateway: cbData?.communicationDataPv?.defaultGateway,
                  modbusSlaveId: cbData?.communicationDataPv?.modbusSlaveId,
                  type: "PV",
                },
              ];
            } else if (
              (projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO") &&
              // siteType === embLabels.GRID_CONNECTED &&
              cbData?.assetType === embLabels.BESS
            ) {
              asset.communications = [];
              if (projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO") {
                if (
                  cbData?.assetDetails[0]?.communicationModel ===
                  "AC Coupled PCU"
                  ) {
                  let assetCommunications = {
                    ip: defaultPreFillData?.[0]?.["BESS"]?.pcs_ipAddress,
                    subnetmask: defaultPreFillData?.[0]?.["BESS"]?.subnetMask,
                    defaultGateway: defaultPreFillData?.[0]?.["BESS"]?.defaultGateway,
                    modbusSlaveId:
                      defaultPreFillData?.[0]?.["BESS"]?.pcs_slaveid ??
                      cbData?.communicationDataPv?.modbusSlaveId,
                    type: "PCS",
                  };
                  asset.communications.push(assetCommunications);
                  let assetCommunications1 = {
                    ip: defaultPreFillData?.[0]?.["BESS"]?.mbms_ipAddress,
                    subnetmask:defaultPreFillData?.[0]?.["BESS"]?.subnetMask,
                    defaultGateway:defaultPreFillData?.[0]?.["BESS"]?.defaultGateway,
                    modbusSlaveId:
                      defaultPreFillData?.[0]?.["BESS"]?.mbms_slaveid ??
                      cbData?.communicationDataBess?.modbusSlaveId,
                    type: "MBMS",
                  };
                  asset.communications.push(assetCommunications1);
                }else   if (
                  cbData?.assetDetails[0]?.communicationModel ===
                  "Schneider Boost Pro"
                  ) {
                  let assetCommunications = {
                    ip: defaultPreFillData?.[0]?.["BESS"]?.eeac_ipAddress,
                    subnetmask: defaultPreFillData?.[0]?.["BESS"]?.eeac_subnetmask,
                    defaultGateway: defaultPreFillData?.[0]?.["BESS"]?.eeac_gateway,
                    modbusSlaveId:
                      defaultPreFillData?.[0]?.["BESS"]?.eeac_slaveid ??
                      cbData?.communicationDataPv?.modbusSlaveId,
                    type: "BESS",
                  };
                  asset.communications.push(assetCommunications);
                  let assetCommunications1 = {
                     ip: defaultPreFillData?.[0]?.["BESS"]?.bess_subSystem_ipAddress,
                    subnetmask: defaultPreFillData?.[0]?.["BESS"]?.bess_subSystem_subnetmask,
                    defaultGateway: defaultPreFillData?.[0]?.["BESS"]?.bess_subSystem_gateway,
                    modbusSlaveId:
                      defaultPreFillData?.[0]?.["BESS"]?.bess_subSystem_slaveid ??
                      cbData?.communicationDataPv?.modbusSlaveId,
                    type: "Miscellaneous",

                  };
                  asset.communications.push(assetCommunications1);
                } else if (cbData?.assetDetails[0]?.assetInfo === "Hardwired") {
                  asset.communications = [];
                } else {
                  let assetCommunications = {
                    ip: cbData?.communicationDataBess?.ipaddress??defaultPreFillData?.[0]?.["BESS"]?.ipAddress,
                    subnetmask: cbData?.communicationDataBess?.subnetMask??defaultPreFillData?.[0]?.["BESS"]?.subnetMask,
                    defaultGateway:
                      cbData?.communicationDataBess?.defaultGateway??defaultPreFillData?.[0]?.["BESS"]?.defaultGateway,
                    modbusSlaveId: cbData?.communicationDataBess?.modbusSlaveId??defaultPreFillData?.[0]?.["BESS"]?.modbusSlaveId,
                    type: "BESS",
                  };
                  asset.communications.push(assetCommunications);
                }
              }
            } else {
              if (cbData?.communicationData.modbusSlaveId) {
                let assetCommunications = {
                  ip: cbData?.communicationData?.ipaddress,
                  subnetmask: cbData?.communicationData?.subnetmask,
                  defaultGateway: cbData?.communicationData?.defaultGateway,
                  modbusSlaveId: cbData?.communicationData?.modbusSlaveId,
                  type: cbData?.assetType,
                };

                asset.communications.push(assetCommunications);

                if (cbData?.assetType === embLabels.GENSET || embLabels.BESS) {
                  if (cbData?.assetDetails?.length) {
                    if (cbData?.assetDetails?.[0]?.assetInfo === "Hardwired") {
                      asset.communications = [];
                    }
                  }
                }
              }
            }

            arrayComponent.push(asset);
            if (
              (siteType === embLabels.ISLANDABLE||siteType === embLabels.ISLANDABLE_GSX) ||
              (siteType === embLabels.GRID_CONNECTED &&
                cbData?.assetType === embLabels.BESS || cbData?.assetType === embLabels.UTILITY
                // &&cbData.uiData.cbRequired
                ) ||
              (projectKind?.isMgaasAnsiGrid &&cbData?.assetType === embLabels.UTILITY) ||
              (siteType === embLabels.GRID_CONNECTED_GSX &&
                cbData?.assetType === embLabels.UTILITY 
                // &&cbData.uiData.cbRequired
                ) ||
              (siteType === embLabels.ISLANDABLE_GSX &&
                defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
              (siteType === embLabels.ISLANDABLE_GSX &&
                defaultPreFillData[1]?.mode === "GENSET_MAIN_NO_BESS" &&
                cbData?.assetType === embLabels.UTILITY) ||
              (siteType === embLabels.PV_HYBRIDIZATION &&
                cbData?.assetType === embLabels.UTILITY) ||
              (siteType === embLabels.PV_HYBRIDIZATION &&
                cbData?.assetType === embLabels.GENSET || (
                clientType === embLabels.A2E_PROJECT &&
                siteType === embLabels.GENSET_PVBESS_A2E &&
                (
                  cbData?.assetType === embLabels.HYBRID)))
            ) {
              let cb = {};
              cb.assetId = cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
              cb.userId = 1;
              cb.componentIdx = CBComponentIdx;
              cb.componentName = cbData?.cbConfigData?.name;
              cb.componentType = "Circuit Breaker";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails?.[0];
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };

              let attributes = {
                name: cbData?.cbConfigData?.name,
                description: cbData?.cbConfigData?.description,
                motorized: cbData?.cbConfigData.motorized ? 1 : 0,
                contactor: cbData?.cbConfigData.contactor ? 1 : 0,
                loadCategory: cbData?.cbConfigData?.loadCategory,
                loadPriority: cbData?.cbConfigData?.loadPriority,
                Contactor_healthy_status_available: 0,
              };

              if (
                siteType === embLabels.GRID_CONNECTED &&
                cbData.assetType === embLabels.BESS &&
                !cbData?.uiData?.cbRequired
              ) {
                attributes.hardwired = cbData?.cbConfigData?.hardwired;
              }
              if (
                // siteType === embLabels.GRID_CONNECTED &&
                // cbData?.cbConfigData?.motorized &&
                cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                  "Hardwired"
              ) {
                attributes.type = "12";
              }
              if (
                // siteType === embLabels.GRID_CONNECTED &&
                cbData?.assetType === embLabels.BESS &&
                cbData?.uiData?.contactor
              ) {
                attributes.type = "20";
                attributes.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value;
              }

              if(!cbData?.cbConfigData?.motorized&&!cbData?.uiData?.contactor){
                attributes.type = "40"
              }
              if(cbData?.assetType === embLabels.HYBRID &&  clientType === embLabels.A2E_PROJECT && siteType === embLabels.GENSET_PVBESS_A2E ){
                attributes.type = "40"
              }
              if (
                // siteType === embLabels.GRID_CONNECTED &&
                cbData?.assetType === embLabels.BESS &&
                !cbData?.uiData?.cbRequired
              ) {
                attributes.type = "40";
              }
                 if(isMgaasIecIsland || isMGaaSETOIsland){
                    if(cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo === "Hardwired"){
                      attributes.type = "12";
                    }

                              
                                      if(!cbData?.uiData?.contactor&&!cbData?.cbConfigData?.motorized){
                          attributes.type = "40"
                        }
                        if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                          attributes.type = "40";
                        }
                        if(cbData?.uiData?.cbRequired && cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo==="Communicating"){
                            delete attributes.type;
                        }

                    if (cbData?.uiData?.contactor) {
                      attributes.type = "20";
                      attributes.Contactor_healthy_status_available =
                        cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value;
                    }
              
                }
              cb.attributes = JSON.stringify(attributes);
              //cb values
              let communications = {};

              if (cbData?.assetType === embLabels.UTILITY) {
                communications = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };
              }
              if (cbData?.assetType === embLabels.GENSET) {
                communications = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };
              }
              if (cbData?.assetType === embLabels.BESS) {
                // her ethe code goes add pcu and mbms if()

                communications = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };
              }
              cb.connections.push(connections);
              cb.communications.push(communications);

              if (
                clientType === embLabels.A2E_PROJECT &&
                siteType === embLabels.GENSET_PVBESS_A2E &&
                (cbData?.assetType === embLabels.GENSET ||
                  cbData?.assetType === embLabels.HYBRID)
              ) {
                cb.communications = [];
              }
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              [embLabels.ISLANDABLE,embLabels.GRID_CONNECTED].includes(siteType) &&
              cbData?.assetType === embLabels.BESS &&
              cbData?.uiData?.contactor&&!cbData?.cbConfigData.motorized
            ) {
              let cb = {};
              cb.assetId =
                cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
              cb.userId = 1;
              cb.componentIdx = CRComponentIdx;
              cb.componentName = cbData?.contactorConfigData?.name;
              cb.componentType = "Contactor";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo =  cbData?.contactorConfigData.cbAssetDetails[0];
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: CBComponentIdx,
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };

              let attributes = {
                name: cbData?.contactorConfigData?.name,
                description: cbData?.contactorConfigData?.description,
                loadCategory: cbData?.contactorConfigData?.loadCategory,
                loadPriority: cbData?.contactorConfigData?.loadPriority,
              };

              cb.attributes = JSON.stringify(attributes);

              //cb values
              let communications = {};

              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            //* for pvhybridization

            if (
              // siteType === embLabels.PV_HYBRIDIZATION ||
              cbData?.uiData?.pmRequired&&cbData?.assetType === embLabels.BESS&&!isDaasIec&&
              architectureType === embLabels.PV_GENSET_ATS
            ) {
              let cb = {};
              // cb.assetId = powerMeter?.assetId
              //   ? powerMeter?.assetId
              //   : cbData?.powerMeterData?.pmAsset?.assetId;
              // cb.userId = 1;
              // cb.componentIdx = PMComponentIdx;
              // cb.componentName = cbData?.powerMeterData?.name;
              // cb.componentType = "Power Meter";
              // cb.connections = [];
              // cb.communications = [];
              // cb.uiAttributes = JSON.stringify(cbData.uiData);
              cb.assetId = cbData?.powerMeterData?.pmAsset?.assetId;
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name!==""?cbData?.powerMeterData?.name:defaultPreFillData?.[0]?.["Power Meter"]?.nameGenset;
              cb.componentType = "Power Meter";
              cb.communications = [];
              cb.connections = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset?.assetId;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.powerMeterData?.name,
                description: cbData?.powerMeterData?.description,
                powerMeterModbusId: cbData?.powerMeterData?.powerMeterModbusId,
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values
              let communications = {};
              communications = {
                ip: cbData?.powerMeterData?.ipAddress,
                subnetmask: cbData?.powerMeterData?.mask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                type: "Circuit Breaker",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              architectureType === embLabels.PV_GENSET_ATS &&
              cbData.uiData.existingPmRequired
            ) {
              let cb = {};
              cb.assetId = powerMeter?.assetId
                ? powerMeter?.assetId
                : cbData?.existingPowerMeterData?.pmAsset?.assetId;
              cb.userId = 1;
              cb.componentIdx = "PM_50";
              cb.componentName = cbData?.existingPowerMeterData?.name;
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo =  powerMeter?.assetId
              ? powerMeter
              : cbData?.existingPowerMeterData?.pmAsset;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.existingPowerMeterData?.name,
                description: cbData?.existingPowerMeterData?.description,
                powerMeterModbusId:
                  cbData?.existingPowerMeterData?.powerMeterModbusId,
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values
              let communications = {};
              communications = {
                ip: cbData?.existingPowerMeterData?.ipAddress,
                subnetmask: cbData?.existingPowerMeterData?.mask,
                defaultGateway: cbData?.existingPowerMeterData?.gatewayAddress,
                modbusSlaveId:
                  cbData?.existingPowerMeterData?.powerMeterModbusId,
                type: "Circuit Breaker",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            //* pv+bess(nr)
            if (
              siteType === embLabels.GRID_CONNECTED_GSX &&
              cbData.assetType === embLabels.UTILITY
            ) {
              // do nothing
            }

            if (((isMgaasIecIsland||isMGaaSETOIsland))&&cbData?.assetType === embLabels.UTILITY) {
              let cb = {};
              // cb.assetId = powerMeter?.assetId
              //   ? powerMeter?.assetId
              //   : cbData?.powerMeterData?.pmAsset?.assetId;
              // cb.userId = 1;
              // cb.componentIdx = PMComponentIdx;
              // cb.componentName = cbData.powerMeterData.name??"PM_Utility";
              // cb.componentType = "Power Meter";
              // cb.connections = [];
              // cb.communications = [];
              cb.assetId = cbData?.powerMeterData?.pmAsset?.assetId;
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name!==""?cbData?.powerMeterData?.name:defaultPreFillData?.[0]?.["Power Meter"]?.nameGenset;
              cb.componentType = "Power Meter";
              cb.communications = [];
              cb.connections = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.powerMeterData?.name,
                description: cbData?.powerMeterData?.description,
                powerMeterModbusId: cbData?.powerMeterData?.powerMeterModbusId,
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values

              let communications = {};
              communications = {
                ip: cbData?.powerMeterData?.ipAddress,
                subnetmask: cbData?.powerMeterData?.mask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                type: "Power Meter",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              siteType === embLabels.GRID_CONNECTED_GSX &&
              architectureType === embLabels.PV_BESS_NR &&
              cbData.assetType === embLabels.BESS 
              // &&cbData.uiData.cbRequired
            ) {
              let cb = {};
              cb.assetId =
                cbData?.cbConfigData?.cbAssetDetails[0]?.assetId ?? 7;
              cb.userId = 1;
              cb.componentIdx = CBComponentIdx;
              cb.componentName = cbData?.cbConfigData?.name;
              cb.componentType = "Circuit Breaker";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails[0];
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };

              let attributes = {
                name: cbData?.cbConfigData?.name,
                description: cbData?.cbConfigData?.description,
                motorized: cbData?.cbConfigData?.motorized? 1 : 0,
                contactor: cbData?.cbConfigData?.contactor ? 1 : 0,
                loadCategory: cbData?.cbConfigData?.loadCategory,
                loadPriority: cbData?.cbConfigData?.loadPriority,
              };
              if (
                // siteType === embLabels.GRID_CONNECTED &&
                // cbData?.cbConfigData?.motorized &&
                cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                  "Hardwired"
              ) {
                attributes.type = "12";
              }
              cb.attributes = JSON.stringify(attributes);

              //cb values
              let communications = {
                ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                subnetmask:
                  cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                defaultGateway:
                  cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                modbusSlaveId:
                  cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                type: "Circuit Breaker",
              };

              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              (siteType === embLabels.GRID_CONNECTED_GSX &&
                architectureType === embLabels.PV_BESS_NR &&
                cbData.assetType === embLabels.BESS &&
                cbData.uiData.existingPmRequired) ||
               (projectKind?.isMgaasAnsiGrid&&
                cbData?.uiData.existingPmRequired)
            ) {
              let cb = {};
              cb.assetId = powerMeter?.assetId
                ? powerMeter?.assetId
                : cbData?.existingPowerMeterData?.pmAsset?.assetId;
              cb.userId = 1;
              cb.componentIdx = "PM_50";
              cb.componentName = cbData?.existingPowerMeterData?.name;
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo =  powerMeter?.assetId
              ? powerMeter
              : cbData?.existingPowerMeterData?.pmAsset
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.existingPowerMeterData?.name,
                description: cbData?.existingPowerMeterData?.description,
                powerMeterModbusId:
                  cbData?.existingPowerMeterData?.powerMeterModbusId,
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values
              let communications = {};
              communications = {
                ip: cbData?.existingPowerMeterData?.ipAddress,
                subnetmask: cbData?.existingPowerMeterData?.mask,
                defaultGateway: cbData?.existingPowerMeterData?.gatewayAddress,
                modbusSlaveId:
                  cbData?.existingPowerMeterData?.powerMeterModbusId,
                type: "Circuit Breaker",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }

            if (
              (siteType === embLabels.GRID_CONNECTED_GSX &&
                architectureType === embLabels.PV_BESS_NR &&
                cbData?.assetType === embLabels.BESS &&
                cbData?.uiData.pmRequired) ||
             (isMgaasAnsi && cbData?.assetType === embLabels.BESS && cbData?.uiData.pmRequired)||
              ((projectKind?.isMgaasIec ||projectKind?.isMGaaSETO||projectKind?.isDaasIecIsland)&&
                cbData?.assetType === embLabels.BESS&&cbData?.uiData.pmRequired)
            ) {
              let cb = {};
              cb.assetId = cbData?.powerMeterData?.pmAsset?.assetId ? cbData?.powerMeterData?.pmAsset?.assetId
                : powerMeter?.assetId ? powerMeter?.assetId : 153;

              // cb.assetId = 153
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name || "PM_BESS";
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset?.assetId ? cbData?.powerMeterData?.pmAsset
              : powerMeter;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: "PM_BESS",
                description: cbData?.powerMeterData?.description,
                powerMeterModbusId: "255",
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values

              let communications = {};
              communications = {
                ip: cbData?.powerMeterData?.ipAddress,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                subnetmask: cbData?.powerMeterData?.mask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                type: "Power Meter",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);

              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }
            // Adding PM data for Utility only for ANSI projects here
            if((isMgaasAnsi||isDaasAnsi ||isDaasEto ||isDaasIec)&&cbData?.assetType === embLabels.UTILITY&&cbData?.uiData.pmRequired){
            
              let cb = {};
              cb.assetId =
                cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter?.assetId;
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name;
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset ?? powerMeter
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.powerMeterData?.name || `PM_${cbData.assetType}`,
                description: cbData?.powerMeterData?.description || "",
                powerMeterModbusId:
                  cbData?.powerMeterData?.powerMeterModbusId || "",
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values

              let communications = {};

              communications = {
                ip: cbData?.powerMeterData?.ipAddress??defaultPreFillData?.[0]?.["Power Meter"]?.[`ipAddress_PM_${cbData?.assetType}`],
                subnetmask: cbData?.powerMeterData?.mask??defaultPreFillData?.[0]?.["Power Meter"]?.subnetMask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress??defaultPreFillData?.[0]?.["Power Meter"]?.defaultGateway,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId??defaultPreFillData?.[0]?.["Power Meter"]?.[`modbusId_PM_${cbData?.assetType}`],
                type: "Power Meter",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;
            }
            //*for grid_connected
            if ((isMgaasIecGrid||isMGaaSETOGrid || isMGaaSETOGensetPvHybrid)&&
                cbData?.assetType === embLabels.UTILITY
                && cbData?.uiData?.pmRequired
            ) {
            
              let cb = {};
              cb.assetId =
                cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter?.assetId;
              cb.userId = 1;
              cb.componentIdx = PMComponentIdx;
              cb.componentName = cbData?.powerMeterData?.name;
              cb.componentType = "Power Meter";
              cb.connections = [];
              cb.communications = [];
              cbData.uiData.assetInfo =  cbData?.powerMeterData?.pmAsset ?? powerMeter;
              cb.uiAttributes = JSON.stringify(cbData?.uiData);
              let connections = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };
              let attributes = {
                name: cbData?.powerMeterData?.name || `PM_${cbData?.assetType}`,
                description: cbData?.powerMeterData?.description || "",
                powerMeterModbusId:
                  cbData?.powerMeterData?.powerMeterModbusId || "",
              };
              cb.attributes = JSON.stringify(attributes);

              //*cb values

              let communications = {};

              communications = {
                ip: cbData?.powerMeterData?.ipAddress??defaultPreFillData?.[0]?.["Power Meter"]?.[`ipAddress_PM_${cbData?.assetType}`],
                subnetmask: cbData?.powerMeterData?.mask??defaultPreFillData?.[0]?.["Power Meter"]?.subnetMask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress??defaultPreFillData?.[0]?.["Power Meter"]?.defaultGateway,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId??defaultPreFillData?.[0]?.["Power Meter"]?.[`modbusId_PM_${cbData?.assetType}`],
                type: "Power Meter",
              };
              cb.connections.push(connections);
              cb.communications.push(communications);
              arrayComponent.push(cb);
              assetCB = assetCB + 10;

              //*cb values utility
            }
           
            if (
              (clientType === embLabels.A2E_PROJECT &&
                siteType === embLabels.GENSET_PVBESS_A2E &&
                cbData?.assetType === embLabels.GENSET) ||
              ((isMgaasAnsiIsland||projectKind?.isDaasIecIsland||isDaasAnsiIsland ||isDaasEtoIsland) &&
                cbData?.assetType === embLabels.GENSET&&
              cbData?.uiData.pmRequired)||
              (cbData?.assetType === embLabels.GENSET&&(isMgaasIecIsland ||  isMGaaSETOIsland || isMGaaSETOGensetPvHybrid)&&cbData.uiData.pmRequired)
            ) {
              let cbNew = {};
              cbNew.assetId = cbData?.powerMeterData?.pmAsset?.assetId;
              cbNew.userId = 1;
              cbNew.componentIdx = PMComponentIdx;
              cbNew.componentName = cbData?.powerMeterData?.name!==""?cbData?.powerMeterData?.name:defaultPreFillData?.[0]?.["Power Meter"]?.nameGenset;
              cbNew.componentType = "Power Meter";
              cbNew.communications = [];
              cbNew.connections = [];
              cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset;
              cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
              let attributesnew = {
                name: cbData?.powerMeterData?.name,
                description: cbData?.powerMeterData?.description,
                powerMeterModbusId: cbData?.powerMeterData?.powerMeterModbusId,
              };

              cbNew.attributes = JSON.stringify(attributesnew);
              let newConnection = {
                componentIdx: "ASSET_" + padNumberFormat(assetI),
                endpointIdX: "1",
                connectionType: "electrical_connection",
              };

              //* cb values

              // let communicationsnew = {
              //   ip: cbData?.powerMeterData?.ipAddress,
              //   subnetmask: cbData?.powerMeterData?.mask,
              //   defaultGateway: cbData?.powerMeterData?.gatewayAddress,
              //   modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
              //   type: "Power Meter",
              // };
              let communicationsnew  = {
                ip: cbData?.powerMeterData?.ipAddress??defaultPreFillData?.[0]?.["Power Meter"]?.[`ipAddress_PM_${cbData?.assetType}`],
                subnetmask: cbData?.powerMeterData?.mask??defaultPreFillData?.[0]?.["Power Meter"]?.subnetMask,
                defaultGateway: cbData?.powerMeterData?.gatewayAddress??defaultPreFillData?.[0]?.["Power Meter"]?.defaultGateway,
                modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId??defaultPreFillData?.[0]?.["Power Meter"]?.[`modbusId_PM_${cbData?.assetType}`],
                type: "Power Meter",
              };

              cbNew.communications.push(communicationsnew);
              cbNew.connections.push(newConnection);
              arrayComponent.push(cbNew);
            }

            assetI = assetI + 1;

            break;
          case embLabels.INVERTER:
            let connectionList = [];

            if (cbData?.pv === 1) {
              CBComponentIdx = "CB_40";
              CRComponentIdx = "Contactor_40";
              PMComponentIdx = "PM_40";
              PVDetails?.pvset1Data?.map((data, key) => {
                let asset = {};
                if (cbData?.assetType === embLabels.INVERTER) {
                  asset.componentType = "Inverter";
                }
                asset.userId = 1;
                asset.componentIdx = `ASSET_${padNumberFormat(assetI)}`;
                asset.componentName = PVDetails?.pvset1Data[key]?.name;
                asset.externalId = PVDetails?.pvset1Data[key]?.pvGsxExternalId
                  ? PVDetails?.pvset1Data[key]?.pvGsxExternalId
                  : gsxExternalId?.utilityExternalId;
                if (PVDetails?.pvset1Data?.[key]?.assetDetails?.[0] !== undefined) {
                  asset.assetId =
                    PVDetails?.pvset1Data[key]?.assetDetails[0]?.assetId;
                } else {
                  asset.assetId = 4;
                }

                asset.connections = [];
                asset.communications = [];
                cbData.uiData.pv = 1;
                cbData.uiData.groupName = PVDetails?.pvset1Data[key]?.groupName;
                cbData.uiData.configured = PVDetails?.pvset1Data[key]?.status;
                cbData.uiData.assetInfo = PVDetails?.pvset1Data[key]?.assetDetails[0];
                asset.uiAttributes = JSON.stringify(cbData?.uiData);
                const configured = cbData?.uiData?.configured === true;
                if(componentJson === null) return;
                componentJson.deploymentReady = !!componentJson.deploymentReady && configured;
                // componentJson.deploymentReady =
                //   componentJson?.deploymentReady && cbData?.uiData?.configured
                //     ? true
                //     : false;
                let assetConnections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                let assetAttributes = {
                  name: PVDetails?.pvset1Data[key]?.name,
                  description: PVDetails?.pvset1Data[key]?.description,
                  max_power: PVDetails?.pvset1Data[key]?.max_power,
                  groupName: PVDetails?.pvset1Data[key]?.groupName,
                  group_max_power: PVDetails?.pvset1Data[key]?.group_max_power,
                };
                asset.attributes = JSON.stringify(assetAttributes);

                if (
                  [
                    embLabels.ISLANDABLE,
                    embLabels.PV_HYBRIDIZATION,
                    embLabels.GRID_CONNECTED_GSX,
                    embLabels.GRID_CONNECTED,
                  ].includes(siteType) ||
                  architectureType === embLabels.PV_GENSET_ATS
                ) {
                  asset.connections.push(assetConnections);
                }

                //* no communication for hardwired

                let assetCommunications;

                if (
                  PVDetails?.pvset1Data?.[key]?.assetDetails.length &&
                  PVDetails?.pvset1Data?.[key]?.assetDetails[0].assetInfo ===
                    "Hardwired"
                ) {
                  assetCommunications = {};
                } else if (
                  PVDetails?.pvset1Data?.[key]?.assetDetails?.length &&
                  PVDetails?.pvset1Data?.[key]?.assetDetails?.[0]?.assetInfo ===
                    embLabels.SERIAL
                ) {
                  assetCommunications = {
                    ip: "",
                    subnetmask: "",
                    defaultGateway: "",
                    modbusSlaveId: PVDetails?.pvset1Data?.[key]?.modbusSlaveId,
                    type: "INVERTER",
                  };
                } else {
                  assetCommunications = {
                    ip: PVDetails?.defaultPVIpPreFillBackUp[key],
                    subnetmask: PVDetails?.pvset1Data?.[key]?.subnetmask,
                    defaultGateway: PVDetails?.pvset1Data?.[key]?.defaultGateway,
                    modbusSlaveId: PVDetails?.pvset1Data?.[key]?.modbusSlaveId,
                    type: "INVERTER",
                  };
                }
                asset.communications.push(assetCommunications);
                arrayComponent.push(asset);
                let connectionNew = {
                  componentIdx: `ASSET_${padNumberFormat(assetI)}`,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                connectionList.push(connectionNew);
                assetI = assetI + 1;
                return null;
              });

              if (
                siteType === embLabels.ISLANDABLE ||
                (siteType === embLabels.GRID_CONNECTED 
                  //  && cbData?.uiData?.cbRequired
                  )  ||
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR 
                  // &&cbData.uiData.cbRequired &&cbData?.uiData?.cbRequired
                  ) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS 
                  // &&cbData?.uiData?.cbRequired
                  ) ||
                siteType === embLabels.PV_HYBRIDIZATION
              ) {
                let cbNew = {};

                cbNew.assetId =
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CBComponentIdx;
                cbNew.componentName = cbData?.cbConfigData?.name;
                cbNew.componentType = "Circuit Breaker";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails[0];
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);

                let attributesnew = {
                  name: cbData?.cbConfigData?.name,
                  description: cbData?.cbConfigData?.description,
                  motorized: cbData?.cbConfigData?.motorized ? 1 : 0,
                  contactor: cbData?.cbConfigData?.contactor ? 1 : 0,
                  loadCategory: cbData?.cbConfigData?.loadCategory,
                  loadPriority: cbData?.cbConfigData?.loadPriority,
                  Contactor_healthy_status_available: 0,
                };
                if (
                  siteType === embLabels.GRID_CONNECTED &&
                  !cbData?.uiData?.cbRequired
                ) {
                  attributesnew.hardwired = cbData?.cbConfigData?.hardwired;
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  // cbData?.cbConfigData?.motorized &&
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                    "Hardwired"
                ) {
                  attributesnew.type = "12";
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData?.contactor
                ) {
                  attributesnew.type = "20";
                  attributesnew.Contactor_healthy_status_available=cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                }


                if(!cbData?.cbConfigData?.motorized&&!cbData?.uiData?.contactor){
                  attributesnew.type = "40"
                }
                if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                  attributesnew.type = "40";
                }
                if(isMgaasIecIsland  || isMGaaSETOIsland){
                if(cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo === "Hardwired"){
                  attributesnew.type = "12";
                }
                if (cbData?.uiData?.contactor) {
                  attributesnew.type = "20";
                  attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                }
                if(!cbData?.uiData?.contactor&&!cbData?.cbConfigData?.motorized){
                  attributesnew.type = "40"
                }
                if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                  attributesnew.type = "40";
                }
                }
                cbNew.attributes = JSON.stringify(attributesnew);
                // const communicationsnew = generateIfeValues("CB_40", cbData);
                let communicationsnew = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };

                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }

              if (
                [embLabels.ISLANDABLE,embLabels.GRID_CONNECTED].includes(siteType)  &&
                cbData?.uiData?.contactor&&!cbData.cbConfigData.motorized
              ) {
                let cbNew = {};

                cbNew.assetId =
                  cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CRComponentIdx;
                cbNew.componentName = cbData?.contactorConfigData?.name;
                cbNew.componentType = "Contactor";
                cbNew.connections = [];
                cbNew.communications = [];
                cbData.uiData.assetInfo =  cbData?.contactorConfigData.cbAssetDetails[0];
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);

                let connections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                let attributes = {
                  name: cbData?.contactorConfigData?.name,
                  description: cbData?.contactorConfigData?.description,
                  loadCategory: cbData?.contactorConfigData?.loadCategory,
                  loadPriority: cbData?.contactorConfigData?.loadPriority,
                };

                cbNew.attributes = JSON.stringify(attributes);

                cbNew.connections.push(connections);
                cbNew.communications.push({});

                arrayComponent.push(cbNew);
              }

              if (
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS) ||
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR &&
                  cbData?.uiData?.pmRequired) ||
                (siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData?.pmRequired) ||
                (siteType === embLabels.PV_HYBRIDIZATION &&
                  cbData?.uiData?.pmRequired) ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI" && cbData?.uiData?.pmRequired) ||
                (siteType === embLabels.ISLANDABLE &&
                  projectTypeValue === "MGaaS ANSI" &&  cbData?.uiData?.pmRequired) ||
                  ((projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland)&&cbData?.uiData?.pmRequired)
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.powerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = PMComponentIdx;
                cbNew.componentName = cbData?.powerMeterData?.name??defaultPreFillData?.[0]?.["Power Meter"]?.namePV;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                // cbNew.connections = [];
                cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset?? powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.powerMeterData?.name,
                  description: cbData?.powerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.powerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.powerMeterData?.ipAddress,
                  subnetmask: cbData?.powerMeterData?.mask,
                  defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                  modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                let connections = {
                  componentIdx: "ASSET_" + padNumberFormat(assetI),
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                // cbNew.connections.push(connections)
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }

              if (
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR &&
                  cbData?.uiData?.existingPmRequired) ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI" &&
                  cbData?.uiData?.existingPmRequired)||
                  ((projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland) &&cbData?.uiData?.existingPmRequired)
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.existingPowerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = "PM_51";
                cbNew.componentName = cbData?.existingPowerMeterData?.name;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo =  cbData?.existingPowerMeterData?.pmAsset?? powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.existingPowerMeterData?.name,
                  description: cbData?.existingPowerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.existingPowerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.existingPowerMeterData?.ipAddress,
                  subnetmask: cbData?.existingPowerMeterData?.mask,
                  defaultGateway:
                    cbData?.existingPowerMeterData?.gatewayAddress,
                  modbusSlaveId:
                    cbData?.existingPowerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }

              if (
                siteType === embLabels.ISLANDABLE_GSX &&
                architectureType === embLabels.PV_GENSET_ATS &&
                cbData?.uiData?.existingPmRequired
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.existingPowerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = "PM_51";
                cbNew.componentName = cbData?.existingPowerMeterData?.name;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo =  cbData?.existingPowerMeterData?.pmAsset ??  powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.existingPowerMeterData?.name,
                  description: cbData?.existingPowerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.existingPowerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.existingPowerMeterData?.ipAddress,
                  subnetmask: cbData?.existingPowerMeterData?.mask,
                  defaultGateway:
                    cbData?.existingPowerMeterData?.gatewayAddress,
                  modbusSlaveId:
                    cbData?.existingPowerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }
            } else if (cbData?.pv === 2) {
              CBComponentIdx = "CB_41";
              CRComponentIdx = "Contactor_41";
              PMComponentIdx = "PM_41";
              PVDetails?.pvset2Data?.map((data, key) => {
                let asset = {};
                if (cbData?.assetType === embLabels.INVERTER) {
                  asset.componentType = "Inverter";
                }
                asset.userId = 1;
                asset.componentIdx = "ASSET_" + padNumberFormat(assetI);
                asset.componentName = PVDetails?.pvset2Data[key]?.name;
                asset.externalId = PVDetails?.pvset2Data[key]?.pvGsxExternalId
                  ? PVDetails?.pvset2Data[key]?.pvGsxExternalId
                  : gsxExternalId?.utilityExternalId;
                if (PVDetails?.pvset2Data?.[key]?.assetDetails?.[0] !== undefined) {
                  asset.assetId =
                    PVDetails?.pvset2Data[key]?.assetDetails?.[0]?.assetId;
                } else {
                  asset.assetId = 4;
                }
                asset.connections = [];
                asset.communications = [];
                cbData.uiData.pv = 2;
                cbData.uiData.groupName = PVDetails?.pvset2Data[key]?.groupName;
                cbData.uiData.configured = PVDetails?.pvset2Data[key]?.status;
                cbData.uiData.assetInfo =  PVDetails?.pvset2Data[key]?.assetDetails[0];
                asset.uiAttributes = JSON.stringify(cbData?.uiData);
                componentJson.deploymentReady =
                  componentJson.deploymentReady && cbData?.uiData?.configured
                    ? true
                    : false;
                let assetConnections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                let assetAttributes = {
                  name: PVDetails?.pvset2Data[key]?.name,
                  description: PVDetails?.pvset2Data[key]?.description,
                  max_power: PVDetails?.pvset2Data[key]?.max_power,
                  groupName: PVDetails?.pvset2Data[key]?.groupName,
                  group_max_power: PVDetails?.pvset2Data[key]?.group_max_power,
                };
                asset.attributes = JSON.stringify(assetAttributes);
                if (
                  siteType === embLabels.ISLANDABLE ||
                  siteType === embLabels.PV_HYBRIDIZATION ||
                  siteType === embLabels.GRID_CONNECTED_GSX ||
                  siteType === embLabels.GRID_CONNECTED ||
                  (siteType === embLabels.ISLANDABLE_GSX &&
                    architectureType === embLabels.PV_GENSET_ATS &&
                    defaultPreFillData[1].mode === "FUEL_SAVER")
                ) {
                  asset.connections.push(assetConnections);
                }

                //* no communication for hardwired

                let assetCommunications;

                if (
                  PVDetails?.pvset2Data?.[key]?.assetDetails?.length &&
                  PVDetails?.pvset2Data?.[key]?.assetDetails?.[0]?.assetInfo ===
                    "Hardwired"
                ) {
                  assetCommunications = {};
                } else if(
                  PVDetails?.pvset2Data?.[key]?.assetDetails?.length &&
                  PVDetails?.pvset2Data?.[key]?.assetDetails?.[0]?.assetInfo === embLabels.SERIAL
                  ){
                    assetCommunications = {
                      ip: '',
                      subnetmask: "",
                      defaultGateway: "",
                      modbusSlaveId: PVDetails?.pvset2Data?.[key]?.modbusSlaveId,
                      type: "INVERTER",
                    };
                  }else {
                    let index = PVDetails?.pvset1Data?.length+key
                  assetCommunications = {
                    ip: PVDetails?.defaultPVIpPreFillBackUp?.[index],
                    subnetmask: PVDetails?.pvset2Data?.[key]?.subnetmask,
                    defaultGateway: PVDetails?.pvset2Data?.[key]?.defaultGateway,
                    modbusSlaveId: PVDetails?.pvset2Data?.[key]?.modbusSlaveId,
                    type: "INVERTER",
                  };
                }

                asset.communications.push(assetCommunications);
                arrayComponent.push(asset);
                let connectionNew = {
                  componentIdx: "ASSET_" + padNumberFormat(assetI),
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                connectionList.push(connectionNew);
                assetI = assetI + 1;
                return null;
              });
              //conncetion made for daas ansi

              if (
                siteType === embLabels.ISLANDABLE ||
                siteType === embLabels.PV_HYBRIDIZATION ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue !== "MGaaS ANSI") ||
                (siteType === embLabels.GRID_CONNECTED_GSX 
                  // &&cbData.uiData.cbRequired
                  ) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI")
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CBComponentIdx;
                cbNew.componentName = cbData?.cbConfigData?.name;
                cbNew.componentType = "Circuit Breaker";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo =  cbData?.cbConfigData?.cbAssetDetails[0];
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.cbConfigData?.name,
                  description: cbData?.cbConfigData?.description,
                  motorized: cbData?.cbConfigData.motorized ? 1 : 0,
                  contactor: cbData?.cbConfigData.contactor ? 1 : 0,
                  loadCategory: cbData?.cbConfigData?.loadCategory,
                  loadPriority: cbData?.cbConfigData?.loadPriority,
                  Contactor_healthy_status_available: 0,
                };
                if (
                  siteType === embLabels.GRID_CONNECTED &&
                  !cbData?.uiData.cbRequired
                ) {
                  attributesnew.hardwired = cbData?.cbConfigData?.hardwired;
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  // cbData?.cbConfigData?.motorized &&
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                    "Hardwired"
                ) {
                  attributesnew.type = "12";
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData?.contactor
                ) {
                  attributesnew.type = "20";
                  attributesnew.Contactor_healthy_status_available=cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                }
              
                if(!cbData?.cbConfigData?.motorized&&!cbData?.uiData?.contactor){
                  attributesnew.type = "40"
                }
                if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                  attributesnew.type = "40";
                }
                if(isMgaasIecIsland){
                  if(cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo === "Hardwired"){
                    attributesnew.type = "12";
                  }
                  if (cbData?.uiData?.contactor) {
                    attributesnew.type = "20";
                    attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                  }
                  if(!cbData?.uiData?.contactor&&!cbData?.cbConfigData?.motorized){
                    attributesnew.type = "40"
                  }
                  if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                    attributesnew.type = "40";
                  }
                  }
                cbNew.attributes = JSON.stringify(attributesnew);

                let communicationsnew = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };

                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }

              if (
                [embLabels.ISLANDABLE,embLabels.GRID_CONNECTED].includes(siteType)  &&
                cbData?.uiData?.contactor&&!cbData?.cbConfigData.motorized
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.contactorConfigData.cbAssetDetails[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CRComponentIdx;
                cbNew.componentName = cbData?.contactorConfigData?.name;
                cbNew.componentType = "Contactor";
                cbNew.connections = [];
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.contactorConfigData.cbAssetDetails[0];
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let connections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };

                let attributes = {
                  name: cbData?.contactorConfigData?.name,
                  description: cbData?.contactorConfigData?.description,
                  loadCategory: cbData?.contactorConfigData?.loadCategory,
                  loadPriority: cbData?.contactorConfigData?.loadPriority,
                };

                cbNew.attributes = JSON.stringify(attributes);

                //cbNew values
                let communications = {};

                cbNew.connections.push(connections);
                cbNew.communications.push(communications);
                arrayComponent.push(cbNew);
              }

              if (
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR &&
                  cbData?.uiData?.pmRequired) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
                (siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData?.pmRequired) ||
                  (siteType === embLabels.PV_HYBRIDIZATION &&
                    cbData?.uiData.pmRequired) ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI" &&  cbData?.uiData?.pmRequired) ||
                (siteType === embLabels.ISLANDABLE &&
                  projectTypeValue === "MGaaS ANSI" &&  cbData?.uiData?.pmRequired) ||
                  ((projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland)&&cbData?.uiData?.pmRequired)
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.powerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = PMComponentIdx;
                cbNew.componentName = cbData?.powerMeterData?.name??defaultPreFillData?.[0]?.["Power Meter"]?.namePV;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo =  cbData?.powerMeterData?.pmAsset ??powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.powerMeterData?.name,
                  description: cbData?.powerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.powerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.powerMeterData?.ipAddress,
                  subnetmask: cbData?.powerMeterData?.mask,
                  defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                  modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }
            } else if (cbData?.pv === 3) {
              CBComponentIdx = "CB_42";
              CRComponentIdx = "Contactor_42";
              PMComponentIdx = "PM_42";
              PVDetails?.pvset3Data?.map((data, key) => {
                let asset = {};
                if (cbData?.assetType === embLabels.INVERTER) {
                  asset.componentType = "Inverter";
                }
                asset.userId = 1;
                asset.componentIdx = "ASSET_" + padNumberFormat(assetI);
                asset.componentName = PVDetails?.pvset3Data?.[key]?.name;
                asset.externalId = PVDetails?.pvset3Data?.[key]?.pvGsxExternalId
                  ? PVDetails?.pvset3Data?.[key]?.pvGsxExternalId
                  : gsxExternalId?.utilityExternalId;
                if (PVDetails?.pvset3Data?.[key]?.assetDetails?.[0] !== undefined) {
                  asset.assetId =
                    PVDetails?.pvset3Data?.[key]?.assetDetails?.[0]?.assetId;
                } else {
                  asset.assetId = 4;
                }
                asset.connections = [];
                asset.communications = [];
                cbData.uiData.pv = 3;
                cbData.uiData.groupName = PVDetails?.pvset3Data?.[key]?.groupName;
                cbData.uiData.configured = PVDetails?.pvset3Data?.[key]?.status;
                cbData.uiData.assetInfo =  PVDetails?.pvset3Data?.[key]?.assetDetails[0];
                asset.uiAttributes = JSON.stringify(cbData?.uiData);
                componentJson.deploymentReady =
                  componentJson.deploymentReady && cbData?.uiData?.configured
                    ? true
                    : false;
                let assetConnections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                let assetAttributes = {
                  name: PVDetails?.pvset3Data?.[key]?.name,
                  description: PVDetails?.pvset3Data?.[key]?.description,
                  max_power: PVDetails?.pvset3Data?.[key]?.max_power,
                  groupName: PVDetails?.pvset3Data?.[key]?.groupName,
                  group_max_power: PVDetails?.pvset3Data?.[key]?.group_max_power,
                };
                asset.attributes = JSON.stringify(assetAttributes);

                // if (
                //   siteType === embLabels.ISLANDABLE ||
                //   siteType === embLabels.GRID_CONNECTED_GSX
                // ) {
                //   asset.connections.push(assetConnections);
                // }

                if (
                  siteType === embLabels.ISLANDABLE ||
                  siteType === embLabels.PV_HYBRIDIZATION ||
                  siteType === embLabels.GRID_CONNECTED_GSX ||
                  siteType === embLabels.GRID_CONNECTED ||
                  (siteType === embLabels.ISLANDABLE_GSX &&
                    architectureType === embLabels.PV_GENSET_ATS &&
                    defaultPreFillData[1].mode === "FUEL_SAVER")
                ) {
                  asset.connections.push(assetConnections);
                }
                //* no communication for hardwired

                let assetCommunications;

                if (
                  PVDetails?.pvset3Data[key].assetDetails.length &&
                  PVDetails?.pvset3Data[key].assetDetails[0].assetInfo ===
                    "Hardwired"
                ) {
                  assetCommunications = {};
                } else if(
                  PVDetails?.pvset3Data[key].assetDetails.length &&
                  PVDetails?.pvset3Data[key].assetDetails[0].assetInfo === embLabels.SERIAL
                  ){
                    assetCommunications = {
                      ip: '',
                      subnetmask: "",
                      defaultGateway: "",
                      modbusSlaveId: PVDetails?.pvset3Data[key].modbusSlaveId,
                      type: "INVERTER",
                    };
                  }else {
                    let index = PVDetails?.pvset1Data.length+PVDetails?.pvset2Data.length+key
                  assetCommunications = {
                    ip: PVDetails?.defaultPVIpPreFillBackUp?.[index],
                    subnetmask: PVDetails?.pvset3Data?.[key]?.subnetmask,
                    defaultGateway: PVDetails?.pvset3Data?.[key]?.defaultGateway,
                    modbusSlaveId: PVDetails?.pvset3Data?.[key]?.modbusSlaveId,
                    type: "INVERTER",
                  };
                }
                asset.communications.push(assetCommunications);
                arrayComponent.push(asset);
                let connectionNew = {
                  componentIdx: "ASSET_" + padNumberFormat(assetI),
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };
                connectionList.push(connectionNew);
                assetI = assetI + 1;
                return null;
              });

             
              if (
                siteType === embLabels.ISLANDABLE ||
                siteType === embLabels.PV_HYBRIDIZATION ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue !== "MGaaS ANSI") ||
                (siteType === embLabels.GRID_CONNECTED_GSX 
                  // &&cbData.uiData.cbRequired
                  ) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI")
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CBComponentIdx;
                cbNew.componentName = cbData?.cbConfigData?.name;
                cbNew.componentType = "Circuit Breaker";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails[0];
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.cbConfigData?.name,
                  description: cbData?.cbConfigData?.description,
                  motorized: cbData?.cbConfigData.motorized ? 1 : 0,
                  contactor: cbData?.cbConfigData.contactor ? 1 : 0,
                  loadCategory: cbData?.cbConfigData?.loadCategory,
                  loadPriority: cbData?.cbConfigData?.loadPriority,
                  Contactor_healthy_status_available: 0
                };
                if (
                  siteType === embLabels.GRID_CONNECTED &&
                  !cbData.uiData.cbRequired
                ) {
                  attributesnew.hardwired = cbData?.cbConfigData?.hardwired;
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  // cbData?.cbConfigData?.motorized &&
                  cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo ===
                    "Hardwired"
                ) {
                  attributesnew.type = "12";
                }
                if (
                  // siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData?.contactor
                ) {
                  attributesnew.type = "20";
                  attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                }
               
                if(!cbData?.cbConfigData?.motorized&&!cbData?.uiData?.contactor){
                  attributesnew.type = "40"
                }
                if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                  attributesnew.type = "40";
                }
                if(isMgaasIecIsland){
                  if(cbData?.cbConfigData?.cbAssetDetails[0]?.assetInfo === "Hardwired"){
                    attributesnew.type = "12";
                  }
                  if (cbData?.uiData?.contactor) {
                    attributesnew.type = "20";
                    attributesnew.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
                  }
                  if(!cbData?.uiData?.contactor&&!cbData?.cbConfigData?.motorized){
                    attributesnew.type = "40"
                  }
                  if (!(cbData?.assetType === embLabels.GENSET || cbData?.assetType === embLabels.UTILITY) && !cbData?.uiData?.cbRequired) {
                    attributesnew.type = "40";
                  }
                  }
                cbNew.attributes = JSON.stringify(attributesnew);

                let communicationsnew = {
                  ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                  subnetmask:
                    cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                  defaultGateway:
                    cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                  modbusSlaveId:
                    cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                  type: "Circuit Breaker",
                };

                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }
              if (
                [embLabels.ISLANDABLE,embLabels.GRID_CONNECTED].includes(siteType)  &&
                cbData?.uiData?.contactor&&!cbData?.cbConfigData.motorized
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CRComponentIdx;
                cbNew.componentName = cbData?.contactorConfigData?.name;
                cbNew.componentType = "Contactor";
                cbNew.connections = [];
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.contactorConfigData.cbAssetDetails[0];
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let connections = {
                  componentIdx: CBComponentIdx,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };

                let attributes = {
                  name: cbData?.contactorConfigData?.name,
                  description: cbData?.contactorConfigData?.description,
                  loadCategory: cbData?.contactorConfigData?.loadCategory,
                  loadPriority: cbData?.contactorConfigData?.loadPriority,
                };

                cbNew.attributes = JSON.stringify(attributes);

                //cbNew values
                let communications = {};

                cbNew.connections.push(connections);
                cbNew.communications.push(communications);
                arrayComponent.push(cbNew);
              }

              if (
                (siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR &&
                  cbData?.uiData.pmRequired) ||
                (siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  defaultPreFillData[1]?.mode === "FUEL_SAVER") ||
                (siteType === embLabels.GRID_CONNECTED &&
                  cbData?.uiData.pmRequired) ||
                  (siteType === embLabels.PV_HYBRIDIZATION &&
                    cbData?.uiData.pmRequired) ||
                (siteType === embLabels.GRID_CONNECTED &&
                  projectTypeValue === "MGaaS ANSI" &&  cbData?.uiData.pmRequired) ||
                (siteType === embLabels.ISLANDABLE &&
                  projectTypeValue === "MGaaS ANSI" &&  cbData?.uiData.pmRequired) ||
                  ((projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland)&&cbData?.uiData.pmRequired)
              ) {
                let cbNew = {};
                cbNew.assetId =
                  cbData?.powerMeterData?.pmAsset?.assetId ??
                  powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = PMComponentIdx;
                cbNew.componentName = cbData?.powerMeterData?.name??defaultPreFillData?.[0]?.["Power Meter"]?.namePV;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.powerMeterData?.name,
                  description: cbData?.powerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.powerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.powerMeterData?.ipAddress,
                  subnetmask: cbData?.powerMeterData?.mask,
                  defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                  modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
              }
            }

            break;

          default:
            break;
        }

      }
      return null;
    
    });

    //* load

    let loadCBI = 50;
    CBLoadList.map((cbData, key) => {
      // if(!cbData) return;
      let load = {};
      load.assetId = 6;
      load.userId = 1;
      let CRComponentIdx = `Contactor_${loadCBI}`
      load.componentIdx = `ASSET_${padNumberFormat(assetI)}`;
      load.componentName = cbData?.configData?.name;
      load.componentType = "Load";
      load.connections = [];
      load.communications = [];
      load.uiAttributes = JSON.stringify(cbData?.uiData);
      if (
        [
          embLabels.ISLANDABLE,
          embLabels.GRID_CONNECTED,
          embLabels.OFF_GRID,
          embLabels.GENSET_PVBESS_A2E,
        ].includes(siteType)
      ) {
        componentJson.deploymentReady =
          componentJson.deploymentReady && cbData?.uiData?.configured
            ? true
            : false;
      }
      if (
        siteType === embLabels.PV_HYBRIDIZATION ||
        architectureType === embLabels.PV_GENSET_ATS
      ) {
        componentJson.deploymentReady =
          componentJson.deploymentReady === true ? true : false;
      }

      let connectionsLoad = {
        componentIdx: "CB_" + loadCBI,
        endpointIdX: "1",
        connectionType: "electrical_connection",
      };
      let loadattributes = {
        name: cbData?.configData?.name,
        description: cbData?.configData?.description,
        maximum_available_power: cbData?.configData?.maximum_available_power,
      };
      load.attributes = JSON.stringify(loadattributes);

      if (
        siteType === embLabels.GRID_CONNECTED_GSX||
        siteType === embLabels.ISLANDABLE ||
        siteType === embLabels.GENSET_PVBESS_A2E ||
        siteType === embLabels.GRID_CONNECTED ||
        siteType === embLabels.PV_HYBRIDIZATION ||
        (siteType === embLabels.ISLANDABLE_GSX  &&
          defaultPreFillData[1].mode === "FUEL_SAVER")
      ) {
        load.connections.push(connectionsLoad);
      }

      arrayComponent.push(load);

      if(((siteType === embLabels.ISLANDABLE || (siteType === embLabels.GRID_CONNECTED && isExportOptimization)) && (projectTypeValue==="MGaaS IEC" || projectTypeValue === "MGaaS ETO")) && cbData?.uiData?.contactor){
        let cbNew = {};
                cbNew.assetId =
                  cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
                cbNew.userId = 1;
                cbNew.componentIdx = CRComponentIdx;
                cbNew.componentName = cbData?.contactorConfigData?.name;
                cbNew.componentType = "Contactor";
                cbNew.connections = [];
                cbNew.communications = [];
                
                // Create a shallow copy of uiData to avoid circular reference
                const uiDataForStringify = { ...cbData.uiData };
                // Only include serializable properties from assetInfo if needed
                if (cbData?.contactorConfigData?.cbAssetDetails?.[0]) {
                  const assetDetails = cbData?.contactorConfigData?.cbAssetDetails?.[0];
                  uiDataForStringify.assetInfo = {
                    assetId: assetDetails?.assetId,
                    assetName: assetDetails?.assetName,
                    manufacturer: assetDetails?.manufacturer,
                    communicationModel: assetDetails?.communicationModel,
                    assetInfo: assetDetails?.assetInfo
                  };
                }
                cbNew.uiAttributes = JSON.stringify(uiDataForStringify);
                let connections = {
                  componentIdx: "CB_" + loadCBI,
                  endpointIdX: "1",
                  connectionType: "electrical_connection",
                };

                let attributes = {
                  name: cbData?.contactorConfigData?.name,
                  description: cbData?.contactorConfigData?.description,
                  loadCategory: cbData?.contactorConfigData?.loadCategory,
                  loadPriority: cbData?.contactorConfigData?.loadPriority,
                };

                cbNew.attributes = JSON.stringify(attributes);

                //cbNew values
                let communications = {};

                cbNew.connections.push(connections);
                cbNew.communications.push(communications);
                arrayComponent.push(cbNew);
      }
      if (
        (siteType === embLabels.GRID_CONNECTED_GSX &&
         ( projectTypeValue === "DaaS ANSI" || projectTypeValue === "DaaS ETO" )) ||
        siteType === embLabels.ISLANDABLE ||
        (siteType === embLabels.ISLANDABLE_GSX &&
          defaultPreFillData[1].mode === "FUEL_SAVER") ||
        (siteType === embLabels.GRID_CONNECTED &&
          projectTypeValue === "MGaaS ANSI") ||
        (siteType === embLabels.GRID_CONNECTED || siteType === embLabels.PV_HYBRIDIZATION  &&
         ( projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO")) || isDaasIecGrid
      ) {
        let cb = {};

        cb.assetId = cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
        cb.userId = 1;
        cb.componentIdx = `CB_${loadCBI}`;
        cb.componentName = cbData?.cbConfigData?.name;
        cb.componentType = "Circuit Breaker";
        cb.connections = [];
        cb.communications = [];
        cbData.uiData.assetInfo =  cbData?.cbConfigData?.cbAssetDetails?.[0];
        cb.uiAttributes = JSON.stringify(cbData?.uiData);
        let connectionsCb = {
          componentIdx: "ASSET_" + padNumberFormat(assetI),
          endpointIdX: "1",
          connectionType: "electrical_connection",
        };

        //* copying cb values

        // let communications = {
        //   ip: cbData.cbConfigData?.cbCommunicationData?.ipaddress,
        //   subnetmask: cbData.cbConfigData?.cbCommunicationData?.subnetmask,
        //   defaultGateway:
        //     cbData.cbConfigData?.cbCommunicationData?.defaultGateway,
        //   modbusSlaveId:
        //     cbData.cbConfigData?.cbCommunicationData?.modbusSlaveId,
        //   type: "Circuit Breaker",
        // };
        let communications = {}
      if((!isExportOptimization && isMgaasIecGrid) || isDaasAnsiGrid || (!isExportOptimization && isDaasEtoGrid ) || (!isExportOptimization && isMgaasAnsiGrid )|| isDaasIecGrid || (!isExportOptimization &&isMGaaSETOGrid) || isMGaaSETOGensetPvHybrid){
        communications = {
            ip: "",
            subnetmask: "",
            defaultGateway:"",
            modbusSlaveId:"",
            type: "Circuit Breaker",
          };
        }else if(cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Hardwired"){
          communications = {
              ip: "",
              subnetmask: "",
              defaultGateway:"",
              modbusSlaveId:"",
              type: "Circuit Breaker",
            };
        }else{
          if((isMgaasIecIsland || isMGaaSETOIsland)&& cbData.uiData.cbRequired==false){
            communications = {
              ip: "",
              subnetmask: "",
              defaultGateway:"",
              modbusSlaveId:"",
              type: "Circuit Breaker",
            };
          }else{
          communications = {
            ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
            subnetmask: cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
            defaultGateway:
              cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
            modbusSlaveId:
              cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
            type: "Circuit Breaker",
            };
          }
        }
        let attributes = {
          name: cbData?.cbConfigData?.name,
          description: cbData?.cbConfigData?.description,
          motorized: cbData?.cbConfigData?.motorized ? 1 : 0,
          loadCategory: cbData?.cbConfigData?.loadCategory,
          loadPriority: cbData?.cbConfigData?.loadPriority,
        };
        if(cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Hardwired"){
          attributes.type = "12";
        }
        if (cbData?.uiData?.contactor) {
          attributes.type = "20";
          attributes.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value
        }
        if(!cbData?.uiData?.contactor&&!cbData?.cbConfigData?.motorized){
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        }
        if (!cbData?.uiData?.CBConfigured && (isDaasAnsiGrid ||isDaasEtoGrid || isDaasIecGrid)){
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        }if(((isMgaasAnsiGrid || isMGaaSETOGrid || isMgaasIecGrid) && isExportOptimization === false)){
           attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        }
        if(((isDaasAnsiGrid) && isExportOptimization === false)){
           attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        }
         if ( ( isExportOptimization === false && (!cbData?.uiData?.CBConfigured && (isMgaasAnsiGrid || isMGaaSETOGrid || isMgaasIecGrid)))) 
          {
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;
        }
        // if(((isMgaasAnsiGrid || isMGaaSETOGrid || isMgaasIecGrid) && isExportOptimization === true)){
        //   delete attributes.type ;
        // }
        if((isMgaasIecIsland || isMGaaSETOIsland || isMGaaSETOGensetPvHybrid)&& !cbData?.uiData?.cbRequired){
          attributes.type = "40";
          attributes.loadCategory = 0;
          attributes.loadPriority = 0;

        }
        cb.attributes = JSON.stringify(attributes);

        cb.connections.push(connectionsCb);
        cb.communications.push(communications);
        if((projectKind?.isMgaasIecIsland||projectKind?.isMgaasAnsiIsland||projectKind?.isDaasAnsiIsland ||projectKind?.isDaasEtoIsland)&&cbData?.uiData?.pmRequired){
          let connectionList = [{
            componentIdx: `ASSET_${padNumberFormat(assetI)}`,
            endpointIdX: "1",
            connectionType: "electrical_connection",
          }];
          let PMComponentIdx = `PM_${loadCBI}`
          let cbNew = {};
                cbNew.assetId = cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter?.assetId;
                cbNew.userId = 1;
                cbNew.componentIdx = PMComponentIdx;
                cbNew.componentName = cbData?.powerMeterData?.name??`PM_Load_${key+1}`;;
                cbNew.componentType = "Power Meter";
                cbNew.connections = connectionList;
                cbNew.communications = [];
                cbData.uiData.assetInfo =  cbData?.powerMeterData?.pmAsset;
                cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
                let attributesnew = {
                  name: cbData?.powerMeterData?.name,
                  description: cbData?.powerMeterData?.description,
                  powerMeterModbusId:
                    cbData?.powerMeterData?.powerMeterModbusId,
                };

                cbNew.attributes = JSON.stringify(attributesnew);

                //* cb values

                let communicationsnew = {
                  ip: cbData?.powerMeterData?.ipAddress,
                  subnetmask: cbData?.powerMeterData?.mask,
                  defaultGateway: cbData?.powerMeterData?.gatewayAddress,
                  modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId,
                  type: "Power Meter",
                };
                cbNew.communications.push(communicationsnew);
                arrayComponent.push(cbNew);
        }
        arrayComponent.push(cb);

        loadCBI = loadCBI + 1;

        //* skip 60 for ev
        if (loadCBI === 60) loadCBI = 61;
      }
      assetI = assetI + 1;

      return null;
    });

    //* ev

    let evCBI = 60;
    CBEVList?.map((cbData, key) => {
      if(!cbData) return;
      if (cbData?.uiData?.status) {
        let ev = {};
        if (cbData?.assetDetails?.length) {
          ev.assetId = cbData?.assetDetails?.[0]?.assetId;
        } else {
          ev.assetId = 5;
        }
        ev.userId = 1;
        ev.componentIdx = "ASSET_" + padNumberFormat(assetI);
        ev.componentName = cbData?.configData?.name;
        ev.componentType = "EV_charging_station";
        ev.connections = [];
        ev.communications = [];
        cbData.uiData.assetInfo = cbData?.assetDetails?.[0]
        ev.uiAttributes = JSON.stringify(cbData?.uiData);
        componentJson.deploymentReady =
          componentJson.deploymentReady && cbData?.uiData?.configured
            ? true
            : false;

        let connectionsEv = {
          componentIdx: "CB_" + evCBI,
          endpointIdX: "1",
          connectionType: "electrical_connection",
        };
        let evattributes = {
          name: cbData?.configData?.name,
          description: cbData?.configData?.description,
          maximum_available_power: cbData?.configData?.maximum_available_power,
        };
        ev.attributes = JSON.stringify(evattributes);

        if (siteType === embLabels.ISLANDABLE ||siteType === embLabels.GRID_CONNECTED) {
          ev.connections.push(connectionsEv);
        }

        if (cbData?.communicationData.ipaddress) {
          let evCommunications = {
            ip: cbData?.communicationData.ipaddress,
            subnetmask: cbData?.communicationData.subnetmask,
            defaultGateway: cbData?.communicationData.defaultGateway,
            modbusSlaveId: cbData?.communicationData.modbusSlaveId,
            type: "EV_charging_station",
          };
          ev.communications.push(evCommunications);
        }
        arrayComponent.push(ev);
        if (siteType === embLabels.ISLANDABLE||siteType===embLabels.GRID_CONNECTED) {
          let cb = {};
          cb.assetId = cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
          cb.userId = 1;
          if(cbData?.uiData?.cbRequired){
            cb.componentIdx = "CB_" + evCBI;
            cb.componentName = cbData?.cbConfigData?.name;
            cb.componentType = "Circuit Breaker";
            cb.connections = [];
            cb.communications = [];
            cbData.uiData.assetInfo = cbData?.cbConfigData?.cbAssetDetails?.[0];
            cb.uiAttributes = JSON.stringify(cbData?.uiData);
            let connectionsCb = {
              componentIdx: "ASSET_" + padNumberFormat(assetI),
              endpointIdX: "1",
              connectionType: "electrical_connection",
            };
            let communications = {}
            if(cbData?.uiData?.cbRequired&&cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo!=="Hardwired"){
               communications = {
                ip: cbData?.cbConfigData?.cbCommunicationData?.ipaddress,
                subnetmask: cbData?.cbConfigData?.cbCommunicationData?.subnetmask,
                defaultGateway:
                  cbData?.cbConfigData?.cbCommunicationData?.defaultGateway,
                modbusSlaveId:
                  cbData?.cbConfigData?.cbCommunicationData?.modbusSlaveId,
                type: "Circuit Breaker",
              };
            }else{
              communications = {
                ip: '',
                subnetmask: '',
                defaultGateway:'',
                modbusSlaveId:'',
                type: "Circuit Breaker",
              };
            }
            let attributes = {
              name: cbData?.cbConfigData?.name,
              description: cbData?.cbConfigData?.description,
              motorized: cbData?.cbConfigData?.motorized ? 1 : 0,
              loadCategory: cbData?.cbConfigData?.loadCategory,
              loadPriority: cbData?.cbConfigData?.loadPriority,
              Contactor_healthy_status_available: 0
            };
            if (cbData?.uiData?.contactor) {
              attributes.type = "20";
              attributes.Contactor_healthy_status_available = cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetAttributes?.[0]?.value;
            }
            if(cbData?.cbConfigData?.motorized&&cbData?.cbConfigData?.cbAssetDetails?.[0]?.assetInfo === "Hardwired"){
              attributes.type = "12";
            }
           if(!cbData?.cbConfigData?.motorized&&!cbData?.uiData?.contactor){
              attributes.type = "40";
              attributes.loadCategory = 0;
              attributes.loadPriority = 0;
            }
            cb.attributes = JSON.stringify(attributes);
  
            cb.connections.push(connectionsCb);
            cb.communications.push(communications);
            arrayComponent.push(cb);
          }
        }

        if (
          (siteType === embLabels.GRID_CONNECTED||siteType===embLabels.ISLANDABLE) &&
          cbData?.uiData?.pmRequired
        ) {
          let cb = {};
          cb.assetId =
            cbData?.powerMeterData?.pmAsset?.assetId ?? powerMeter?.assetId;
          cb.userId = 1;
          cb.componentIdx = "PM_60";
          cb.componentName = cbData?.powerMeterData?.name;
          cb.componentType = "Power Meter";
          cb.connections = [];
          cb.communications = [];
          cbData.uiData.assetInfo = cbData?.powerMeterData?.pmAsset ?? powerMeter
          cb.uiAttributes = JSON.stringify(cbData?.uiData);
          let connections = {
            componentIdx: "ASSET_" + padNumberFormat(assetI),
            endpointIdX: "1",
            connectionType: "electrical_connection",
          };
          let attributes = {
            name: cbData?.powerMeterData?.name || "PM_EV",
            description: cbData?.powerMeterData?.description || "",
            powerMeterModbusId:
              cbData?.powerMeterData?.powerMeterModbusId || "103",
          };
          cb.attributes = JSON.stringify(attributes);

          //*cb values

          let communications = {};
          communications = {
            ip: cbData?.powerMeterData?.ipAddress,
            subnetmask: cbData?.powerMeterData?.subnetMask,
            defaultGateway: cbData?.powerMeterData?.defaultGateway,
            modbusSlaveId: cbData?.powerMeterData?.powerMeterModbusId || "103",
            type: "Power Meter",
          };
          cb.connections.push(connections);
          cb.communications.push(communications);
          arrayComponent.push(cb);
          assetCB = assetCB + 10;
        }
      }
      if (
        (siteType === embLabels.GRID_CONNECTED||siteType===embLabels.ISLANDABLE) &&
        cbData?.uiData?.contactor&&!cbData?.cbConfigData?.motorized
      ) {
        let cbNew = {};
        cbNew.assetId =
          cbData?.contactorConfigData?.cbAssetDetails?.[0]?.assetId ?? 7;
        cbNew.userId = 1;
        cbNew.componentIdx = "Contactor_60";
        cbNew.componentName = cbData?.contactorConfigData?.name;
        cbNew.componentType = "Contactor";
        cbNew.connections = [];
        cbNew.communications = [];
        cbData.uiData.assetInfo = cbData?.contactorConfigData?.cbAssetDetails?.[0];
        cbNew.uiAttributes = JSON.stringify(cbData?.uiData);
        let connections = {
          componentIdx: "CB_60",
          endpointIdX: "1",
          connectionType: "electrical_connection",
        };
        let attributes = {
          name: cbData?.contactorConfigData?.name??"EV Contactor",
          description: cbData?.contactorConfigData?.description??"",
          loadCategory: cbData?.contactorConfigData?.loadCategory??0,
          loadPriority: cbData?.contactorConfigData?.loadPriority??0,
        };

        cbNew.attributes = JSON.stringify(attributes);

        //cbNew values
        let communications = {};

        cbNew.connections.push(connections);
        cbNew.communications.push(communications);
        arrayComponent.push(cbNew);
      }

      return null;
    });
   
    arrayComponent?.forEach((arrayComp) => {
      if(!arrayComp) return;
      if(DER.includes(arrayComp?.componentType)){
        if(JSON.parse(arrayComp?.uiAttributes).pmConfiguredGrid){
          let attr = JSON.parse(arrayComp?.attributes);
          if(!attr.pmPriority){
            prorityRules[arrayComp.componentType].pmPriority =JSON.parse(arrayComp?.uiAttributes).pmRequired? 1:0;
          attr = {
            ...attr,
            ...prorityRules[arrayComp?.componentType]
          }
          }
          
          arrayComp.attributes = JSON.stringify(attr);
        }
        if(JSON.parse(arrayComp?.uiAttributes).pmRequired === false){
          let attr = JSON.parse(arrayComp?.attributes);
        
            prorityRules[arrayComp.componentType].pmPriority =0;
            prorityRules[arrayComp.componentType].cbPriority =1;
              prorityRules[arrayComp.componentType].derPriority =arrayComp?.componentType === "Load" && !(JSON.parse(arrayComp?.uiAttributes)?.isRemoteLoad)?0:2;
          attr = {
            ...attr,
            ...prorityRules[arrayComp?.componentType]
        
          }
          
          arrayComp.attributes = JSON.stringify(attr);
        }
        
        if(JSON.parse(arrayComp?.uiAttributes).CBConfigured){
          let attr = JSON.parse(arrayComp?.attributes);
          if(!attr.CBPriority){
          prorityRules[arrayComp.componentType].cbPriority = JSON.parse(arrayComp?.uiAttributes).cbRequired?prorityRules[arrayComp.componentType].pmPriority  === 0?1:2:0
          attr = {
            ...attr,
            ...prorityRules[arrayComp?.componentType]
          }
          }
          arrayComp.attributes = JSON.stringify(attr);
        }
        if(JSON.parse(arrayComp?.uiAttributes).cbRequired === false){
          let attr = JSON.parse(arrayComp.attributes);
        
          prorityRules[arrayComp.componentType].pmPriority =1;
            prorityRules[arrayComp.componentType].cbPriority = 0;
            prorityRules[arrayComp.componentType].derPriority = 2;
          attr = {
            ...attr,
            ...prorityRules[arrayComp?.componentType]
          
          }
          arrayComp.attributes = JSON.stringify(attr);
        }
        if(JSON.parse(arrayComp?.uiAttributes).cbRequired === false && JSON.parse(arrayComp?.uiAttributes).pmRequired === false){
          let attr = JSON.parse(arrayComp.attributes);
        
            prorityRules[arrayComp.componentType].pmPriority =0;
            prorityRules[arrayComp.componentType].cbPriority = 0;
            prorityRules[arrayComp.componentType].derPriority = 1;

          attr = {
            ...attr,
            ...prorityRules[arrayComp?.componentType]
        
          }
          arrayComp.attributes = JSON.stringify(attr);
        }
        if(JSON.parse(arrayComp?.uiAttributes).derPriority === false && JSON.parse(arrayComp?.uiAttributes).pmRequired === false){
          let attr = JSON.parse(arrayComp?.attributes);
        
            prorityRules[arrayComp.componentType].pmPriority =0;
            prorityRules[arrayComp.componentType].cbPriority = 1;
            prorityRules[arrayComp.componentType].derPriority = 0;

          attr = {
            ...attr,
            ...prorityRules[arrayComp?.componentType]
        
          }
          arrayComp.attributes = JSON.stringify(attr);
        }
        if( arrayComp?.componentType ==="Load"  && JSON.parse(arrayComp?.uiAttributes).cbRequired === false && JSON.parse(arrayComp?.uiAttributes).pmRequired === false){
          let attr = JSON.parse(arrayComp.attributes);
        
            prorityRules[arrayComp.componentType].pmPriority =0;
            prorityRules[arrayComp.componentType].cbPriority = 0;
            prorityRules[arrayComp.componentType].derPriority = 0;

          attr = {
            ...attr,
            ...prorityRules[arrayComp?.componentType]
        
          }
          arrayComp.attributes = JSON.stringify(attr);
        }
      }
    })


    componentJson.components = assignIpAddress(arrayComponent,communicationState,CBAssetList,CBLoadList,CBEVList,assetDefaultValues)
    componentJson.diagramChangeRequired = false;
    componentJson.evceDiagramChangeRequired = false;
    if (UserScope.access.saveSLD === true) {
    const deploymentReadyState =   checkAssetStatus();
    componentJson.deploymentReady = deploymentReadyState;
    upDateCbcount( componentJson.components);
    setUpdateComponents(prev=>({
      ...prev,
      updateComponents:componentJson.components
    }));
    if(deploymentReadyState){
      sessionStorage.setItem("componentDataModified",false);
      updateComponentRemote(componentJson);
     
    }else if(firstTimeCall){
      const upDateJson = {...componentJson}
      if(projectKind?.isMgaasAnsi || projectKind?.isDaasAnsi || projectKind?.isDaasEto){
      componentJson.connectionType = "LOAD_SIDE";
      }
      updateComponentRemote(componentJson);
      setFirstTimecall(false);
      
    }else if(multipleLoads){
    componentJson.isAllowMultipleLoads = false;
    setMultipleLoads(false);
     updateComponentRemote(componentJson);
    }
    

    ComponentDataDispatch({
      type:ACTIONS.UPDATE_COMPONENT_DATA,
      payload:componentJson
    });
    //* update pv communication

    PVDetailsDispatch({
      type: ACTIONS.UPDATE_PV_COMMUNICATION_COMPONENT,
      payload: {
        components: componentJson.components,
        externalId: gsxExternalId.utilityExternalId,
        projectTypeValue,
      },
    });
      checkExportOptimizationCondition();
      sessionStorage.setItem("componentJsonData",JSON.stringify(componentJson));
      setCurrentProject((prevData)=>({
        ...prevData,
        componentData:componentJson
      }))
     
    };
  };

  const updateComponentRemote = (componentJson) => {
    if (isUpdatingComponent.current) {
      console.log("updateComponentRemote already in progress, skipping duplicate call");
      return;
    }
    isUpdatingComponent.current = true;
    setLoading(true);
    apiSession
      .updateComponents(componentJson)
      .then((json) => {
        setJsonData(json?.components)
        getCBDetails(json?.components);
        setSwitchboardType(json?.switchboardType);
        setIsEvce(json?.isElectricalVehicleEnergyManagement);
        setRemoteMain(json?.remoteMain);
        setLoadSide(json?.connectionType);
        setCurrentProject((prevData) => ({
          ...prevData,
          componentData:json?.components,
          timeSettingsValidated: json?.systemsTimeSyncPage,
          showUseCase: json?.deploymentReady,
          showSystems: !json?.programPage,
          showBOM: json?.systemsPage === false && json?.systemsTimeSyncPage === true && !json?.programPage,
          showDeploy: json?.systemsPage === false && json?.systemsTimeSyncPage === true && !json?.programPage,
        }));      
      ComponentDataDispatch({
          type:ACTIONS.UPDATE_COMPONENT_DATA,
          payload:json
        })
        projectKindDispatch({
          type: PROJECT_ACTION.UPDATE_PROJECT_KIND,
          payload: { ...json, projectTypeValue },
        });
        //* update pv communication

        PVDetailsDispatch({
          type: ACTIONS.UPDATE_PV_COMMUNICATION_COMPONENT,
          payload: {
            components: json?.components,
            externalId: gsxExternalId.utilityExternalId,
            projectTypeValue: projectTypeValue
          },
        });
        setUpdateComponents(prev=>({
          ...prev,
          updateComponents:json?.components
        }));
        setLoading(false);
        sessionStorage.setItem("programPage", true);
        sessionStorage.setItem("communicationValidated", json?.systemsPage);
        sessionStorage.setItem("componentDataModified",false);
        sessionStorage.setItem("assetEditStatus", `"",false`);
        setDuplicateUpdate({
          der: "",
          load: "",
          pv: "",
          ev: "",
        });
        if (defaultConfigurationStatus) {
          callSnackbar("success", embLabels.defaultConfigurationCreated);
          const defaultConfigurationStatusNew = false;
          setDefaultConfigurationStatus(defaultConfigurationStatusNew);
        } else {

          callSnackbar("success", embLabels.configurationUpdatedSuccess);
        }
        if (deleteOneDER) {
          sessionStorage.setItem("deploymentReady", false);
          setDeploymentReady("false");
          checkGensetDeleteOneDER(true);
        }
        isUpdatingComponent.current = false;
      })
      .catch((error) => {
        setLoading(false);
        if (error?.response) {
          if (error?.response?.status === 400) {
            if (duplicateUpdate.der !== "") {
              CBAssetListDispatch({
                type: ACTIONS.DUPLICATE_DER_UPDATE,
                payload: {
                  selectedAsset: duplicateUpdate.der,
                },
              });
            }
            if (duplicateUpdate.load !== "") {
              CBLoadListDispatch({
                type: ACTIONS.DUPLICATE_LOAD_UPDATE,
                payload: {
                  selectedLoad: duplicateUpdate.load,
                },
              });
            }
            if (duplicateUpdate.ev !== "") {
              CBEVListDispatch({
                type: ACTIONS.DUPLICATE_EV_UPDATE,
                payload: {
                  selectedEv: duplicateUpdate.ev,
                },
              });
            }
            if (duplicateUpdate.pv !== "") {
              PVDetailsDispatch({
                type: ACTIONS.DUPLICATE_PV_UPDATE,
              });
              PVDetailsDispatch({
                type: ACTIONS.PV_CONFIGURED_STATUS,
              });
            }
          }
          callSnackbar("error", error?.response?.data?.message);
        } else {
          callSnackbar("error", embLabels.errorInUpdatingConfiguration);
        }
        if (deleteOneDER) {
          sessionStorage.setItem("deploymentReady", false);
          setDeploymentReady("false");
          checkGensetDeleteOneDER(true);
        }
        isUpdatingComponent.current = false;
      });
  };

  const getCBDetails = (components) => {
    const CBIFEDETAILS = components?.filter(
      (component) =>
        component.communications.length &&
        component.componentType === "Circuit Breaker"
    );
    const CBDETAILS = CBIFEDETAILS.map((component) => ({
      [component?.componentIdx]: {
        ip: component?.communications?.[0]?.ip ??"",
        gateway: component?.communications?.[0]?.defaultGateway ??"",
        mask: component?.communications?.[0]?.subnetmask ??"",
        modbus: component?.communications?.[0]?.modbusSlaveId ??"",
        assetId: component?.asset?.assetId,
        numberOfDevicesIFE: component?.asset?.assetAttributes?.[0]?.value,
      },
    }));

    const CBVALUES = Object.assign({}, ...CBDETAILS);
    setCBValues(CBVALUES);
    const usedIps = CBIFEDETAILS.map(
      (cbdetail) => cbdetail.communications[0].ip
    );
    const usedIfeSet = CBIFEDETAILS.map((cbdetail) => [
      cbdetail.communications[0].ip,
      cbdetail.asset.assetAttributes[0].value,
    ]);
    const ifeIpSets = {};
    for (let [usedIp, maxValue] of usedIfeSet) {
      if (ifeIpSets[usedIp]) {
        ifeIpSets[usedIp][0] = ifeIpSets[usedIp][0] + 1;
      } else {
        ifeIpSets[usedIp] = [1, +maxValue];
      }
    }
    setCbCommunicationValues((prevState) => ({
      ...prevState,
      usedIps,
      ifeIpSets,
      availableIps: prevState?.allIps?.filter(
        (ifeIp) => !usedIps.includes(ifeIp)
      ),
    }));
  };

  const assignComponents = (component,contactor,isAllowMultipleLoads, isExportOptimization) => {
    let components = component?.components;
    let loadCBIndex = 0;
    let loadIndex = 0;
    let pvNo1 = 0;
    let pvNo2 = 0;
    let pvNo3 = 0;

    components?.sort((a, b) => a.componentIdx.localeCompare(b.componentIdx));

    //* update pv communication
    PVDetailsDispatch({
      type: ACTIONS.UPDATE_EMPTY_PVCOMMUNICATION,
      payload: {
        ["componentsData"]: components,
        projectTypeValue: projectTypeValue
      },
    });
    const loadPMIDArray = ["PM_50","PM_51","PM_52","PM_53","PM_54","PM_55","PM_56","PM_57","PM_58","PM_59"];
    const loadPMIDArray2 = ["PM_61","PM_62","PM_63","PM_64","PM_65","PM_66","PM_67","PM_68","PM_69","PM_70","PM_71","PM_72","PM_73","PM_74"]
    const loadContactorIDArray = ["Contactor_50","Contactor_51","Contactor_52","Contactor_53","Contactor_54","Contactor_55","Contactor_56","Contactor_57","Contactor_58","Contactor_59"];
    const LoadEMArray = ["CB_50","CB_51","CB_52","CB_53","CB_54","CB_55","CB_56","CB_57","CB_58","CB_59","CB_61","CB_62","CB_63","CB_64","CB_65","CB_66","CB_67","CB_68","CB_69","CB_70","CB_71","CB_72","CB_73","CB_74"]
    components?.map((componentsData) => {
      if(!componentsData) return;
      switch (componentsData?.componentType) {
        case embLabels.UTILITY:
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_UTILITY,
            payload: { componentsData: componentsData, projectTypeValue  },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          if (
            component.siteType === embLabels.ISLANDABLE_GSX ||
            component.siteType === embLabels.GRID_CONNECTED_GSX
          ) {
            setGsxExternalId((prevState) => ({
              ...prevState,
              utilityExternalId: componentsData.externalId
                ? componentsData.externalId
                : "",
            }));
          }
          break;

        case embLabels.GENSET:
          //default value for genset power, site is Access to Energy
          const assetAttributesNew = JSON.parse(componentsData?.attributes);
          if (
            component?.siteType === "GENSET_PVBESS_A2E" &&
            assetAttributesNew?.max_power === "1200"
          ) {
            assetAttributesNew.max_power = "130";
            componentsData.attributes = JSON.stringify(assetAttributesNew);
          }

          CBAssetListDispatch({
            type: ACTIONS.UPDATE_GENSET,
            payload: { componentsData: componentsData ,switchboardType:component?.switchboardType},
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          if (component.siteType === embLabels.ISLANDABLE_GSX) {
            setGsxExternalId((prevState) => ({
              ...prevState,
              gensetExternalId: componentsData.externalId
                ? componentsData.externalId
                : "",
            }));
          }
          break;

        case embLabels.BESS:
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_BESS,
            payload: {
              componentsData: componentsData,
              batteryCommunicationData,
              setBatteryCommunicationData,
              contactor,
              projectTypeValue
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          if (
            component.siteType === embLabels.GRID_CONNECTED_GSX ||
            component.siteType === embLabels.ISLANDABLE_GSX
          ) {
            setGsxExternalId((prevState) => ({
              ...prevState,
              batteryExternalId: componentsData.externalId
                ? componentsData.externalId
                : "",
            }));
          }
          break;

        case embLabels.INVERTER:
          const uiData = JSON.parse(componentsData.uiAttributes);

          PVDetailsDispatch({
            type: ACTIONS.UPDATE_PV_COMMUNICATION,
            payload: {
              componentsData: componentsData,
              projectTypeValue: projectTypeValue
            },
          });

          if (uiData.pv === 1) {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_PV,
              payload: {
                componentsData,
                pvArray: 3,
                projectTypeValue
              },
            });

            if (pvNo1 === 0) {
              countDispatch({
                type: ACTIONS.UPDATE_DER_COUNT,
                payload: { count: 1 },
              });
            }

            PVDetailsDispatch({
              type: ACTIONS.UPDATE_PVSET,
              payload: {
                componentsData,
                pvArray: 3,
              },
            });

            pvNo1++;
          } else if (uiData.pv === 2) {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_PV,
              payload: {
                componentsData,
                pvArray: 4,
              },
            });

            if (pvNo2 === 0) {
              countDispatch({
                type: ACTIONS.UPDATE_DER_COUNT,
                payload: { count: 1 },
              });
            }

            PVDetailsDispatch({
              type: ACTIONS.UPDATE_PVSET,
              payload: {
                componentsData,
                pvArray: 4,
              },
            });
            pvNo2++;
          } else if (uiData.pv === 3) {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_PV,
              payload: {
                componentsData,
                pvArray: 5,
              },
            });
            if (pvNo3 === 0) {
              countDispatch({
                type: ACTIONS.UPDATE_DER_COUNT,
                payload: { count: 1 },
              });
            }

            PVDetailsDispatch({
              type: ACTIONS.UPDATE_PVSET,
              payload: {
                componentsData,
                pvArray: 5,
              },
            });

            pvNo3++;
          }

          break;

        case embLabels.CHP:
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_CHP,
            payload: {
              componentsData: componentsData,
            },
          });

          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          break;

        case embLabels.HYBRID:
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_HYBRID,
            payload: {
              componentsData: componentsData,
            },
          });

          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });
          break;

        case embLabels.LOAD:
          const uiAttributes = JSON.parse(componentsData?.uiAttributes);
          if(uiAttributes.isRemoteLoad){
            countDispatch({
              type: ACTIONS.UPDATE_REMOTE_LOAD_COUNT,
              payload: { count: 1 },
            });
          }else{
            countDispatch({
              type: ACTIONS.UPDATE_LOAD_COUNT,
              payload: { count: 1 },
            });
          }
          CBLoadListDispatch({
            type: ACTIONS.UPDATE_LOAD,
            payload: { componentsData, loadIndex,siteType:component.siteType,projectTypeValue, isAllowMultipleLoads },
          });

          //   CBLoadListUpdated = newLoadData;
          loadIndex++;

          break;

        case embLabels.EV_CHARGING_STATION:
          if(component.evceDiagramChangeRequired){
            // nothing is doing
          }else{
              countDispatch({
            type: ACTIONS.UPDATE_EV_COUNT,
            payload: { count: 1 },
          });
          CBEVListDispatch({
            type: ACTIONS.UPDATE_EV,
            payload: {
              componentsData,
              evCommunicationData,
              setEvCommunicationData,
            },
          });
          }
          break;
        case embLabels.CIRCUIT_BREAKER:

          if (componentsData.componentIdx === "CB_10") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 0,
                projectTypeValue
              },
            });
          } else if (componentsData.componentIdx === "CB_20") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 1,
              },
            });
          } else if (componentsData.componentIdx === "CB_30") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 2,
              },
            });
          } else if (componentsData.componentIdx === "CB_80") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 6,
              },
            });
          } else if (componentsData.componentIdx === "CB_90") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 7,
              },
            });
          } else if (componentsData.componentIdx === "CB_40") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 3,
              },
            });
          } else if (componentsData.componentIdx === "CB_41") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 4,
              },
            });
          } else if (componentsData.componentIdx === "CB_42") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB,
              payload: {
                componentsData,
                value: 5,
              },
            });
          } else if (componentsData.componentIdx === "CB_60") {
            CBEVListDispatch({
              type: ACTIONS.UPDATE_EV_CB,
              payload: { componentsData },
            });
          }else if(LoadEMArray.includes(componentsData.componentIdx)){
            LoadEMArray.forEach((loadData,index)=>{
              if(loadData === componentsData.componentIdx ){
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_LOAD_CB,
                  payload: {
                     componentsData,
                     loadCBIndex:index,
                     siteType:component.siteType,
                     projectTypeValue,
                      contactor: contactor,
                      isExportOptimization:isExportOptimization ?? false
                    },
                });
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_EM_LOAD,
                  payload: {
                    componentsData,
                    value: index,
                    projectTypeValue: projectTypeValue
                  },
                });
                  
              }
            })
          } 
          else {
            // CBLoadListDispatch({
            //   type: ACTIONS.UPDATE_LOAD_CB,
            //   payload: { 
            //     componentsData, 
            //     loadCBIndex:15,
            //     siteType:component.siteType,
            //     projectTypeValue,
            //      contactor: contactor },
            // });
            // loadCBIndex += 1;
          }
          break;

        case embLabels.CONTACTOR:
          if (componentsData.componentIdx === "Contactor_30") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 2,
              },
            });
          }
          if (componentsData.componentIdx === "Contactor_40") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 3,
              },
            });
          }
          if (componentsData.componentIdx === "Contactor_41") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 4,
              },
            });
          }
          if (componentsData.componentIdx === "Contactor_42") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 5,
              },
            });
          }
          if (componentsData.componentIdx === "Contactor_60") {
            CBEVListDispatch({
              type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
              payload: {
                componentsData,
                value: 0,
              },
            });
          }
          if(loadContactorIDArray.includes(componentsData.componentIdx)){
            loadContactorIDArray.forEach((loadData,index)=>{
              if(loadData === componentsData.componentIdx){
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_DER_CB_CONTACTOR,
                  payload: {
                    componentsData,
                    value: index,
                  },
                });
              }
            })
          }
          break;

        case embLabels.POWER_METER:
          if (["PM_10", "CB_10"].includes(componentsData.componentIdx)) {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 0,
              },
            });
          } else if (componentsData.componentIdx === "PM_20") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 1,
              },
            });
          } else if (componentsData.componentIdx === "PM_40") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 3,
              },
            });
          } else if (componentsData.componentIdx === "PM_41") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 4,
              },
            });
          } else if (componentsData.componentIdx === "PM_42") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 5,
              },
            });
          } else if (componentsData.componentIdx === "PM_30") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 2,
              },
            });
          } else if (componentsData.componentIdx === "PM_80") {
            CBAssetListDispatch({
              type: ACTIONS.UPDATE_DER_PM,
              payload: {
                componentsData,
                value: 6,
              },
            });
          } else if (componentsData.componentIdx === "PM_60") {
            CBEVListDispatch({
              type: ACTIONS.UPDATE_EV_PM,
              payload: { componentsData },
            });
         } 
        //  else if (componentsData.componentIdx === "PM_50"&&!(component.siteType===embLabels.ISLANDABLE&& (projectTypeValue==="MGaaS IEC" || projectTypeValue === "MGaaS ETO"))) {
        //     CBAssetListDispatch({
        //       type: ACTIONS.UPDATE_DER_EXISTING_PM,
        //       payload: {
        //         componentsData,
        //         value: 0,
        //       },
        //     });
        //   }
           else if (["PM_50","PM_51","PM_52","PM_53","PM_54","PM_55","PM_56","PM_57","PM_58","PM_59"].includes(componentsData.componentIdx)&&([embLabels.ISLANDABLE,embLabels.ISLANDABLE_GSX].includes(component.siteType)&&["MGaaS ETO","MGaaS IEC","MGaaS ANSI","DaaS ANSI","DaaS ETO"].includes(projectTypeValue))) {
            let foundPM = false;
            for (let index = 0; index < loadPMIDArray.length; index++) {
              const item = loadPMIDArray[index];
              if (item === componentsData.componentIdx) {
                if(item === "PM_59"){
                  // debugger
                }
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_DER_EXISTING_PM,
                  payload: {
                    componentsData,
                    value: index,

                  },
                });
                foundPM = true;
                break; // Exit the loop once the condition is met
              }
            }
          }else if(["PM_61","PM_62","PM_63","PM_64","PM_65","PM_66","PM_67","PM_68","PM_69","PM_70","PM_71","PM_72","PM_73","PM_74"].includes(componentsData.componentIdx)&&([embLabels.ISLANDABLE,embLabels.ISLANDABLE_GSX].includes(component.siteType)&&["MGaaS ETO","MGaaS IEC","MGaaS ANSI","DaaS ANSI", "DaaS ETO"].includes(projectTypeValue))) {
             let foundPM = false;
            for (let index = 0; index < loadPMIDArray2.length; index++) {
              const item = loadPMIDArray2[index];
              if (item === componentsData.componentIdx) {
                if(item === "PM_59"){
                  // debugger
                }
                CBLoadListDispatch({
                  type: ACTIONS.UPDATE_DER_EXISTING_PM,
                  payload: {
                    componentsData,
                    value: index+10,

                  },
                });
                foundPM = true;
                break; // Exit the loop once the condition is met
              }
            }
          }
          //   else if (componentsData.componentIdx === "PM_51") {
          //   CBAssetListDispatch({
          //     type: ACTIONS.UPDATE_DER_EXISTING_PM,
          //     payload: {
          //       componentsData,
          //       value: 3,
          //     },
          //   });
          // }  
          else {
            // do nothing
          }

          break;

        default:
          break;
      }
      return null;
    });
    const runCalculateCoordinatesNew = { componentPush: false };
    setRunCalculateCoordinates(runCalculateCoordinatesNew);
    setSldLoadCompleted(true);
    setLoading(false);

  };

  const setAssetSelection = (assetName, cbDer) => {
    // setIsOpenLoadConfig(false);
    setCbder(cbDer);
    PVDetailsDispatch({
      type: ACTIONS.CLOSE_PVDISPLAY_CONTENT,
      payload: {
        selectSubPv: PVDetails?.selectSubPv,
        selectedPv: PVDetails?.selectedPv,
      }
    });

    const newAssetInfo = { ...assetInfo, assetSelected: true };
    setAssetInfo(newAssetInfo);
    getAssets(assetName);
  };

  const getAssets = (type) => {
    setAssetInfo((prevState) => ({ ...prevState, manufacturerLoading: true }));
    apiSession
      .getAssetsList(type, projectId)
      .then((json) => {
        const manufacturer = [];
        let standardTemplate = "";
        json.assetCatalogue[0].assetList.forEach((data) => {
          if (type === embLabels.GENERATOR) {
            if (data.manufacturer === "STANDARD GENSET TEMPLATE") {
              standardTemplate = data.manufacturer;
            } else {
              manufacturer.push(data.manufacturer);
            }
          } else if (type === embLabels.BESS) {
            if (data.manufacturer === "STANDARD BESS TEMPLATE") {
              standardTemplate = data.manufacturer;
            } else {
              manufacturer.push(data.manufacturer);
            }
          } else if (type === embLabels.PV_INVERTER) {
            if (data.manufacturer === "STANDARD PV INVERTER SUNSPEC TEMPLATE") {
              standardTemplate = data.manufacturer;
            } else {
              manufacturer.push(data.manufacturer);
            }
          } else {
            manufacturer.push(data.manufacturer);
          }
        });
        manufacturer.sort();

        if (standardTemplate !== "") {
          manufacturer.splice(0, 0, standardTemplate);
        }

        const modelType = [];
        json.assetCatalogue[0].assetList.forEach((data) => {
          if (modelType[data.manufacturer]) {
            modelType[data.manufacturer].push(data.communicationModel);
          } else {
            modelType[data.manufacturer] = [];
            modelType[data.manufacturer].push(data.communicationModel);
          }
          modelType[data.manufacturer].sort();
        });

        const uniqueManufactures = [...new Set(manufacturer)];

        const newAssetInfo = {
          ...assetInfo,
          assets: json.assetCatalogue[0].assetList,
          assetManufacturer: uniqueManufactures,
          assetModelType: modelType,
          manufacturerLoading: false,
          assetSelected: true,
        };
        setAssetInfo(newAssetInfo);
      })
      .catch(() => {
        setAssetInfo((prevState) => ({
          ...prevState,
          manufacturerLoading: false,
        }));
      });
  };

  const selectManufacturer = (e) => {
    const newAssetInfo = { ...assetInfo, selectedManufacturer: e.target.value };
    setAssetInfo(newAssetInfo);
  };

  const closeAssetSelectionBlock = () => {
    setAssetInfo((prevState) => ({
      ...prevState,
      assetSelected: false,
      selectedManufacturer: "",
    }));
  };

  const selectAssetFromList = (data) => {
    let selectedAsset = {};
    const assetDetailsData = { ...assetDetailsDisplay };
    setIsBessController(false);
    assetInfo.assets.forEach((assetData) => {
      if (parseInt(assetData.assetId) === parseInt(data)) {
        assetDetailsData.assetId = assetData.assetId;
        assetDetailsData.manufacturer = assetData.manufacturer;
        assetDetailsData.communicationModel = assetData.communicationModel;
        assetDetailsData.assetInfo = assetData.assetInfo;
        assetDetailsData.imageLink = assetData.imageLink;
        assetDetailsData.assetName = assetData.assetType;
        selectedAsset = assetData;
      }
    });
    CBAssetListDispatch({
      type: ACTIONS.SELECTED_ASSET,
      payload: {
        selectedAsset: selectedAsset,
      },
    });
    setAssetDetailsDisplay(assetDetailsData);

    setAssetInfo((prevState) => ({
      ...prevState,
      assetSelected: false,
      selectedManufacturer: "",
    }));
    const configDataNew = configData?.configData &&  { ...configData?.configData };
    const preFillDefault = defaultPreFillData?.[0];
    if(!configDataNew) return;
    switch (selectedAsset?.assetType) {
      //* GENSET

      case embLabels.GENERATOR:
        CBAssetListDispatch({
          type: ACTIONS.SELECT_DER_ASSET,
          payload: {
            index: 1,
            selectedAsset,
          },
        });
        if (selectedAsset?.assetAttributes?.length) {
          selectedAsset?.assetAttributes.forEach((data, index) => {
            switch (selectedAsset?.assetAttributes?.[index]?.type) {
              case "max_power":
                configDataNew.max_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "starting_timer":
                configDataNew.starting_timer =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "cooling_timer":
                configDataNew.cooling_timer =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "minimum_running_period":
                configDataNew.minimum_running_period =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              default:
                break;
            }
          });
          // CBAssetListDispatch({
          //   type:ACTIONS.ASSET_SELECTED_CONFIG,
          //   payload: {
          //     selectedAsset: selectedValues.selectedAsset,
          //     configData: configDataNew,
          //   },
          // });
        } else {
          configDataNew.max_power = defaultsMinMax?.maxPowerGensetDefault;
          configDataNew.min_power = "";
          configDataNew.gensetCO2 = defaultsMinMax?.gensetCO2Default;
          configDataNew.starting_timer = defaultsMinMax?.startUpGensetDefault;
          configDataNew.cooling_timer =
            defaultsMinMax?.coolingDurationGensetDefault;
          configDataNew.minimum_running_period =
            defaultsMinMax?.minRunningDurationGensetDefault;
        }
        if (selectedAsset?.assetInfo === embLabels.SERIAL) {
          const newModbusId =
            preFillDefault?.Generator?.ipAddress?.split(".")[3];
          CBAssetListDispatch({
            type: ACTIONS.SELECT_SERIAL_ASSET,
            payload: {
              index: 1,
              modbusSlaveId: newModbusId,
            },
          });
        } else if (
          CBAssetList?.[1].communicationData.ipaddress === "" &&
          selectedAsset?.assetInfo === embLabels.COMMUNICATING
        ) {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_COMMUNICATING_ASSET,
            payload: {
              index: 1,
              preFillDefault: preFillDefault?.Generator,
            },
          });
        }
        break;

      //* BESS

      case embLabels.BESS:
        CBAssetListDispatch({
          type: ACTIONS.SELECT_DER_ASSET,
          payload: {
            index: 2,
            selectedAsset,
          },
        });

        if (selectedAsset?.assetAttributes?.length) {
          configDataNew.isBoostPro = false;
          selectedAsset?.assetAttributes?.forEach((data, index) => {
            if(selectedAsset?.assetAttributes?.[index]?.type === "isMultiBess"){
              setIsBessController( selectedAsset?.assetAttributes?.[index]?.value)
            }
            switch (selectedAsset?.assetAttributes?.[index]?.type) {
              case "max_power":
                if (
                  selectedAsset?.assetAttributes?.[index]?.value?.includes("[")
                ) {
                  try {
                    configDataNew.max_power = JSON.parse(
                      selectedAsset?.assetAttributes?.[index]?.value
                    )?.[0];
                  } catch (error) {
                    configDataNew.max_power = "";
                  }
                } else {
                  configDataNew.max_power =
                    selectedAsset?.assetAttributes[index].value;
                  setBessControllerPrevValue(prev=>{
                    return{
                      ...prev,
                      max_power:selectedAsset?.assetAttributes?.[index]?.value
                    }
                  })
                }

                break;
              case "starting_timer":
                configDataNew.starting_timer =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "soc_max":
                configDataNew.soc_max =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "capacity":
                configDataNew.capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                  setBessControllerPrevValue(prev=>{
                    return{
                      ...prev,
                      capacity:selectedAsset?.assetAttributes?.[index]?.value
                    }
                  });
                break;
              case "soc_min":
                configDataNew.soc_min =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "soc_nominal_power":
                configDataNew.soc_nominal_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "SoC_fallback":
                configDataNew.SoC_fallback =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "usableStorageCapacityHr":
                configDataNew.storage_capacity_hr =
                  selectedAsset?.assetAttributes?.[index]?.value;

                break;
              case "usableStorageCapacity":
                configDataNew.corresponding_name_plate_capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "max_solar_power":
                configDataNew.max_solar_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "max_inverter_output_power":
                configDataNew.max_inverter_output_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "quantityOfBess":
                configDataNew.quantityOfBessList = JSON.parse( selectedAsset?.assetAttributes?.[index]?.value);
                   configDataNew.quantityOfBess =JSON.parse( selectedAsset?.assetAttributes?.[index]?.value)?.[0];
                break;
                case "Number_Of_BESS":
                configDataNew.quantityOfBessList = JSON.parse( selectedAsset?.assetAttributes?.[index]?.value);
                   configDataNew.quantityOfBess =JSON.parse( selectedAsset?.assetAttributes?.[index]?.value)?.[0];
                    configDataNew.isBoostPro = true;
                break;
              case "perUnitMaxPower":
                configDataNew.perUnitMaxPower = selectedAsset?.assetAttributes?.[index]?.value;
                if(selectedAsset?.assetAttributes?.[index]?.type === "isMultiBess"){
                  configDataNew.max_power = Number(configDataNew.quantityOfBess || 1) * Number(selectedAsset?.assetAttributes?.[index]?.value);

                }

                break;
              case "perUnitMaxEnergy":
                configDataNew.perUnitMaxEnergy = selectedAsset?.assetAttributes[index]?.value;
                if(selectedAsset?.assetAttributes?.[index]?.type === "isMultiBess"){
                  configDataNew.capacity = Number(configDataNew?.quantityOfBess || 1) * Number(selectedAsset?.assetAttributes?.[index]?.value)

                }
                break;
              default:
                break;
            }
          });
        } else {
          configDataNew.max_power = defaultsMinMax?.maxPowerBessDefault;
          configDataNew.starting_timer = "";
          configDataNew.capacity = 0;
          configDataNew.soc_max = defaultsMinMax?.socMaxDefault;
          configDataNew.soc_min = defaultsMinMax?.socMinDefault;
          configDataNew.soc_nominal_power = 60;
          configDataNew.SoC_fallback = 60;
        }

        if (selectedAsset?.assetInfo === embLabels.SERIAL) {
          const newModbusId = preFillDefault?.BESS?.ipAddress.split(".")[3];
          CBAssetListDispatch({
            type: ACTIONS.SELECT_SERIAL_ASSET,
            payload: {
              index: 2,
              modbusSlaveId: newModbusId,
            },
          });
        } else if (CBAssetList[2].communicationData.ipaddress === "") {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_COMMUNICATING_ASSET,
            payload: {
              index: 2,
              preFillDefault: preFillDefault?.BESS,
            },
          });
        }
        break;

      //* CHP

      case embLabels.CHP:
        CBAssetListDispatch({
          type: ACTIONS.SELECT_DER_ASSET,
          payload: {
            index: 6,
            selectedAsset,
          },
        });

        if (selectedAsset?.assetAttributes.length) {
          selectedAsset?.assetAttributes.forEach((data, index) => {
            switch (selectedAsset?.assetAttributes[index].type) {
              case "nominalPower":
                configDataNew.nominal_power =
                  selectedAsset?.assetAttributes[index].value;
                break;
              default:
                break;
            }
          });
        } else {
          configDataNew.nominal_power = defaultsMinMax?.chpNominalPowerMax;
        }

        break;

      //* Hybrid

      case embLabels.HYBRID:
        CBAssetListDispatch({
          type: ACTIONS.SELECT_DER_ASSET,
          payload: {
            index: 7,
            selectedAsset,
          },
        });

        if (selectedAsset?.assetAttributes?.length) {
          selectedAsset?.assetAttributes?.forEach((_, index) => {
            switch (selectedAsset?.assetAttributes[index].type) {
              case "max_capacity":
                configDataNew.max_capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                if (selectedAsset?.assetAttributes?.[index].value === "240") {
                  setBatteryRack("2");
                } else {
                  setBatteryRack("1");
                }
                break;
              case "capacity":
                configDataNew.capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "max_solar_power":
                configDataNew.max_solar_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "max_inverter_output_power":
                configDataNew.max_inverter_output_power =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;
              case "usableStorageCapacityHr":
                configDataNew.storage_capacity_hr =
                  selectedAsset?.assetAttributes?.[index]?.value;

                break;
              case "usableStorageCapacity":
                configDataNew.corresponding_name_plate_capacity =
                  selectedAsset?.assetAttributes?.[index]?.value;
                break;

              default:
                break;
            }
          });

          setDefaultComponentData((prevData) => ({
            ...prevData,
            defaultComponentData: selectedAsset,
          }));
          if(selectedAsset){
            setBatterySystemA2EConfig(prev=>{
              const hybridModels = selectedAsset?.assetAttributes?.find(
                (assetType) => assetType.type === "hybridModels"
              )?.value.split(",");
              const {storageCapacity, timeCapacity} = filterHybridModel(selectedAsset?.assetAttributes, hybridModels?.[0]);
              setConfigData((prevState) => ({
                ...prevState,
                configData:{ 
                  ...prevState.configData,
                  hybridModels:hybridModels,
                  namePlateEnergy:storageCapacity,
                  time_capacity:timeCapacity
                  },
              }));
              return {
                ...prev,
                model:hybridModels,
                namePlateEnergy:storageCapacity,
              }
            });
           
           
          }
        } else {
          configDataNew.max_capacity = 0;
          configDataNew.capacity = 0;
          configDataNew.max_solar_power = 0;
          configDataNew.max_inverter_output_power = 0;
          configDataNew.storage_capacity_hr = [];
          configDataNew.corresponding_name_plate_capacity = [];
        }

        if (
          +CBLoadList[0]?.configData?.maximum_available_power >
          +configDataNew?.max_inverter_output_power
        ) {
          CBLoadListDispatch({
            type: ACTIONS.DUPLICATE_LOAD_UPDATE,
            payload: {
              selectedLoad: 0,
            },
          });
        }

        CBAssetListDispatch({
          type: ACTIONS.DUPLICATE_DER_UPDATE,
          payload: {
            selectedAsset: 1,
          },
        });

        // if(CBLoadList[1].configData.
        //   max_power <
        //   ){
        //   CBAssetListDispatch({
        //     type: ACTIONS.DUPLICATE_DER_UPDATE,
        //     payload: {
        //       selectedAsset: 1,
        //     },
        //   });
        // }

        break;

      //* PV

      case embLabels.PV_inverter_assettype:
        // CBAssetListDispatch({
        //   type: ACTIONS.INDIVIDUAL_PV_ASSET_SELECT,
        //   payload: {
        //     selectedPv: PVDetails.selectedPv,
        //   },
        // });

        if (PVDetails?.selectedPv === 3) {
          PVDetailsDispatch({
            type: ACTIONS.UPDATE_PV_CONFIG,
            payload: {
              selectedAsset,
              selectedPv: 3,
              defaultsMinMax: defaultsMinMax,
            },
          });
        }
        if (PVDetails?.selectedPv === 4) {
          PVDetailsDispatch({
            type: ACTIONS.UPDATE_PV_CONFIG,
            payload: {
              selectedAsset,
              selectedPv: 4,
              defaultsMinMax: defaultsMinMax,
            },
          });
        }
        if (PVDetails?.selectedPv === 5) {
          PVDetailsDispatch({
            type: ACTIONS.UPDATE_PV_CONFIG,
            payload: {
              selectedAsset,
              selectedPv: 5,
              defaultsMinMax: defaultsMinMax,
            },
          });
        }

        //     this.onChangePvSubSelection(this.state.selectSubPv);
        break;

      //* ev

      case embLabels.EV_CHARGING_STATION:
        CBEVListDispatch({
          type: ACTIONS.SELECT_EV_ASSET,
          payload: {
            index: selectedValues?.selectedEv,
            selectedAsset,
          },
        });

        if (selectedAsset?.assetAttributes?.length) {
          selectedAsset?.assetAttributes?.forEach((attribute) => {
            switch (attribute.type) {
              case "max_power":
                configDataNew.maximum_available_power = attribute.value;
                break;
              default:
                break;
            }
          });
        } else {
          configDataNew.maximum_available_power = 10;
        }

        if (selectedAsset?.assetInfo === embLabels.SERIAL) {
          const newModbusId =
            preFillDefault?.EV_charging_station?.ipAddress?.split(".")[3];

          CBEVListDispatch({
            type: ACTIONS.SELECT_SERIAL_ASSET,
            payload: {
              index: selectedValues?.selectedEv,
              modbusSlaveId: newModbusId,
            },
          });
        } else if (
          CBEVList?.[selectedValues?.selectedEv]?.communicationData?.ipaddress === ""
        ) {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_COMMUNICATING_ASSET,
            payload: {
              index: selectedValues?.selectedEv,
              preFillDefault: preFillDefault?.EV_charging_station,
            },
          });
        }

        break;

      case embLabels.CIRCUIT_BREAKER:
        if (CBAssetList?.some((cbasset) => cbasset.uiData.CBSelected)) {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_DER_CBASSET,
            payload: {
              index: selectedValues?.selectedAssetCB,
              selectedAsset,
              cbCommunicationValues,
              CBValues,
              defaultValues: defaultPreFillData?.[0],
              count,
              switchboardType,
            projectTypeValue
            },
          });
        }

        if (CBLoadList?.some((cbload) => cbload.uiData.CBSelected)) {
          CBLoadListDispatch({
            type: ACTIONS.SELECT_LOAD_CBASSET,
            payload: {
              index: selectedValues?.selectedLoadCB,
              selectedAsset,
              cbCommunicationValues,
              defaultValues: defaultPreFillData?.[0],
              count,
              siteType,
              projectTypeValue
            },
          });
         
        }
        if (CBEVList?.some((cbev) => cbev.uiData.CBSelected)) {
          CBEVListDispatch({
            type: ACTIONS.SELECT_EV_CBASSET,
            payload: {
              index: selectedValues?.selectedEvCB,
              selectedAsset,
              cbCommunicationValues,
            },
          });         
        }
        break;

      case embLabels.CONTACTOR:
        if (CBAssetList?.some((cbasset) => cbasset.uiData.CBSelected)) {
          CBAssetListDispatch({
            type: ACTIONS.SELECT_DER_CB_CONTACTOR_ASSET,
            payload: {
              index: selectedValues?.selectedAssetCB,
              selectedAsset,
            },
          });
        }
        if (CBEVList?.some((cbev) => cbev.uiData.CBSelected)) {
          CBEVListDispatch({
            type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG,
            payload: {
              index: selectedValues?.selectedEvCB,
              selectedAsset: selectedAsset,
            },
          });
        }
        if(CBLoadList?.some((cbload) => cbload.uiData.CBSelected)){
          CBLoadListDispatch({
            type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG,
            payload: {
              index: selectedValues?.selectedLoadCB,
              selectedAsset: selectedAsset,
            },
          });
        }

        break;

      case embLabels.POWER_METER:
        if (
          CBAssetList?.some(
            (cbasset) =>
              cbasset.uiData.pmSelected || cbasset.uiData.existingPmSelected
          )
        ) {
          if (detailsBlock?.existingPmAssetDetailsBlockGrid) {
            CBAssetListDispatch({
              type: ACTIONS.SELECT_DER_EXISTING_PMASSET,
              payload: {
                index: selectedValues?.selectedAssetPM,
                selectedAsset,
                defaultValues: defaultPreFillData?.[0],
                existingPMBlock: detailsBlock.existingPmAssetDetailsBlockGrid,
              },
            });
          } else {
            CBAssetListDispatch({
              type: ACTIONS.SELECT_DER_PMASSET,
              payload: {
                index: selectedValues?.selectedAssetPM,
                selectedAsset,
                defaultValues: defaultPreFillData?.[0],
              },
            });
          }
        }
        if (CBEVList?.some((cbev) => cbev.uiData.pmSelected)) {
          CBEVListDispatch({
            type: ACTIONS.SELECT_EV_PMASSET,
            payload: {
              index: selectedValues?.selectedEvPM,
              selectedAsset,
              preFillDefault: preFillDefault?.["Power Meter"],
            },
          });
        }
        if(CBLoadList?.some((cbLoad) => cbLoad.uiData.pmSelected)){
          CBLoadListDispatch({
            type: ACTIONS.SELECT_LOAD_PMASSET,
            payload: {
              index: selectedValues?.selectedLoad ===""?selectedValues?.selectedLoadPM:selectedValues?.selectedLoad,
              selectedAsset,
              preFillDefault: preFillDefault?.["Power Meter"],
            },
          })
        }
        break;
      default:
        break;
    }

    const cbCofigDataNew = {
      ...configData?.cbConfigData,
    };
    if (
      [embLabels.GRID_CONNECTED,embLabels.ISLANDABLE].includes(siteType) &&
      clientType === embLabels.GENERIC_PROJECT &&
      selectedAsset?.assetType === embLabels.CIRCUIT_BREAKER &&
      (projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO") &&
      (selectedAsset?.assetInfo === "Serial" ||
        selectedAsset?.assetInfo === "Communicating")
    ) {
      cbCofigDataNew.motorized = true;
    }

    setConfigData((prevState) => ({
      ...prevState,
      configData: configDataNew,
      cbConfigData: cbCofigDataNew,
    }));
    // if (siteType === "GENSET_PVBESS_A2E") {
    //   setBatterySystemA2EConfig(prev=>{
    //     return {
    //       ...prev,
    //       namePlateEnergy:JSON.parse(configDataNew.storage_capacity_hr)[0],
    //     }
    //   }
    //   );
    //   configDataNew["corresponding_name_plate_capacity_value"] = JSON.parse(
    //     configDataNew.corresponding_name_plate_capacity
    //   )["1.1"];
    //   setConfigData((prevState) => ({
    //     ...prevState,
    //     configData: configDataNew,
    //   }));
    // }

    sessionStorage.setItem("deploymentReady", false);
    setDeploymentReady("false");
    sessionStorage.setItem("componentDataModified", true);
    setIsAssetConfigChanged(configData);
  };

  const assetDetailsReset = () => {
    CBAssetListDispatch({
      type: ACTIONS.CLOSEDETAILS_ASSET,
    });
    CBLoadListDispatch({
      type: ACTIONS.CLOSEDETAILS_LOAD,
    });
    CBEVListDispatch({
      type: ACTIONS.CLOSEDETAILS_EV,
    });
    const newAssetDetails = { ...detailsBlock };
    Object.keys(newAssetDetails).forEach(
      (block) => (newAssetDetails[block] = false)
    );
    const configData = {
      name: "",
      description: "",
      min_power: "",
      max_power: "",
    };
    const cbConfigData = {
      name: "",
      description: "",
    };
    const contactorConfigData = {
      name: "",
      description: "",
    };
    const newAssetDetailsDisplay = { ...assetDetailsDisplay };
    Object.keys(newAssetDetailsDisplay).forEach(
      (details) => (newAssetDetailsDisplay[details] = "")
    );
    setDetailsBlock(newAssetDetails);
    setConfigData((prevState) => ({
      ...prevState,
      configData,
      cbConfigData,
      contactorConfigData,
    }));
    setAssetDetailsDisplay(newAssetDetailsDisplay);
  };

  const selectedValuesHandler = (
    index,
    selectedAssetValue,
    selectedAssetBlcok
  ) => {
    setConsiderSelected(true);
    const newSelectedValuess = { ...selectedValues };
    Object.keys(newSelectedValuess).forEach(
      (block) => (newSelectedValuess[block] = "")
    );

    if (selectedAssetBlcok !== "hardWiredCbDetailsBlockGrid") {
      setSelectedValues({
        ...newSelectedValuess,
        [selectedAssetValue]: index,
      });
    }
    if (selectedAssetBlcok === "loadDetailsBlock") {
      setSelectedValues({
        ...newSelectedValuess,
        ["selectedLoadCB"]: index,
        ["selectedLoad"]:index,
      });
    }
    setDetailsBlock((prevState) => ({
      ...prevState,
      [selectedAssetBlcok]: true,
    }));
  };

  const selectedSubPvHandler = (index) =>
    setSelectedValues((prevState) => ({
      ...prevState,
      selectSubPv: index,
    }));

  const selectedAssetHandler = (type, index) => {
    let assetArrayIn;
    switch (type) {
      case embLabels.ASSETS:
        assetArrayIn = [...CBAssetList];
        break;
      case embLabels.EV_CHARGING_STATION:
        assetArrayIn = [...CBEVList];
        break;
      default:
        break;
    }

    const assetDetailsData = { ...assetDetailsDisplay };
    if (assetArrayIn?.[index]?.assetDetails !== undefined) {
      if (assetArrayIn?.[index]?.assetDetails?.length) {
        assetDetailsData.assetId =
          assetArrayIn[index]?.assetDetails[0]?.assetId;
        assetDetailsData.manufacturer =
          assetArrayIn[index]?.assetDetails[0]?.manufacturer;
        assetDetailsData.communicationModel =
          assetArrayIn[index]?.assetDetails[0]?.communicationModel;
        assetDetailsData.assetInfo =
          assetArrayIn[index]?.assetDetails[0]?.assetInfo;
        assetDetailsData.assetName =
          assetArrayIn[index]?.assetDetails[0]?.assetName;
        assetDetailsData.imageLink =
          assetArrayIn[index]?.assetDetails[0]?.imageLink;
        setAssetDetailsDisplay(assetDetailsData);
      } else {
        const newAssetDetailsDisplay = { ...assetDetailsDisplay };
        Object.keys(newAssetDetailsDisplay).forEach(
          (details) => (newAssetDetailsDisplay[details] = "")
        );
        setAssetDetailsDisplay(newAssetDetailsDisplay);
      }
    }
  };

  const selectedAssetHandlerPv = (selectedPv, selectSubPv) => {
    let indexValue = parseInt(selectSubPv - 1);
    let newPvSubData = [];

    switch (selectedPv) {
      case 3:
        newPvSubData = [...PVDetails?.pvset1Data];
        break;
      case 4:
        newPvSubData = [...PVDetails?.pvset2Data];
        break;
      case 5:
        newPvSubData = [...PVDetails?.pvset3Data];
        break;
      default:
        break;
    }

    const assetDetailsData = { ...assetDetailsDisplay };

    if (newPvSubData[indexValue]?.assetDetails !== undefined) {
      if (newPvSubData[indexValue]?.assetDetails?.length) {
        assetDetailsData.assetId =
          newPvSubData[indexValue]?.assetDetails[0]?.assetId;
        assetDetailsData.manufacturer =
          newPvSubData[indexValue]?.assetDetails[0]?.manufacturer;
        assetDetailsData.communicationModel =
          newPvSubData[indexValue]?.assetDetails[0]?.communicationModel;
        assetDetailsData.assetInfo =
          newPvSubData[indexValue]?.assetDetails[0]?.assetInfo;
        assetDetailsData.assetName =
          newPvSubData[indexValue]?.assetDetails[0]?.assetName;
        assetDetailsData.imageLink =
          newPvSubData[indexValue]?.assetDetails[0]?.imageLink;
        setAssetDetailsDisplay(assetDetailsData);
      } else {
        const newAssetDetailsDisplay = { ...assetDetailsDisplay };
        Object.keys(newAssetDetailsDisplay).forEach(
          (details) => (newAssetDetailsDisplay[details] = "")
        );
        setAssetDetailsDisplay(newAssetDetailsDisplay);
      }
    }
   
  };
const loadSelectHandler = () => {
  setSelectedLoadIndx(null);
  assetDetailsReset();
  setDetailsBlock(prev=>({
    ...prev,
    loadDetailsBlock:true,
  }))
  };
  //* GET CONFIG DATA

  const assetConfigDataHandler = (index) => {
    const CBASSETLISTNEW = _.cloneDeep(CBAssetList);
    const defaultsData = {};
    for (let defaultData of defaultPreFillData[2]) {
      defaultsData[defaultData["param"]] = defaultData["value"];
    }

    if (CBASSETLISTNEW[index]?.configData?.name) {
      let assetConfigDataNew = {};
      assetConfigDataNew = CBASSETLISTNEW[index]?.configData;
      if (CBASSETLISTNEW[index]?.assetType === embLabels.UTILITY) {
        assetConfigDataNew = Object.assign({}, configData?.utilityConfigData);
        assetConfigDataNew = {
          ...CBASSETLISTNEW[index]?.configData,

        }
        assetConfigDataHandler.maximum_available_power = 300;

      } else if (CBASSETLISTNEW[index]?.assetType === embLabels.GENSET) {
        assetConfigDataNew = Object.assign({}, configData?.gensetConfigData);
        // assetConfigDataNew.max_power = defaultsData.maxPowerGensetDefault;
        assetConfigDataNew = {
          ...CBASSETLISTNEW[index]?.configData,

        }
      } else if (CBASSETLISTNEW[index]?.assetType === embLabels.BESS) {
        assetConfigDataNew = Object.assign({}, configData?.batteryConfigData);
        assetConfigDataNew = {
          ...CBASSETLISTNEW[index]?.configData,

        }
        assetConfigDataNew.soc_max = assetConfigDataNew.soc_max ?? defaultPreFillData[0]?.BESS?.soc_max;
        assetConfigDataNew.soc_min = assetConfigDataNew.soc_min ?? defaultPreFillData[0]?.BESS?.soc_min;
        assetConfigDataNew.SoC_min_optimization = assetConfigDataNew.SoC_min_optimization ?? defaultsData?.socMinOptimizationDefault;
        assetConfigDataNew.soc_nominal_power = CBASSETLISTNEW[index]?.configData?.soc_nominal_power ?? defaultsData?.socNominalDefault;
        assetConfigDataNew.SoC_fallback = assetConfigDataNew?.SoC_fallback ?? defaultsData?.SoC_fallback;

      } else if (CBASSETLISTNEW[index].assetType === embLabels.CHP) {
        assetConfigDataNew = Object.assign({}, configData?.chpConfigData);
        assetConfigDataNew = {
          ...CBASSETLISTNEW[index]?.configData,

        }
      } else if (CBASSETLISTNEW[index].assetType === embLabels.HYBRID) {
        assetConfigDataNew = Object.assign({}, configData?.hybridConfigData);
        assetConfigDataNew = {
          ...CBASSETLISTNEW[index]?.configData,

        }
      } else {
        assetConfigDataNew = Object.assign({}, configData?.sampleConfigData);
        assetConfigDataNew = {
          ...CBASSETLISTNEW[index]?.configData,

        }
      }

      
      assetConfigDataNew.name = CBASSETLISTNEW[index]?.configData?.name;
      assetConfigDataNew.description =
        CBASSETLISTNEW[index]?.configData?.description;
      // assetConfigDataNew.max_power=CBASSETLISTNEW[1].
      if (CBASSETLISTNEW[index]?.assetType === embLabels.GENSET) {
        CBASSETLISTNEW[1]?.selectedAssetData?.assetAttributes &&
          CBASSETLISTNEW[1]?.selectedAssetData?.assetAttributes.forEach(
            (assetAttribute) => {
              if (assetAttribute?.type === "gensetPower") {
                assetConfigDataNew.max_power = assetAttribute?.value;
              }
            }
          );
        // assetConfigDataNew.max_power = defaultsData.maxPowerGensetDefault;
      }
      // assetConfigDataNew.max_power =
      //   CBASSETLISTNEW[index].configData.maximum_available_power ||
      //   CBASSETLISTNEW[index].configData.max_power;
      // if (CBASSETLISTNEW[index].assetType === embLabels.BESS){
      //   assetConfigDataNew.capacity = CBAssetList[index].assetDetails[0]?.assetAttributes.find(
      //     attribute => attribute.type === "capacity"
      //   )?.value;
      //   assetConfigDataNew.max_power =  CBAssetList[index].assetDetails[0]?.assetAttributes.find(
      //     attribute => attribute.type === "power_max"
      //   )?.value;
      // }
      // if (CBASSETLISTNEW[index].assetType === embLabels.GENSET){
      //   assetConfigDataNew.max_power =  CBAssetList[index].assetDetails[0]?.assetAttributes.find(
      //     attribute => attribute.type === "min_power"
      //   )?.value;
      // }
      // if(siteType === 'GENSET_PVBESS_A2E'){
      //   assetConfigDataNew.max_power = CBAssetList[7].assetDetails[0]?.assetAttributes.find(
      //     attribute => attribute.type === "minGensetPower"
      //   )?.value;
      // }
      //  assetConfigDataNew.max_power = defaultsData.max_power;

      const derHistory = JSON.parse(sessionStorage.getItem("derHistory"));

      if (index === 0) {
        Object.entries(derHistory[embLabels.UTILITY]).forEach(
          ([key, value]) => {
            assetConfigDataNew[key] = value;
          }
        );
      } else if (index === 1) {
        Object.entries(derHistory[embLabels.GENSET]).forEach(([key, value]) => {
          assetConfigDataNew[key] = value;
        });
      } else if (index === 2) {
        Object.entries(derHistory[embLabels.BESS]).forEach(([key, value]) => {
          assetConfigDataNew[key] = value;
        });
      } else if (index === 6) {
        Object.entries(derHistory[embLabels.CHP]).forEach(([key, value]) => {
          assetConfigDataNew[key] = value;
        });
      } else if (index === 7) {
        Object.entries(derHistory[embLabels.HYBRID]).forEach(([key, value]) => {
          assetConfigDataNew[key] = value;
        });
      }

      setConfigData((prevState) => ({
        ...prevState,
        configData: assetConfigDataNew,
      }));
    } else {
      const assetConfigDataNew = { ...configData?.sampleConfigData };
      assetConfigDataNew.name = "";
      assetConfigDataNew.description = "";
      setConfigData((prevState) => ({
        ...prevState,
        configData: assetConfigDataNew,
      }));
    }
  };

  const loadConfigDataHandler = (index, flag) => {
    
    if(flag !== "skip_this"){
      setSelectedLoadIndx(index);
    }
    
    const loadArray = [...CBLoadList];
    const CBASSETLISTNEW = _.cloneDeep(CBAssetList);
    if (loadArray[index]?.configData?.name) {
      let cbConfigDataNew = { ...configData?.loadConfigData };
      cbConfigDataNew.name = loadArray[index]?.configData?.name;
      cbConfigDataNew.description = loadArray[index]?.configData?.description;
      cbConfigDataNew.description = loadArray[index]?.configData?.description;
      cbConfigDataNew.maximum_available_power =
        loadArray[index]?.configData?.maximum_available_power;
      CBASSETLISTNEW[1]?.selectedAssetData?.assetAttributes &&
        CBASSETLISTNEW[1]?.selectedAssetData?.assetAttributes?.forEach(
          (assetAttribute) => {
            if (assetAttribute?.type === "loadPower"&&assetAttribute?.value!=undefined) {
              cbConfigDataNew.maximum_available_power = assetAttribute.value;
              CBLoadListDispatch({
                type: ACTIONS.UPDATE_MAXIMUM_LOAD_POWER,
                payload: {
                  index: 0,
                  loadPower: assetAttribute.value,
                },
              });
            }
          }
        );
      // cbConfigDataNew.maximum_available_power =
      //   loadArray[index].configData.maximum_available_power;
      //   if(siteType === 'GENSET_PVBESS_A2E'){
      //      cbConfigDataNew.maximum_available_power =  CBAssetList[7].assetDetails[0]?.assetAttributes.find(
      //   attribute => attribute.type === "loadPower"
      // )?.value;
      //   }

      let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
      let loadHistory = [];
      if (derStatus[4] === true) {
        loadHistory = JSON.parse(sessionStorage.getItem("loadHistory"));
        if (loadHistory[index] !== undefined && loadHistory[index] !== null) {
          Object.entries(loadHistory[index]).forEach(([key, value]) => {
            cbConfigDataNew[key] = value;
          });
        }
      }

      setConfigData((prevState) => ({
        ...prevState,
        configData: cbConfigDataNew,
      }));
    } else {
      let cbConfigDataNew = { ...configData?.loadConfigData };
      cbConfigDataNew.name = "";
      cbConfigDataNew.description = "";
      cbConfigDataNew.maximum_available_power = 0;
      setConfigData((prevState) => ({
        ...prevState,
        configData: cbConfigDataNew,
      }));
    }
  };

  const evConfigDataHandler = (index) => {
    if (CBEVList?.[index]?.configData?.name) {
      let evConfigDataNew = { ...configData?.evConfigData };
      evConfigDataNew = CBEVList?.[index]?.configData;
      evConfigDataNew.name = CBEVList?.[index]?.configData?.name;
      evConfigDataNew.description = CBEVList?.[index]?.configData?.description;
      evConfigDataNew.maximum_available_power =
        CBEVList?.[index]?.configData?.maximum_available_power;

      let derHistory = JSON.parse(sessionStorage.getItem("derHistory"));

      Object.entries(derHistory["EV"]).forEach(([key, value]) => {
        evConfigDataNew[key] = value;
      });

      setConfigData((prevState) => ({
        ...prevState,
        configData: evConfigDataNew,
      }));
    } else {
      const evConfigDataNew = { ...configData?.evConfigData };
      evConfigDataNew.name = "";
      evConfigDataNew.description = "";
      setConfigData((prevState) => ({
        ...prevState,
        configData: evConfigDataNew,
      }));
    }
  };

  //* GET CB CONFIG DATA

  const cbConfigDataHandler = (index) => {
    const CBASSETLISTNEW = _.cloneDeep(CBAssetList);
    if (CBASSETLISTNEW?.[index]) {
      const cbConfigDataNew = { ...configData?.sampleCbConfigData };
      if (siteType === embLabels.PV_HYBRIDIZATION) {
        cbConfigDataNew.name = CBASSETLISTNEW?.[index]?.cbConfigData?.name;
        cbConfigDataNew.description =
          CBASSETLISTNEW?.[index]?.cbConfigData?.description;
      } else if (
        [
          embLabels.ISLANDABLE,
          embLabels.GRID_CONNECTED,
          embLabels.OFF_GRID,
          embLabels.GENSET_PVBESS_A2E,
        ].includes(siteType)
      ) {
        cbConfigDataNew.name = CBASSETLISTNEW?.[index]?.cbConfigData?.name;
        cbConfigDataNew.description =
          CBASSETLISTNEW[index]?.cbConfigData?.description;
        cbConfigDataNew.motorized =
          CBASSETLISTNEW[index]?.cbConfigData?.motorized;
          cbConfigDataNew.contactor =
          CBASSETLISTNEW[index]?.cbConfigData?.contactor;
      } else {
        //* do nothing
      }

      const derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
      let cbAssetHistory = [];
      if (derStatus[6]) {
        if (sessionStorage.getItem("cbAssetHistory") === "") {
          cbAssetHistory = [];
        } else {
          cbAssetHistory = JSON.parse(sessionStorage.getItem("cbAssetHistory"));
        }
        if (
          cbAssetHistory[index] !== undefined &&
          cbAssetHistory[index] !== null
        ) {
          Object.entries(cbAssetHistory[index]).forEach(([key, value]) => {
            cbConfigDataNew[key] = value;
          });
        }
      }
      const newcontactorConfigData = {
        ...configData?.sampleContactorConfigData,
      };
      if ([embLabels.GRID_CONNECTED,embLabels.ISLANDABLE].includes(siteType)) {
        newcontactorConfigData.name =
          CBASSETLISTNEW[index]?.contactorConfigData?.name;
        newcontactorConfigData.description =
          CBASSETLISTNEW[index]?.contactorConfigData?.description;
      }

      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
        contactorConfigData: newcontactorConfigData,
      }));
    } else {
      const cbConfigDataNew = { ...configData?.sampleCbConfigData };
      if (siteType === embLabels.PV_HYBRIDIZATION) {
        cbConfigDataNew.name = "";
        cbConfigDataNew.description = "";
      } else if (
        [
          embLabels.ISLANDABLE,
          embLabels.GRID_CONNECTED,
          embLabels.OFF_GRID,
        ].includes(siteType)
      ) {
        cbConfigDataNew.name = "";
        cbConfigDataNew.description = "";
        cbConfigDataNew.motorized = true;
        cbConfigDataNew.contactor = false;
      } else {
        //* do nothing
      }
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    }
  };

  const newSBCbConfigDataHandler = (index) => {
    const CBASSETLISTNEW = _.cloneDeep(CBAssetList);
    if (CBASSETLISTNEW[index]) {
      const cbConfigDataNew = { ...configData?.sampleCbConfigData };

      cbConfigDataNew.name = CBASSETLISTNEW[index]?.cbConfigData?.name;
      cbConfigDataNew.description =
        CBASSETLISTNEW[index]?.cbConfigData?.description;
      cbConfigDataNew.motorized =
        CBASSETLISTNEW[index]?.cbConfigData?.motorized;
      cbConfigDataNew.contactor =
        CBASSETLISTNEW[index]?.cbConfigData?.contactor;

      const derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
      let cbAssetHistory = [];
      if (derStatus[6]) {
        if (sessionStorage.getItem("cbAssetHistory") === "") {
          cbAssetHistory = [];
        } else {
          cbAssetHistory = JSON.parse(sessionStorage.getItem("cbAssetHistory"));
        }
        if (
          cbAssetHistory[index] !== undefined &&
          cbAssetHistory[index] !== null
        ) {
          Object.entries(cbAssetHistory[index]).forEach(([key, value]) => {
            cbConfigDataNew[key] = value;
          });
        }
      }

      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    } else {
      const cbConfigDataNew = { ...configData?.sampleCbConfigData };

      cbConfigDataNew.name = "";
      cbConfigDataNew.description = "";
      cbConfigDataNew.motorized = true;
      cbConfigDataNew.contactor = false;

      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    }
  };

  const loadCbConfigDataHandler = (index) => {
   
    const loadArray = [...CBLoadList];
    const assetDetailsData = { ...assetDetailsDisplay };
    if (loadArray[index]) {
      let cbConfigDataNew = { ...configData?.cbConfigData };
      cbConfigDataNew.name = loadArray[index]?.cbConfigData?.name;
      cbConfigDataNew.description = loadArray[index]?.cbConfigData?.description;
      cbConfigDataNew.motorized = loadArray[index]?.cbConfigData?.motorized;

      let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
      let cbLoadHistory = [];
      if (derStatus[6] === true) {
        if (sessionStorage.getItem("cbLoadHistory") === "") {
          cbLoadHistory = [];
        } else {
          cbLoadHistory = JSON.parse(sessionStorage.getItem("cbLoadHistory"));
        }

        if (
          cbLoadHistory[index] !== undefined &&
          cbLoadHistory[index] !== null
        ) {
          Object.entries(cbLoadHistory[index]).forEach(([key, value]) => {
            cbConfigDataNew[key] = value;
          });
        }
      }
      if(!projectKind?.isA2E){
      setAssetDetailsDisplay({
        ...assetDetailsData,
        communicationModel:
          CBLoadList[index]?.cbConfigData?.cbAssetDetails?.[0]
            ?.communicationModel,
      });
    }
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
        contactorConfigData: CBLoadList?.[index]?.contactorConfigData,
      }));
    } else {
      let cbConfigDataNew = { ...configData?.cbConfigData };
      cbConfigDataNew.name = "";
      cbConfigDataNew.description = "";
      cbConfigDataNew.motorized = true;
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    }
  };

  const evCbConfigDataHandler = (index) => {
    const cbArray = [...CBEVList];
    for(let item of jsonData){
      if(projectTypeValue=="MGaaS IEC" || projectTypeValue === "MGaaS ETO"){
      if(item?.componentIdx=="Contactor_60"&&cbArray[index]?.assetType=="EV_charging_station"){
        setIsContactorEnabled(true);
        const configDataNew = {...configData}
        configDataNew.cbConfigData.contactor = true;
        setConfigData((prevState) => ({ ...prevState, configData: configDataNew }))
        }
      }
    }
    if (cbArray[index]) {
      let cbConfigDataNew = { ...configData?.sampleCbConfigData };
      cbConfigDataNew.name = cbArray[index]?.cbConfigData?.name;
      cbConfigDataNew.description = cbArray[index]?.cbConfigData?.description;
      cbConfigDataNew.motorized = cbArray[index]?.cbConfigData?.motorized;
      cbConfigDataNew.contactor = cbArray[index]?.cbConfigData?.contactor;

      let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
      let cbEvHistory = [];
      if (derStatus[6]) {
        if (sessionStorage.getItem("cbEvHistory") === "") {
          cbEvHistory = [];
        } else {
          cbEvHistory = JSON.parse(sessionStorage.getItem("cbEvHistory"));
        }

        if (cbEvHistory[index] !== undefined && cbEvHistory[index] !== null) {
          Object.entries(cbEvHistory[index]).forEach(([key, value]) => {
            cbConfigDataNew[key] = value;
          });
        }
      }
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
        contactorConfigData: CBEVList?.[0]?.contactorConfigData,
      }));
    } else {
      let cbConfigDataNew = { ...configData?.sampleCbConfigData };
      cbConfigDataNew.name = "";
      cbConfigDataNew.description = "";
      cbConfigDataNew.motorized = true;
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    }
  };

  const pmConfigDataHandler = (index) => {
    const CBASSETLISTNEW = _.cloneDeep(CBAssetList);
    if (CBASSETLISTNEW[index]) {
      const cbConfigDataNew = { ...configData?.powerMeterData };
      cbConfigDataNew.name = CBASSETLISTNEW[index]?.powerMeterData?.name;
      cbConfigDataNew.description =
        CBASSETLISTNEW[index]?.powerMeterData?.description;

      const derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
      let pmAssetHistory = [];
      if (derStatus[8]) {
        if (sessionStorage.getItem("pmAssetHistory") === "") {
          pmAssetHistory = [];
        } else {
          pmAssetHistory = JSON.parse(sessionStorage.getItem("pmAssetHistory"));
        }
        if (
          pmAssetHistory[index] !== undefined &&
          pmAssetHistory[index] !== null
        ) {
          Object.entries(pmAssetHistory[index]).forEach(([key, value]) => {
            cbConfigDataNew[key] = value;
          });
        }
      }

      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    } else {
      const cbConfigDataNew = { ...configData?.sampleCbConfigData };
      cbConfigDataNew.name = "";
      cbConfigDataNew.description = "";
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    }
  };

  const existingPmConfigDataHandler = (index) => {
    const CBASSETLISTNEW = _.cloneDeep(CBAssetList);
    if (CBASSETLISTNEW[index]) {
      const cbConfigDataNew = { ...configData?.existingPowerMeterData };
      cbConfigDataNew.name =
        CBASSETLISTNEW[index]?.existingPowerMeterData?.name;
      cbConfigDataNew.description =
        CBASSETLISTNEW[index]?.existingPowerMeterData?.description;

      const derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
      let pmAssetHistory = [];
      if (derStatus[8]) {
        if (sessionStorage.getItem("pmAssetHistory") === "") {
          pmAssetHistory = [];
        } else {
          pmAssetHistory = JSON.parse(sessionStorage.getItem("pmAssetHistory"));
        }
        if (
          pmAssetHistory[index] !== undefined &&
          pmAssetHistory[index] !== null
        ) {
          Object.entries(pmAssetHistory[index]).forEach(([key, value]) => {
            cbConfigDataNew[key] = value;
          });
        }
      }

      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    } else {
      const cbConfigDataNew = { ...configData?.sampleCbConfigData };
      cbConfigDataNew.name = "";
      cbConfigDataNew.description = "";
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    }
  };

  const loadpmConfigDataHandler = (index) => {
    const CBLoadListNew = _.cloneDeep(CBLoadList);
    if (CBLoadListNew[index]) {
      const cbConfigDataNew = { ...configData?.powerMeterData };
      cbConfigDataNew.name = CBLoadListNew[index]?.powerMeterData?.name;
      cbConfigDataNew.description =
        CBLoadListNew[index]?.powerMeterData?.description;

      const derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
      let pmEvHistory = [];
      if (derStatus[8]) {
        if (sessionStorage.getItem("pmEvHistory") === "") {
          pmEvHistory = [];
        } else {
          pmEvHistory = JSON.parse(sessionStorage.getItem("pmEvHistory"));
        }
        if (pmEvHistory[index] !== undefined && pmEvHistory[index] !== null) {
          Object.entries(pmEvHistory[index]).forEach(([key, value]) => {
            cbConfigDataNew[key] = value;
          });
        }
      }

      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    } else {
      const cbConfigDataNew = { ...configData?.sampleCbConfigData };
      cbConfigDataNew.name = "";
      cbConfigDataNew.description = "";
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    }
  }

  const evpmConfigDataHandler = (index) => {
    const CBEVListNEW = _.cloneDeep(CBEVList);
    if (CBEVListNEW[index]) {
      const cbConfigDataNew = { ...configData?.powerMeterData };
      cbConfigDataNew.name = CBEVListNEW[index]?.powerMeterData?.name;
      cbConfigDataNew.description =
        CBEVListNEW[index]?.powerMeterData?.description;

      const derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
      let pmEvHistory = [];
      if (derStatus[8]) {
        if (sessionStorage.getItem("pmEvHistory") === "") {
          pmEvHistory = [];
        } else {
          pmEvHistory = JSON.parse(sessionStorage.getItem("pmEvHistory"));
        }
        if (pmEvHistory[index] !== undefined && pmEvHistory[index] !== null) {
          Object.entries(pmEvHistory[index]).forEach(([key, value]) => {
            cbConfigDataNew[key] = value;
          });
        }
      }

      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    } else {
      const cbConfigDataNew = { ...configData?.sampleCbConfigData };
      cbConfigDataNew.name = "";
      cbConfigDataNew.description = "";
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: cbConfigDataNew,
      }));
    }
  };

  //* change handlers

  const handleUtilityChange = (e) => {
    const dataConfig = { ...configData?.configData };
   const onlyNumber = /^(\d+(\.\d+)?|)$/;
    switch (e.target.name) {
      case "utilityCO2":
        if (!isNaN(e.target.value) && e.target.value >= 0) {
          dataConfig[e.target.name] = e.target.value;
          setConfigData((prevState) => ({
            ...prevState,
            configData: dataConfig,
          }));

          assetEditStatusUpdateDER(e, embLabels.UTILITY, true);
        }
        break;
      case "maximum_available_power":
        if (onlyNumber.test(e.target.value)) {
          dataConfig[e.target.name] = e.target.value;
          setConfigData((prevState) => ({
            ...prevState,
            configData: dataConfig,
          }));

          assetEditStatusUpdateDER(e, embLabels.UTILITY, true);
        }
        break;
      case "externalId":
        const { value } = e.target;
        if (value.trim() !== "") {
          if (alphanumericRegWithHyphen.test(value)) {
            setGsxExternalId((prevState) => ({
              ...prevState,
              utilityExternalId: value,
            }));
          }
          assetEditStatusUpdateDER(e, embLabels.UTILITY, true);
        } else {
          setGsxExternalId((prevState) => ({
            ...prevState,
            utilityExternalId: "",
          }));
        }

        break;
      default:
        dataConfig[e.target.name] = e.target.value;
        if (isValidName(e.target.value)) {
          setConfigData((prevState) => ({
            ...prevState,
            configData: dataConfig,
          }));

          assetEditStatusUpdateDER(e, embLabels.UTILITY, true);
        } else {
          setConfigData((prevState) => ({
            ...prevState,
            configData: dataConfig,
          }));
        }
    }
    setIsAssetConfigChanged(configData);
  };

  const handleGensetChange = (e) => {
    const dataConfig = { ...configData?.configData };
   const onlyNumber =/^(\d+(\.\d+)?|)$/;
    if (e.target.name === "gensetCO2") {
      if (!isNaN(e.target.value) && e.target.value >= 0) {
        dataConfig[e.target.name] = e.target.value;
        setConfigData((prevState) => ({
          ...prevState,
          configData: dataConfig,
        }));
        assetEditStatusUpdateDER(e, embLabels.GENSET, true);
      }
    } else if (
      [
        "starting_timer",
        "cooling_timer",
        "minimum_running_period",
        "max_power",
      ].includes(e.target.name)
    ) {
      if (onlyNumber.test(e.target.value)) {
        if (parseInt(e.target.value) === 0) {
          dataConfig[e.target.name] = e.target.value;
        } else {
          dataConfig[e.target.name] = parseInt(e.target.value)
            ? parseInt(e.target.value)
            : "";
        }
        setConfigData((prevState) => ({
          ...prevState,
          configData: dataConfig,
        }));
        assetEditStatusUpdateDER(e, embLabels.GENSET, true);
      }
    } else if (e.target.name === "externalId") {
      const { value } = e.target;
      if (value.trim() !== "") {
        if (alphanumericRegWithHyphen.test(value)) {
          setGsxExternalId((prevState) => ({
            ...prevState,
            gensetExternalId: value,
          }));
        }
        assetEditStatusUpdateDER(e, embLabels.GENSET, true);
      } else {
        setGsxExternalId((prevState) => ({
          ...prevState,
          gensetExternalId: "",
        }));
      }
    } else {
      if( (projectKind?.isDaasAnsi || projectKind?.isDaasEto) && e.target.name === "deviceName" ){
        dataConfig[e.target.name] = e.target.value.toLowerCase();
       }else{
        dataConfig[e.target.name] = e.target.value;
       }

      setConfigData((prevState) => ({
        ...prevState,
        configData: dataConfig,
      }));
      assetEditStatusUpdateDER(e, embLabels.GENSET, true);
    }
    setIsAssetConfigChanged(configData)
  };

  const handleBatteryChange = (e) => {
    const dataConfig = { ...configData?.configData };
    const onlyNumber =/^(\d+(\.\d+)?|)$/;
    if (
      [
        "max_power",
        "capacity",
        "soc_max",
        "soc_min",
        "soc_nominal_power",
       "SoC_min_optimization",
       "SoC_fallback"
      ].includes(e.target.name)
    ) {
      if (onlyNumber.test(e.target.value)) {
        dataConfig[e.target.name] = e.target.value;
        assetEditStatusUpdateDER(e, embLabels.BESS, true);
      } else {
        dataConfig[e.target.name] = e.target.value;
      }
      setConfigData((prevState) => {
        return { ...prevState, configData: dataConfig }
      });
    } else if (e.target.name === "externalId") {
      const { value } = e.target;
      if (value.trim() !== "") {
        if (alphanumericRegWithHyphen.test(value)) {
          setGsxExternalId((prevState) => ({
            ...prevState,
            batteryExternalId: value,
          }));
        }
        assetEditStatusUpdateDER(e, embLabels.BESS, true);
      } else {
        setGsxExternalId((prevState) => ({
          ...prevState,
          batteryExternalId: "",
        }));
      }
    } else if (e.target.name === "deviceName") {
      dataConfig[e.target.name] = e.target.value.toLowerCase();

      setConfigData((prevState) => ({
        ...prevState,
        configData: dataConfig,
      }));

      assetEditStatusUpdateDER(e, embLabels.BESS, true);
    }else if(e.target.name === "quantityOfBess" ){
       if (onlyNumber.test(e.target.value)) {
        dataConfig[e.target.name] = e.target.value;
        dataConfig["max_power"] = Number(e.target.value) * Number(dataConfig.perUnitMaxPower);
         dataConfig["capacity"] = Number(e.target.value) * Number(dataConfig.perUnitMaxEnergy);
        assetEditStatusUpdateDER(e, embLabels.BESS, true);
      } 
      setConfigData((prevState) => ({ ...prevState, configData: dataConfig }));
     
    }else if(e.target.name === "quantityOfBessPro"){
       if (onlyNumber.test(e.target.value)) {
        dataConfig["quantityOfBess"] = e.target.value;
        dataConfig["max_power"] = Number(e.target.value) * 100;
         dataConfig["capacity"] = Number(e.target.value) * 215;
        assetEditStatusUpdateDER(e, embLabels.BESS, true);
      } 
      setConfigData((prevState) => ({ ...prevState, configData: dataConfig }));
    }else if(e.target.name === "perUnitMaxPower"){
       if (onlyNumber.test(e.target.value)) {
        dataConfig[e.target.name] = e.target.value;
        dataConfig["max_power"] = Number(e.target.value) * Number(dataConfig.quantityOfBess ?? 1);
        assetEditStatusUpdateDER(e, embLabels.BESS, true);
      } 
      setConfigData((prevState) => ({ ...prevState, configData: dataConfig }));
    }else if(e.target.name ===  "perUnitMaxEnergy"){
       if (onlyNumber.test(e.target.value)) {
        dataConfig[e.target.name] = e.target.value;
         dataConfig["capacity"] = Number(e.target.value) * Number(dataConfig.quantityOfBess ?? 1);
        assetEditStatusUpdateDER(e, embLabels.BESS, true);
      } 
      setConfigData((prevState) => ({ ...prevState, configData: dataConfig }));
    }
     else {
      dataConfig[e.target.name] = e.target.value;

      setConfigData((prevState) => ({
        ...prevState,
        configData: dataConfig,
      }));

      assetEditStatusUpdateDER(e, embLabels.BESS, true);
    }
    setIsAssetConfigChanged(configData);
  };

  const handleChpChange = (e) => {
    let dataConfig = { ...configData?.configData };
    const onlyNumber =/^(\d+(\.\d+)?|)$/;
    switch (e.target.name) {
      case "nominal_power":
        if (onlyNumber.test(e.target.value)) {
          dataConfig[e.target.name] = e.target.value;

          assetEditStatusUpdateDER(e, embLabels.CHP, true);
        } else {
          dataConfig[e.target.name] = configData?.configData?.nominal_power;
        }
        setConfigData((prevState) => ({
          ...prevState,
          configData: dataConfig,
        }));
        break;

      default:
        dataConfig[e.target.name] = e.target.value;
        // if (isValidName(e.target.value)) {
          setConfigData((prevState) => ({
            ...prevState,
            configData: dataConfig,
          }));
          assetEditStatusUpdateDER(e, embLabels.CHP, true);
        // }
    }
  };

  const handleHybridChange = (e) => {
    const dataConfig = { ...configData?.configData };
    const onlyNumber =/^(\d+(\.\d+)?|)$/;
    const { name, value } = e.target;
    if (
      [
        "max_capacity",
        "capacity",
        "max_solar_power",
        "max_inverter_output_power",
        "usableStorageCapacityHr",
        "usableStorageCapacity",
      ].includes(name)
    ) {
      if (onlyNumber.test(value)) {
        dataConfig[name] = value;
        assetEditStatusUpdateDER(e, embLabels.HYBRID, true);
      } else {
        dataConfig[e.target.name] = e.target.name;
      }
      setConfigData((prevState) => ({ ...prevState, configData: dataConfig }));
    } else {
      dataConfig[name] = value;
      // if (isValidName(value)) {
        setConfigData((prevState) => ({
          ...prevState,
          configData: dataConfig,
        }));
      // }
      assetEditStatusUpdateDER(e, embLabels.HYBRID, true);
    }
    setIsAssetConfigChanged(configData);
  };

  const handlePvChange = (e) => {
    // if (isValidName(e.target.value)) {
      PVDetailsDispatch({
        type: ACTIONS.HANDLE_PV_CHANGE,
        payload: {
          data: e.target,
          projectTypeValue
        },
      });
      setConsiderSelected(false);
    // }
  };

  const handleLoadChange = (e) => {
    const {name, value} = e.target;
    let newConfigData = { ...configData?.configData };
    const onlyNumber =  /^(\d+(\.\d+)?|)$/;
    switch (name) {
      case "maximum_available_power":
        if (onlyNumber.test(value)) {
          newConfigData[name] = value;
          assetEditStatusUpdateLoad(e, true, selectedValues?.selectedLoad);
        } else {
          newConfigData[name] =
            configData?.configData?.maximum_available_power;
        }
        setConfigData((prevState) => ({
          ...prevState,
          configData: newConfigData,
        }));

        break;
      case "name":
        if(isValidName(value) || value === ""){
          let loadNamesList = [];
        CBLoadList?.forEach((load) => {
          loadNamesList.push(load?.configData?.name);
        });
        newConfigData[name] = value;
        if (loadNamesList.includes(value)) {
          setIsLoadNameUnique(true);
        } else {
          setIsLoadNameUnique(false);
        }
        setConfigData((prevState) => ({
          ...prevState,
          configData: newConfigData,
        }));
        assetEditStatusUpdateLoad(e, true, selectedValues?.selectedLoad);
        }else{
           setConfigData((prevState) => ({
            ...prevState,
            configData: newConfigData,
          }));
        }
        
        break;
      default:
        newConfigData[e.target.name] = e.target.value;
        if (isValidName(e.target.value)) {
          setConfigData((prevState) => ({
            ...prevState,
            configData: newConfigData,
          }));
          assetEditStatusUpdateLoad(e, true, selectedValues?.selectedLoad);
        } else {
          setConfigData((prevState) => ({
            ...prevState,
            configData: newConfigData,
          }));
          // callSnackbar("error", "only alphanumeric charecters are allowed")
        }
    }
     setIsAssetConfigChanged(configData);
  };

  const handleEvChange = (e) => {
    let dataConfig = { ...configData?.configData };
    const onlyNumber =  /^(\d+(\.\d+)?|)$/;
    switch (e.target.name) {
      case "maximum_available_power":
        if (onlyNumber.test(e.target.value)) {
          dataConfig[e.target.name] = e.target.value;
          assetEditStatusUpdateDER(e, embLabels.EV, true);
        } else {
          dataConfig[e.target.name] =
            configData?.configData?.maximum_available_power;
        }
        setConfigData((prevState) => ({
          ...prevState,
          configData: dataConfig,
          evConfigData: dataConfig,
        }
        
      ));
        break;
        case "name":
        dataConfig[e.target.name] = e.target.value;
        setConfigData((prevState) => ({
            ...prevState,
            configData: dataConfig,
            evConfigData: dataConfig,
          }));
          assetEditStatusUpdateDER(e, embLabels.EV, true);
        break;
      default:
        dataConfig[e.target.name] = e.target.value;
        // if (isValidName(e.target.value)) {
          setConfigData((prevState) => ({
            ...prevState,
            configData: dataConfig,
            evConfigData: dataConfig,
          }));
          assetEditStatusUpdateDER(e, embLabels.EV, true);
        // }
    }
    setIsAssetConfigChanged(configData);
  };

  const handleCBConfigChange = (e) => {
    const newCbConfigData = { ...configData?.cbConfigData };
    if (e.target.name === "motorized") {
      if (
        [embLabels.GRID_CONNECTED,embLabels.ISLANDABLE].includes(siteType) &&
        clientType === embLabels.GENERIC_PROJECT &&
       ( projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO")
      ) {
        if(e.target.checked){
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG,
            payload: {
              selectedAssetCB: selectedValues?.selectedAssetCB,
              cbConfigData: configData?.contactorConfigData,
              checked: false,
            },
          })
            newCbConfigData.motorized = true;
            setConfigData((prevState)=>({
              ...prevState,
              cbConfigData: newCbConfigData,
            }))
        }else{
          newCbConfigData[e.target.name] = e.target.checked;
        }
      } else {
        newCbConfigData[e.target.name] = true;
      }
    }else if(e.target.name==="contactor"){
      if (
        [embLabels.GRID_CONNECTED,embLabels.ISLANDABLE].includes(siteType)  &&
        clientType === embLabels.GENERIC_PROJECT &&
        (projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO")
      ) {
         if(e.target.checked){
          if(configData?.cbConfigData?.motorized){
            const newConfigData = {...configData}
            newConfigData.cbConfigData.motorized = false
            newConfigData.cbConfigData[e.target.name] = e.target.value;
            setConfigData((prevState)=>({
              ...prevState,
              cbConfigData: newConfigData,
            }))
          }
        }
      } else {
        newCbConfigData[e.target.name] = true;
      }
    } else {
      if( (projectKind?.isDaasAnsi || projectKind?.isDaasEto) && e.target.name === "name" ){
        newCbConfigData[e.target.name] = e.target.value.toLowerCase();
      }else{
        newCbConfigData[e.target.name] = e.target.value;
      }
    }
    // if (isValidName(e.target.value)) {
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: newCbConfigData,
      }));
    // }
    setIsAssetConfigChanged(configData);
  };

  const handleCBContactorConfigChange = (e) => {
    const newCbContactorConfigData = { ...configData?.contactorConfigData };
    newCbContactorConfigData[e.target.name] = e.target.value;

    // if (isValidName(e.target.value)) {
      setConfigData((prevState) => {
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG,
          payload: {
            selectedAssetCB: selectedValues?.selectedAssetCB,
            cbConfigData: newCbContactorConfigData,
            checked: CBAssetList?.[selectedValues?.selectedAssetCB]?.uiData?.contactor
          },
        });
       return { ...prevState,
        contactorConfigData: newCbContactorConfigData}
      });
    // }

    setIsAssetConfigChanged(newCbContactorConfigData)
  };
  const handleCBContactorConfigChangeLoad = (e) => {
    const newCbContactorConfigData = { ...configData?.contactorConfigData };
    newCbContactorConfigData[e.target.name] = e.target.value;

    // if (isValidName(e.target.value)) {
      setConfigData((prevState) => {
       
         CBLoadListDispatch({
              type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_CHANGE,
              payload: {
                index: selectedValues?.selectedLoadCB,
                CBContactor: newCbContactorConfigData,
                },
            })
       return { ...prevState,
        contactorConfigData: newCbContactorConfigData}
      });
    // }

    setIsAssetConfigChanged(newCbContactorConfigData)
  };
  const handleCBConfigChangeLoad = (e) => {
    const newCbConfigData = { ...configData?.cbConfigData };
    let newContactorConfigData = { ...configData?.contactorConfigData };
    
    if (e.target.name === "motorized") {
      if(e.target.checked){
       CBLoadListDispatch({
         type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_DATA,
         payload: {
           index: selectedValues?.selectedLoadCB,
           CBContactor: configData?.contactorConfigData,
           defaultContactor: configData?.contactorConfigData,
           checked: false,
         },
       })
         newCbConfigData[e.target.name] = e.target.checked;
         newCbConfigData.loadCategory = 0;
         newCbConfigData.loadCategory = 0;
         setConfigData((prevState)=>({
           ...prevState,
           cbConfigData: newCbConfigData,
         }))
     }else{
       newCbConfigData[e.target.name] = e.target.checked;
     }
     newCbConfigData[e.target.name] = e.target.checked;
     newCbConfigData.loadCategory = 0;
     newCbConfigData.loadCategory = 0;
   }else if(e.target.name==='contactor'){
     if(e.target.checked){
       // Generate the same name as the reducer
       const index = selectedValues?.selectedLoadCB;
       newContactorConfigData = { ...configData?.contactorConfigData };
       newContactorConfigData.name = `Load_Contactor_${index + 1}`;
       
       if(newCbConfigData.motorized){
        CBLoadListDispatch({
           type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_DATA,
           payload: {
             index: selectedValues?.selectedLoadCB,
             CBContactor: newContactorConfigData,
             defaultContactor: defaultPreFillData[3],
             checked: true,
           },
         })
         newCbConfigData.motorized = false;
         }else{
          CBLoadListDispatch({
             type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_DATA,
             payload: {
               index: selectedValues?.selectedLoadCB,
               CBContactor: newContactorConfigData,
               defaultContactor: defaultPreFillData[3],
               checked: true,
             },
           })
       }
     }else{
       newContactorConfigData = { name: "", description: "" };
       
      CBLoadListDispatch({
         type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_DATA,
         payload: {
           index: selectedValues?.selectedLoadCB,
           CBContactor: newContactorConfigData,
            defaultContactor: defaultPreFillData[3],
           checked: false,
         },
       })
     }
   } else {
    if( (projectKind?.isDaasAnsi || projectKind?.isDaasEto) && e.target.name === "name" ){
      newCbConfigData[e.target.name] = e.target.value.toLowerCase();
    }else{
      newCbConfigData[e.target.name] = e.target.value;
    }
     
   }

    // if (isValidCBName(e.target.value)) {
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: newCbConfigData,
        contactorConfigData: newContactorConfigData,
      }));
    // }
    setIsAssetConfigChanged(configData)
  };

  const handleCBConfigChangeEv = (e) => {
    const newCbConfigData = { ...configData?.cbConfigData };
    if (e.target.name === "motorized") {
       if(e.target.checked){
        CBEVListDispatch({
          type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_DATA,
          payload: {
            index: selectedValues?.selectedEvCB,
            CBContactor: configData?.contactorConfigData,
            defaultContactor: configData?.contactorConfigData,
            checked: false,
          },
        })
          newCbConfigData.motorized = true;
          setConfigData((prevState)=>({
            ...prevState,
            cbConfigData: newCbConfigData,
          }))
      }else{
        newCbConfigData[e.target.name] = e.target.checked;
      }
      newCbConfigData[e.target.name] = e.target.checked;
      newCbConfigData.loadCategory = 0;
      newCbConfigData.loadCategory = 0;
    }else if(e.target.name==='contactor'){
      if(e.target.checked){
        if(newCbConfigData.motorized){
          CBEVListDispatch({
            type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_DATA,
            payload: {
              index: selectedValues?.selectedEvCB,
              CBContactor: configData?.contactorConfigData,
              defaultContactor: configData?.contactorConfigData,
              checked: true,
            },
          })
          newCbConfigData.motorized = false;
          }else{
            CBEVListDispatch({
              type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_DATA,
              payload: {
                index: selectedValues?.selectedEvCB,
                CBContactor: configData?.contactorConfigData,
                defaultContactor: configData?.contactorConfigData,
                checked: true,
              },
            })
        }
      }else{
        CBEVListDispatch({
          type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_DATA,
          payload: {
            index: selectedValues?.selectedEvCB,
            CBContactor: configData?.contactorConfigData,
            defaultContactor: configData?.contactorConfigData,
            checked: false,
          },
        })
      }
    } else {
      newCbConfigData[e.target.name] = e.target.value;
    }

    // if (isValidName(e.target.value)) {
      setConfigData((prevState) => ({
        ...prevState,
        cbConfigData: newCbConfigData,
      }));
    // }
    setIsAssetConfigChanged(configData);
  };

  //* Update config data's

  const isBetween = (num, a, b) => (num - a) * (num - b) <= 0;

  const calculateMaxAvailableUtilityPower = () => {
    const nominalCurrentMin =
      CBAssetList[0]?.cbConfigData?.cbAssetDetails[0]?.assetAttributes?.filter(
        (assetAttribute) => assetAttribute.type === "nominalCurrentMin"
      )[0]?.value;
    const nominalCurrentMax =
      CBAssetList[0]?.cbConfigData?.cbAssetDetails[0]?.assetAttributes?.filter(
        (assetAttribute) => assetAttribute.type === "nominalCurrentMax"
      )[0]?.value;
    const nominalPowerMin = nominalCurrentMin
      ? nominalCurrentMin * nominalVoltage
      : +defaultsMinMax?.maxAvailablePowerUtilityMin;
    const nominalPowerMax = nominalCurrentMax
      ? nominalCurrentMax * nominalVoltage
      : +defaultsMinMax?.maxAvailablePowerUtilityMax;

    const powerIsBetween = isBetween(
      +configData?.configData?.maximum_available_power,
      nominalPowerMin,
      nominalPowerMax
    );

    return [powerIsBetween, nominalPowerMin, nominalPowerMax];
  };
  const calculateMaxAvailableLoadPower = () => {
    const nominalCurrentMin = CBLoadList?.[
      selectedValues?.selectedLoad
    ]?.cbConfigData?.cbAssetDetails?.[0]?.assetAttributes?.filter(
      (assetAttribute) => assetAttribute.type === "nominalCurrentMin"
    )[0]?.value;
    const nominalCurrentMax = CBLoadList?.[
      selectedValues?.selectedLoad
    ]?.cbConfigData?.cbAssetDetails?.[0]?.assetAttributes?.filter(
      (assetAttribute) => assetAttribute.type === "nominalCurrentMax"
    )[0]?.value;

    let nominalPowerMin = nominalCurrentMin
      ? nominalCurrentMin * nominalVoltage
      : +defaultsMinMax?.maxPowerLoadMin;
    let nominalPowerMax = nominalCurrentMax
      ? nominalCurrentMax * nominalVoltage
      : +defaultsMinMax?.maxPowerLoadMax;

    if (siteType === embLabels.GENSET_PVBESS_A2E) {
      nominalPowerMin =
        +CBAssetList[7].assetDetails[0].assetAttributes.find(
          (attribute) => attribute.type === "minLoadPower"
        ).value ?? "0";
      nominalPowerMax =
        +CBAssetList[7].assetDetails[0].assetAttributes.find(
          (attribute) => attribute.type === "maxLoadPower"
        ).value ?? "200";
    }

    const powerIsBetween = isBetween(
      +configData?.configData?.maximum_available_power,
      nominalPowerMin,
      nominalPowerMax
    );

    return [powerIsBetween, nominalPowerMin, nominalPowerMax];
  };

  const calculateMaxAvailableGensetPower = () => {
    const nominalPowerMin = Number(
      CBAssetList[7]?.assetDetails[0]?.assetAttributes?.find(
        (attribute) => attribute.type === "minGensetPower"
      )?.value ?? defaultsMinMax?.maxPowerGensetMin
    );

    const nominalPowerMax = Number(
      CBAssetList[7].assetDetails[0]?.assetAttributes?.find(
        (attribute) => attribute.type === "maxGensetPower"
      )?.value ?? defaultsMinMax?.maxPowerGensetMax
    );

    const powerIsBetween = isBetween(
      +configData?.configData?.max_power,
      +nominalPowerMin,
      +nominalPowerMax
    );

    return [powerIsBetween, nominalPowerMin, nominalPowerMax];
  };

  const updateUtilitytConfig = () => {
    const [powerIsBetween, nominalPowerMin, nominalPowerMax] =
      calculateMaxAvailableUtilityPower();
    if (
      checkForDuplicateName(
        configData?.configData?.name,
        CBAssetList[0]?.configData?.name
      )
    ) {
      callSnackbar(
        `error`,
        `"${configData?.configData?.name}" already exists, please provide an unique name`
      );
    } else {
      if (
        /^[a-zA-Z0-9-_& ]+$/.test(configData?.configData?.name) &&
        parseInt(configData?.configData?.maximum_available_power) !== 0 &&
         (configData?.configData?.maximum_available_power !== "")  &&
        parseInt(configData?.configData?.utilityCO2) >=
          defaultsMinMax?.utilityCO2Min &&
        parseInt(configData?.configData?.utilityCO2) <=
          defaultsMinMax?.utilityCO2Max &&
        powerIsBetween
      ) {
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_ASSET_CONFIG,
          payload: {
            selectedAsset: selectedValues?.selectedAsset,
            configData: configData?.configData,
          },
        });
        if (duplicateUpdate.der === "") {
          setDuplicateUpdate({
            der: 0,
            load: "",
            pv: "",
            ev: "",
          });
        }
        updateDerHistory(0);
        updateDerStatus(0);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "Utility Configured Successfully");
      } else if (
        configData?.configData?.name === "" ||
        configData?.configData?.maximum_available_power?.toString() === "" ||
        configData?.configData?.utilityCO2.toString() === ""
      ) {
        callSnackbar("error", embLabels.mandatoryFields);
      // } else if (!isValidName(configData?.configData?.name)) {
      //   callSnackbar("error", embLabels.notallowedAlphanumericValues);
      } else if (
        parseInt(configData?.configData?.utilityCO2) <
          defaultsMinMax?.utilityCO2Min ||
        parseInt(configData?.configData?.utilityCO2) >
          defaultsMinMax?.utilityCO2Max
      ) {
        callSnackbar(
          `error`,
          `Utility CO2 Emission should be in range(${defaultsMinMax?.utilityCO2Min}-${defaultsMinMax?.utilityCO2Max} g/kWh)`
        );
      } else if (!powerIsBetween) {
        callSnackbar(
          `error`,
          `Maximum Available Power should be in range
          (${nominalPowerMin}-${nominalPowerMax} kW)`
        );
      } else {
        callSnackbar("error", embLabels.mandatoryFields);
      }
    }
  };

  const updateGensetConfig = () => {
    const deviceNameCheck = typeof configData?.configData?.deviceName === 'string' && /^[a-zA-Z0-9-_]+$/.test(configData?.configData?.deviceName);
    const [powerIsBetween, nominalPowerMin, nominalPowerMax] =
      calculateMaxAvailableGensetPower();
    if (
      checkForDuplicateName(
        configData?.configData?.name,
        CBAssetList[1]?.configData?.name
      )
    ) {
      callSnackbar(
        "error",
        `"${configData?.configData?.name}" already exists, please provide an unique name`
      );
    } else {
      if (parseInt(configData?.configData?.starting_timer) !== 0 && 
      parseInt(configData?.configData?.cooling_timer) !== 0 && 
      parseInt(configData?.configData?.minimum_running_period) !== 0 &&
        /^[a-zA-Z0-9-_& ]+$/.test(configData?.configData?.name ) &&
        // isValidName(configData.configData.name) &&
        parseInt(configData?.configData?.gensetCO2) >=
          defaultsMinMax?.gensetCO2Min &&
        parseInt(configData?.configData?.gensetCO2) <=
          defaultsMinMax?.gensetCO2Max &&
        parseInt(configData?.configData?.starting_timer) >=
          defaultsMinMax?.startUpGensetMin &&
        parseInt(configData?.configData?.starting_timer) <=
          defaultsMinMax?.startUpGensetMax &&
        parseInt(configData?.configData?.cooling_timer) >=
          defaultsMinMax?.coolingDurationGensetMin &&
        parseInt(configData?.configData?.cooling_timer) <=
          defaultsMinMax?.coolingDurationGensetMax &&
        parseInt(configData?.configData?.minimum_running_period) >=
          defaultsMinMax?.minRunningDurationGensetMin &&
        parseInt(configData?.configData?.minimum_running_period) <=
          defaultsMinMax?.minRunningDurationGensetMax &&
        powerIsBetween
      ) {
        if(!deviceNameCheck &&( projectTypeValue === "DaaS ANSI" || projectTypeValue === "DaaS ETO")){
          callSnackbar(`error`, embLabels.mandatoryFields);
        }else{
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_ASSET_CONFIG,
            payload: {
              selectedAsset: selectedValues?.selectedAsset,
              configData: configData?.configData,
            },
          });
          if (duplicateUpdate.der === "") {
            setDuplicateUpdate({
              der: 1,
              load: "",
              pv: "",
              ev: "",
            });
          }
  
          // newGensetData[this.state.selectedAsset].communicationData =
          //   Object.assign({}, this.state.communicationData);
  
          updateDerHistory(1);
          updateDerStatus(1);
  
          const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
          setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
          sessionStorage.setItem("componentDataModified",true);
          callSnackbar("information", "Genset Configured Successfully");
        }
      } else if (
        configData?.configData?.name.toString() === "" ||
        configData?.configData?.max_power?.toString() === "" ||
        configData?.configData?.gensetCO2?.toString() === "" ||
        configData?.configData?.starting_timer?.toString() === "" ||
        configData?.configData?.cooling_timer?.toString() === "" ||
        configData?.configData?.minimum_running_period.toString() === ""
      ) {
        callSnackbar("error", embLabels.mandatoryFields);
      // } else if (!isValidName(configData?.configData?.name)) {
      //   callSnackbar("error", embLabels.notallowedAlphanumericValues);
      } else if (!powerIsBetween) {
        callSnackbar(
          `error`,
          `Max Power should be in range
          (${nominalPowerMin}-${nominalPowerMax} kW)`
        );
      } else if (
        parseInt(configData?.configData?.gensetCO2) <
          defaultsMinMax?.gensetCO2Min ||
        parseInt(configData?.configData?.gensetCO2) > defaultsMinMax?.gensetCO2Max
      ) {
        callSnackbar(
          `error`,
          `Genset CO2 should be in range (${defaultsMinMax?.gensetCO2Min}-${defaultsMinMax?.gensetCO2Max} kg/MWh)`
        );
      } else if (
        parseInt(configData?.configData?.starting_timer) <
          defaultsMinMax?.startUpGensetMin ||
        parseInt(configData?.configData?.starting_timer) >
          defaultsMinMax?.startUpGensetMax
      ) {
        callSnackbar(
          `error`,
          `Start-up duration should be in range (${defaultsMinMax?.startUpGensetMin}-${defaultsMinMax?.startUpGensetMax} s)`
        );
      } else if (
        parseInt(configData?.configData?.cooling_timer) <
          defaultsMinMax?.coolingDurationGensetMin ||
        parseInt(configData?.configData?.cooling_timer) >
          defaultsMinMax?.coolingDurationGensetMax
      ) {
        callSnackbar(
          `error`,
          `Cooling Duration should be in range (${defaultsMinMax?.coolingDurationGensetMin}-${defaultsMinMax?.coolingDurationGensetMax} s)`
        );
      } else if (
        parseInt(configData?.configData?.minimum_running_period) <
          defaultsMinMax?.minRunningDurationGensetMin ||
        parseInt(configData?.configData?.minimum_running_period) >
          defaultsMinMax?.minRunningDurationGensetMax
      ) {
        callSnackbar(
          `error`,
          `Minimum running duration should be in range (${defaultsMinMax?.minRunningDurationGensetMin}-${defaultsMinMax?.minRunningDurationGensetMax} s)`
        );
      } else {
        callSnackbar("error", embLabels.mandatoryFields);
      }
    }
  };

  const updateBatteryConfig = (index) => {
    const isEnergyReserveSelected = CBAssetList?.[index]?.uiData?.energyReserveRequired;
    const maxPowerBessMax = configData?.configData?.quantityOfBess?(configData?.configData?.quantityOfBess  * defaultsMinMax?.maxPowerBessMax):defaultsMinMax?.maxPowerBessMax;
  const capacityBessMax = configData?.configData?.quantityOfBess?(configData?.configData?.quantityOfBess  * defaultsMinMax?.capacityBessMax):defaultsMinMax?.capacityBessMax;
 
    const deviceNameCheck = typeof configData?.configData?.deviceName === 'string' && (/^[a-zA-Z0-9-_]+$/.test(configData?.configData?.deviceName));
    if(configData?.configData?.max_power!=undefined&&configData?.configData?.max_power!=""){
    let values = JSON.parse(configData?.configData?.max_power)
      if(Array.isArray(values)){
        const configDataNew = {...configData?.configData}
        configDataNew.max_power = values[0];
        setConfigData((prevState)=>({...prevState,configData:configDataNew}))
      }
    }
    if (
      checkForDuplicateName(
        configData?.configData?.name,
        CBAssetList?.[2]?.configData?.name
      )
    ) {
      callSnackbar(
        `error`,
        `"${configData?.configData?.name}" already exists, please provide an unique name"`
      );
    } else {
      if (
        /^[a-zA-Z0-9-_& ]+$/.test(configData?.configData?.name)  &&
       
        // isValidName(configData?.configData?.name) &&
        ( 
          (parseInt(configData?.configData?.max_power) >=
            defaultsMinMax?.maxPowerBessMin &&
            parseInt(configData?.configData?.max_power) <=
              maxPowerBessMax)) &&
        parseInt(configData?.configData?.capacity) >=
          defaultsMinMax?.capacityBessMin &&
        parseInt(configData?.configData?.capacity) <=
          capacityBessMax &&
        parseInt(configData?.configData?.soc_max) >= parseInt(defaultsMinMax?.socMaxMin) &&
        parseInt(configData?.configData?.soc_max) <= parseInt(defaultsMinMax?.socMaxMax) &&
        parseInt(configData?.configData?.soc_min) >= parseInt(defaultsMinMax?.socMinMin) &&
        parseInt(configData?.configData?.soc_min) <= parseInt(defaultsMinMax?.socMinMax) &&
        (parseInt(configData?.configData?.SoC_min_optimization) > parseInt(configData?.configData?.soc_min)) &&
         (parseInt(configData?.configData?.SoC_min_optimization) < parseInt(defaultsMinMax?.socMinMax) )&&
         (  parseInt(configData?.configData?.SoC_min_optimization) < parseInt(defaultsMinMax?.socEmergencyDefault)) &&
         (parseInt(configData?.configData?.SoC_fallback) > parseInt(configData?.configData?.soc_min) && parseInt(configData?.configData?.SoC_fallback) < parseInt(configData?.configData?.soc_max)) &&
        (((siteType === embLabels.ISLANDABLE || siteType === embLabels.ISLANDABLE_GSX) &&(parseInt(configData?.configData?.soc_nominal_power) > parseInt(defaultsMinMax?.socEmergencyDefault)) && (parseInt(configData?.configData?.soc_nominal_power) > parseInt(defaultsMinMax?.socEssentialDefault)) && (parseInt(configData?.configData?.soc_nominal_power) < parseInt(configData?.configData?.soc_max)))
          || ((siteType === embLabels.GRID_CONNECTED || siteType === embLabels.GRID_CONNECTED_GSX) && ((parseInt(configData?.configData?.soc_nominal_power) > parseInt(configData?.configData?.soc_min)) &&  (parseInt(configData?.configData?.soc_nominal_power) < parseInt(configData?.configData?.soc_max))) ))   
        && (parseInt(configData?.configData?.soc_nominal_power) > 0 && parseInt(configData?.configData?.soc_nominal_power) <= 100) 
        ) {
        if( !deviceNameCheck &&( projectTypeValue === "DaaS ANSI" || projectTypeValue === "DaaS ETO")){
          callSnackbar(`error`, embLabels.mandatoryFields);
        }else{
          const configDataNew = {...configData?.configData}
          configDataNew.energyReserveRequired = isEnergyReserveSelected;
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_ASSET_CONFIG,
            payload: {
              selectedAsset: selectedValues?.selectedAsset,
              configData: configDataNew,
              isBessController: isBessController
            },
          });
  
          // newBatteryData[this.state.selectedAsset].communicationData =
          // Object.assign({}, this.state.batteryCommunicationData);
          if (duplicateUpdate.der === "") {
            setDuplicateUpdate({
              der: 2,
              load: "",
              pv: "",
              ev: "",
            });
          }
  
          updateDerHistory(2);
          updateDerStatus(2);
  
          const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
          setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
          sessionStorage.setItem("componentDataModified",true);
          callSnackbar("information", "Battery Configured Successfully");
        }
       
      }else if(((siteType !== embLabels.ISLANDABLE || siteType !== embLabels.ISLANDABLE_GSX) && !((parseInt(configData?.configData?.soc_nominal_power) > parseInt(defaultsMinMax?.socEmergencyDefault)) && (parseInt(configData?.configData?.soc_nominal_power) > parseInt(defaultsMinMax?.socEssentialDefault))))){
        callSnackbar(
          'error',
          `SOC Nominal should be greater than SOC B (${defaultsMinMax?.socEssentialDefault}) and SOC C (${defaultsMinMax?.socEmergencyDefault}), and less than ${configData?.configData?.soc_max} of Max power.`
        );
      }else if(((siteType !== embLabels.GRID_CONNECTED || siteType !== embLabels.GRID_CONNECTED_GSX) && !((parseInt(configData?.configData?.soc_nominal_power) > parseInt(configData?.configData?.soc_min)) && (parseInt(configData?.configData?.soc_nominal_power) < parseInt(configData?.configData?.soc_max))))){
        callSnackbar(
          'error',
          `SOC Nominal should be greater than SOC B (${defaultsMinMax?.socEssentialDefault}) and SOC C (${defaultsMinMax?.socEmergencyDefault}), and less than ${configData?.configData?.soc_max} of Max power.`
        );
      }else if(Number(configData?.configData?.SoC_fallback )< Number( configData?.configData?.soc_min) || Number(configData?.configData?.SoC_fallback) > Number(configData?.configData?.soc_max)){
        callSnackbar(
          'error',
          `SOC fallback should be greater than SOC Min Manufacturer(
                    ${configData?.configData?.soc_min}) and less than
                    ${configData?.configData?.soc_max} of SOC Max Manufacturer.`
        );
      }else if( parseInt(configData?.configData?.SoC_min_optimization) <=
              configData?.configData?.soc_min ||
              parseInt(configData?.configData?.SoC_min_optimization) >
                defaultsMinMax?.socMinMax ||
                parseInt(configData?.configData?.SoC_min_optimization) >
               defaultsMinMax?.socEmergencyDefault){
              callSnackbar(`error`,` SOC Min optimization should be greater than SOC Min Manufacturer(
                    ${configData?.configData?.soc_min}) and less than SOC Emergency (
                    ${defaultsMinMax?.socEmergencyDefault})`)
      }
      else if((parseInt(configData?.configData?.soc_nominal_power) < 1 || parseInt(configData?.configData?.soc_nominal_power) > 100) ){
        callSnackbar(`error`, embLabels.SOC_NOMINAL_RANGE);
      }
 else if (
        [
          configData?.configData?.name,
          configData?.configData?.max_power?.toString(),
          configData?.configData?.capacity?.toString(),
          configData?.configData?.soc_max?.toString(),
          configData?.configData?.soc_min?.toString(),
          configData?.configData?.soc_nominal_power?.toString(),
          
        ].includes("")
      ) {
        callSnackbar(`error`, embLabels.mandatoryFields);
      // } else if (!isValidName(configData?.configData?.name)) {
      //   callSnackbar("error", embLabels.notallowedAlphanumericValues);
      } else if (
        parseInt(configData?.configData?.max_power) <
          defaultsMinMax?.maxPowerBessMin ||
        parseInt(configData?.configData?.max_power) >
          maxPowerBessMax
      ) {
        callSnackbar(
          `error`,
          `${embLabels.maxPowerRange} ${embLabels.shouldBeInRangeOpen}${defaultsMinMax?.maxPowerBessMin}-${maxPowerBessMax}
           ${embLabels.kiloWatt}${embLabels.shouldBeInRangeClose}`
        );
      } else if (
        parseInt(configData?.configData?.capacity) <
          defaultsMinMax?.capacityBessMin ||
        parseInt(configData?.configData?.capacity) >
          capacityBessMax
      ) {
        callSnackbar(
          `error`,
          `${embLabels.capacity} ${embLabels.shouldBeInRangeOpen}${defaultsMinMax?.capacityBessMin}-${capacityBessMax}
           ${embLabels.kiloWattHour}${embLabels.shouldBeInRangeClose}`
        );
      } else if (
        parseInt(configData?.configData?.soc_max) < defaultsMinMax?.socMaxMin ||
        parseInt(configData?.configData?.soc_max) > defaultsMinMax?.socMaxMax
      ) {
        callSnackbar(
          `error`,
          `${embLabels.socMax} ${embLabels.shouldBeInRangeOpen}${defaultsMinMax?.socMaxMin}-${defaultsMinMax?.socMaxMax}
           ${embLabels.perentageOfMaxpower}${embLabels.shouldBeInRangeClose}`
        );
      } else if (
        parseInt(configData?.configData?.soc_min) < defaultsMinMax?.socMinMin ||
        parseInt(configData?.configData?.soc_min) > defaultsMinMax?.socMinMax
      ) {
        callSnackbar(
          `error`,
          `${embLabels.socMin} ${embLabels.shouldBeInRangeOpen}${defaultsMinMax?.socMinMin}-${defaultsMinMax?.socMinMax}
           ${embLabels.perentageOfMaxpower}${embLabels.shouldBeInRangeClose}`
        );
      } else {
        callSnackbar("error", embLabels.mandatoryFields);
      }
    }
  };

  const updateChpConfig = () => {
    if (
      checkForDuplicateName(
        configData?.configData?.name,
        CBAssetList[6]?.configData?.name
      )
    ) {
      callSnackbar(
        `error`,
        `"${configData?.configData?.name}" already exists, please provide an unique name"`
      );
    } else {
      if (
        /^[a-zA-Z0-9-_& ]+$/.test(configData?.configData?.name)  &&
        parseInt(configData?.configData?.nominal_power) >=
          defaultsMinMax?.chpNominalPowerMin &&
        parseInt(configData?.configData?.nominal_power) <=
          defaultsMinMax?.chpNominalPowerMax
      ) {
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_ASSET_CONFIG,
          payload: {
            selectedAsset: selectedValues?.selectedAsset,
            configData: configData?.configData,
          },
        });
        if (duplicateUpdate.der === "") {
          setDuplicateUpdate({
            der: 6,
            load: "",
            pv: "",
            ev: "",
          });
        }

        updateDerHistory(6);
        updateDerStatus(7);

        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "CHP Configured Successfully");
      } else if (
        configData?.configData?.name === "" ||
        configData?.configData?.nominal_power.toString() === ""
      ) {
        callSnackbar("error", embLabels.mandatoryFields);
      // } else if (!isValidName(configData?.configData?.name)) {
      //   callSnackbar("error", embLabels.notallowedAlphanumericValues);
      } else if (
        parseInt(configData?.configData?.nominal_power) <
          defaultsMinMax?.chpNominalPowerMin ||
        parseInt(configData?.configData?.nominal_power) >
          defaultsMinMax?.chpNominalPowerMax
      ) {
        callSnackbar(
          `error`,
          `${embLabels.nominalPowerRange}${embLabels.shouldBeInRangeOpen}${defaultsMinMax?.chpNominalPowerMin}-${defaultsMinMax?.chpNominalPowerMax}${embLabels.kiloWatt}${embLabels.shouldBeInRangeClose}
      `
        );
      } else {
        callSnackbar("error", embLabels.mandatoryFields);
      }
    }
  };

  const updateHybridConfig = () => {
    if (
      checkForDuplicateName(
        configData?.configData?.name,
        CBAssetList?.[7]?.configData?.name
      )
    ) {
      callSnackbar(
        "error",
        `"${configData?.configData?.name}" already exists, please provide an unique name`
      );
    } else {
      if (
        /^[a-zA-Z0-9-_& ]+$/.test(configData?.configData?.name) &&
        parseInt(configData?.configData?.max_capacity) >=
          defaultsMinMax?.hybridMaxCapacityMin &&
        parseInt(configData?.configData?.max_capacity) <=
          defaultsMinMax?.hybridMaxCapacityMax &&
        parseInt(configData?.configData?.capacity) >=
          defaultsMinMax?.hybridCapacityMin &&
        parseInt(configData?.configData?.capacity) <=
          defaultsMinMax?.hybridCapacityMax &&
        parseInt(configData?.configData?.max_solar_power) >=
          defaultsMinMax?.hybridMaxSolarPowerMin &&
        parseInt(configData?.configData?.max_solar_power) <=
          defaultsMinMax?.hybridMaxSolarPowerMax &&
        parseInt(configData?.configData?.max_inverter_output_power) >=
          defaultsMinMax?.hybridInverterPowerMin &&
        parseInt(configData?.configData?.max_inverter_output_power) <=
          defaultsMinMax?.hybridInverterPowerMax
      ) {
        //A2E getset configuration
        const gesetAssetConfigDataNew = Object.assign(
          {},
          CBAssetList?.[1]?.configData
        );
        if (CBAssetList?.[1]?.assetType === embLabels.GENSET) {
          CBAssetList?.[1]?.selectedAssetData?.assetAttributes &&
            CBAssetList?.[1]?.selectedAssetData?.assetAttributes?.forEach(
              (assetAttribute) => {
                if (assetAttribute.type === "gensetPower") {
                  gesetAssetConfigDataNew.max_power = assetAttribute.value;
                }
              }
            );
        }
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_ASSET_CONFIG,
          payload: {
            selectedAsset: 1,
            configData: gesetAssetConfigDataNew,
          },
        });
        const newConfigData = {...configData?.configData};
        const bessConfiguration = CBAssetList?.[selectedValues?.selectedAsset];
        newConfigData.model = bessConfiguration?.configData?.model;
        newConfigData.storage_capacity = bessConfiguration?.configData?.storage_capacity;
        newConfigData.corresponding_name_plate_capacity_value = bessConfiguration?.configData?.corresponding_name_plate_capacity_value;
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_ASSET_CONFIG,
          payload: {
            selectedAsset: selectedValues?.selectedAsset,
            configData: newConfigData,
          },
        });
        if (duplicateUpdate.der === "") {
          setDuplicateUpdate({
            der: 1,
            load: "",
            pv: "",
            ev: "",
          });
        }

        updateDerHistory(9);
        updateDerStatus(9);

        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "Hybrid Configured Successfully");
      } else if (
        configData?.configData?.name.toString() === "" ||
        configData?.configData?.max_capacity?.toString() === "" ||
        configData?.configData?.capacity?.toString() === "" ||
        configData?.configData?.max_solar_power?.toString() === "" ||
        configData?.configData?.max_inverter_output_power.toString() === ""
      ) {
        callSnackbar("error", embLabels.mandatoryFields);
      // } else if (!isValidName(configData?.configData?.name)) {
      //   callSnackbar("error", embLabels.notallowedAlphanumericValues);
      } else if (
        parseInt(configData?.configData?.max_capacity) <
          defaultsMinMax?.maxPowerGensetMin ||
        parseInt(configData?.configData?.max_capacity) >
          defaultsMinMax?.hybridMaxCapacityMax
      ) {
        callSnackbar(
          `error`,
          `Max battery capacity should be in range (${defaultsMinMax?.hybridMaxCapacityMin}-${defaultsMinMax?.hybridMaxCapacityMax} kW DC)`
        );
      } else if (
        parseInt(configData?.configData?.capacity) <
          defaultsMinMax?.hybridCapacityMin ||
        parseInt(configData?.configData?.capacity) >
          defaultsMinMax?.hybridCapacityMax
      ) {
        callSnackbar(
          `error`,
          `Capacity should be in range (${defaultsMinMax?.hybridCapacityMin}-${defaultsMinMax?.hybridCapacityMax} KWh)`
        );
      } else if (
        parseInt(configData?.configData?.max_solar_power) <
          defaultsMinMax?.hybridMaxSolarPowerMin ||
        parseInt(configData?.configData?.max_solar_power) >
          defaultsMinMax?.hybridMaxSolarPowerMax
      ) {
        callSnackbar(
          `error`,
          `Max Inverter output power (${defaultsMinMax?.hybridMaxSolarPowerMin}-${defaultsMinMax?.hybridMaxSolarPowerMax} kw AC)`
        );
      } else if (
        parseInt(configData?.configData?.max_inverter_output_power) <
          defaultsMinMax?.hybridInverterPowerMin ||
        parseInt(configData?.configData?.max_inverter_output_power) >
          defaultsMinMax?.hybridInverterPowerMax
      ) {
        callSnackbar(
          `error`,
          `Max Inverter output power (${defaultsMinMax?.hybridInverterPowerMin}-${defaultsMinMax?.hybridInverterPowerMax} kw AC)`
        );
      } else {
        callSnackbar("error", embLabels.mandatoryFields);
      }
    }
  };

  const arrayMaxPowerFinder = () => {
    switch (parseInt(selectedValues?.selectedPv)) {
      case 3:
        return PVDetails?.pvset1Data.reduce(
          (prev, cur) => prev + +cur.max_power,
          0
        );
      case 4:
        return PVDetails?.pvset2Data.reduce(
          (prev, cur) => prev + +cur.max_power,
          0
        );
      case 5:
        return PVDetails?.pvset3Data.reduce(
          (prev, cur) => prev + +cur.max_power,
          0
        );
      default:
        return 0;
    }
  };

  const updatePvArrayConfig = () => {
    const index = PVDetails?.selectSubPv - 1;
    const selectedPv = PVDetails?.selectedPv;
    //  const isUniqueName = prevPvGroupNames.includes(PVDetails.pvConfig.groupName);
    // if (isUniqueName) {
    //    PVDetailsDispatch({
    //         type: ACTIONS.CONFIGURE_PV_ARRAY,
    //         payload: {
    //           data: prevPvGroupNames[index],
    //         },
    //       });
    //       //  CBAssetListDispatch({
    //       //       type: ACTIONS.CONFIGURE_UPDATE_DER_PV_ARRAY,
    //       //       payload: {
    //       //         data: e.target.value,
    //       //         selectedPvArray:selectedValues?.selectedPv
    //       //       },
    //       //     })
    //       //     assetEditStatusUpdatePv( 
    //       //       e,
    //       //       true,
    //       //       PVDetails.selectedPv,
    //       //       PVDetails.selectSubPv
    //       //     );
    //    callSnackbar(
    //     `error`,
    //     `"${PVDetails.pvConfig.groupName}" already exists, please provide an unique name`
    //   );
      
    //   return;
    // }
    if (
      /^[a-zA-Z0-9-_& ]+$/.test(PVDetails?.pvConfig?.groupName) &&
      arrayMaxPowerFinder() < parseInt(PVDetails?.pvConfig?.group_max_power)
    ) {
      callSnackbar(
        "error",
        `Array Max Power should not exceed sum of all pv inverter max power.`
      );
    } else if (
      PVDetails?.pvConfig?.groupName &&
      parseInt(PVDetails?.pvConfig?.group_max_power) >= 0
    ) {
      // if (isValidName(PVDetails?.pvConfig?.groupName)) {
        PVDetailsDispatch({
          type: ACTIONS.UPDATE_PV_ARRAY,
        });
        CBAssetListDispatch({
          type:ACTIONS.UPDATE_DER_DATA_PV_CONFIRGURED,
          payload: { PVDetails },
        })

        updatePvHistory(index, selectedPv);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "PV Array Configured Successfully");
      // } else {
      //   callSnackbar("error", embLabels.notallowedAlphanumericValues);
      // }
    } else {
      callSnackbar("error", embLabels.mandatoryFields);
    }
  };

  const updatePvConfig = () => {
    const projectType = projectTypeValue
    const pvNumber = PVDetails?.selectedPv;
    let whichSubPv = PVDetails?.selectSubPv - 1;
    let removeName;

    switch (pvNumber) {
      case 3:
        removeName = PVDetails?.pvset1Data[whichSubPv]?.name;
        break;
      case 4:
        removeName = PVDetails?.pvset2Data[whichSubPv]?.name;
        break;
      case 5:
        removeName = PVDetails?.pvset3Data[whichSubPv]?.name;
        break;
      default:
        break;
    }

    if (checkForDuplicateName(PVDetails?.pvConfig?.name, removeName)) {
      callSnackbar(
        `error`,
        `"${PVDetails?.pvConfig.name}" already exists, please provide an unique name`
      );
    } else {
      if (
       (( projectType === "DaaS ANSI"|| projectType === "DaaS ETO" )&& /^[a-z0-9-_]+$/.test(PVDetails?.pvConfig?.name)) &&
        parseInt(PVDetails?.pvConfig?.max_power) >=
          defaultsMinMax?.maxPowerPvMin &&
        parseInt(PVDetails?.pvConfig?.max_power) <= defaultsMinMax?.maxPowerPvMax
      ) {
        setDuplicateUpdate({
          der: "",
          load: "",
          pv: "pv",
          ev: "",
        });
        PVDetailsDispatch({
          type: ACTIONS.UPDATE_PV_CONFIG_SAVE,
        });
        PVDetailsDispatch({
          type: ACTIONS.PV_CONFIGURED_STATUS,
        });

        updatePvHistory(PVDetails?.selectSubPv - 1, PVDetails?.selectedPv);
        updatePvHistoryGroupPower(PVDetails?.selectedPv);

        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "PV Configured Successfully");
      }else if(( (projectType !== "DaaS ANSI" ||projectType !== "DaaS ETO") && PVDetails?.pvConfig?.name) &&
      parseInt(PVDetails?.pvConfig?.max_power) >=
        defaultsMinMax?.maxPowerPvMin &&
      parseInt(PVDetails?.pvConfig?.max_power) <= defaultsMinMax?.maxPowerPvMax){

        setDuplicateUpdate({
          der: "",
          load: "",
          pv: "pv",
          ev: "",
        });
        PVDetailsDispatch({
          type: ACTIONS.UPDATE_PV_CONFIG_SAVE,
        });
        PVDetailsDispatch({
          type: ACTIONS.PV_CONFIGURED_STATUS,
        });

        updatePvHistory(PVDetails?.selectSubPv - 1, PVDetails?.selectedPv);
        updatePvHistoryGroupPower(PVDetails?.selectedPv);

        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "PV Configured Successfully");
      } 
       else if (
        PVDetails?.pvConfig?.name.toString() === "" ||
        PVDetails?.pvConfig?.max_power.toString() === ""
      ) {
        callSnackbar("error", embLabels.mandatoryFields);
      // } else if (!isValidName(PVDetails.pvConfig.name)) {
      //   callSnackbar("error", embLabels.notallowedAlphanumericValues);
      } else if (
        parseInt(PVDetails?.pvConfig?.max_power) < defaultsMinMax?.maxPowerPvMin ||
        parseInt(PVDetails?.pvConfig?.max_power) > defaultsMinMax?.maxPowerPvMax
      ) {
        callSnackbar(
          `error`,
          `Max Power should be in range(${defaultsMinMax?.maxPowerPvMin}-${defaultsMinMax?.maxPowerPvMax} kW)`
        );
      } else {
        callSnackbar("error", embLabels.mandatoryFields);
      }
    }
  };

  const updateLoadConfig = () => {
    const [powerIsBetween, nominalPowerMin, nominalPowerMax] =
      calculateMaxAvailableLoadPower();

    if (
      checkForDuplicateName(
        configData?.configData?.name,
        CBLoadList?.[selectedValues?.selectedLoad]?.configData?.name
      )
    ) {
      callSnackbar(
        `error`,
        `"${configData?.configData?.name}" already exists, please provide an unique name"`
      );
    }else if( CBLoadList?.[selectedValues?.selectedLoad]?.uiData?.contactor && configData?.contactorConfigData?.name === ""){
       callSnackbar("error", embLabels.mandatoryFields);
    } else {
      if (
        /^[a-zA-Z0-9-_& ]+$/.test(configData?.configData?.name) &&
        configData?.configData?.maximum_available_power?.toString().trim() &&
        powerIsBetween
      ) {
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_LOAD_CONFIG,
          payload: {
            selectedLoad: selectedValues?.selectedLoad,
            configData: configData?.configData,
          },
        });

        setDuplicateUpdate({
          der: "",
          load: selectedValues?.selectedLoad,
          pv: "",
          ev: "",
        });

        updateLoadHistory(selectedValues?.selectedLoad);
         if ( /^[a-zA-Z0-9-_& ]+$/.test(configData?.cbConfigData?.name)) {
           updateLoadCbConfigData();
           setIsOpenLoadConfig(false);
        } else {
         callSnackbar("error", embLabels.mandatoryFields);
         return;
       }
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        setIsOpenLoadConfig(false);
        // callSnackbar("information", "Load Configured Successfully");
      } else if (
        configData?.configData?.name === "" ||
        configData?.configData?.maximum_available_power?.toString() === ""
      ) {
        callSnackbar("error", embLabels.mandatoryFields);
      // } else if (!isValidName(configData?.configData?.name)) {
      //   callSnackbar("error", embLabels.notallowedAlphanumericValues);
      } else if (!powerIsBetween) {
        callSnackbar(
          `error`,
          `Maximum Available Power should be in range (${nominalPowerMin}-${nominalPowerMax} kW)`
        );
      } else {
        callSnackbar("error", embLabels.mandatoryFields);
      }
    }
    checkAssetStatus();
  };

  const updateEvConfig = () => {
    if (
      checkForDuplicateName(
        configData?.configData?.name,
        CBEVList[0]?.configData?.name
      )
    ) {
      callSnackbar(
        `error`,
        `"${configData?.configData?.name}" already exists, please provide an unique name`
      );
    } else {
      if (
        /^[a-zA-Z0-9-_& ]+$/.test(configData?.configData?.name) &&
        parseInt(configData?.configData?.maximum_available_power) >=
          defaultsMinMax?.maxPowerEvMin &&
        parseInt(configData?.configData?.maximum_available_power) <=
          defaultsMinMax?.maxPowerEvMax
      ) {
        CBEVListDispatch({
          type: ACTIONS.UPDATE_EV_CONFIG,
          payload: {
            selectedEv: selectedValues?.selectedEv,
            configData: configData?.configData,
          },
        });
        setDuplicateUpdate({
          der: "",
          load: "",
          pv: "",
          ev: selectedValues?.selectedEv,
        });
        updateDerHistory(5);
        updateDerStatus(5);

        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "EV Configured Successfully");
      } else if (
        configData?.configData?.name === "" ||
        configData?.configData?.maximum_available_power.toString() === ""
      ) {
        callSnackbar("error", embLabels.mandatoryFields);
      // } else if (!isValidName(configData?.configData?.name)) {
      //   callSnackbar("error", embLabels.notallowedAlphanumericValues);
      } else if (
        parseInt(configData?.configData?.maximum_available_power) <
          defaultsMinMax?.maxPowerEvMin ||
        parseInt(configData?.configData?.maximum_available_power) >
          defaultsMinMax?.maxPowerEvMax
      ) {
        callSnackbar(
          `error`,
          `Maximum Available Power should be in range (${defaultsMinMax?.maxPowerEvMin}-${defaultsMinMax?.maxPowerEvMax} kW)`
        );
      } else {
        callSnackbar("error", embLabels.mandatoryFields);
      }
    }
  };

  const updateCbConfigData = () => {
    const projectType = projectTypeValue
    if (/^[a-z0-9-_]+$/.test(configData?.cbConfigData?.name) && (projectType === "DaaS ANSI" || projectType === "DaaS ETO")) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CB_CONFIG,
        payload: {
          selectedAssetCB: selectedValues?.selectedAssetCB,
          cbConfigData: configData?.cbConfigData,
        },
      });
      if (
        configData?.contactorConfigData.name &&
        [embLabels.GRID_CONNECTED,embLabels.ISLANDABLE].includes(siteType) &&
        clientType === embLabels.GENERIC_PROJECT
        &&
        CBAssetList[selectedValues?.selectedAssetCB]?.uiData?.contactor
      ) {
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG,
          payload: {
            selectedAssetCB: selectedValues?.selectedAssetCB,
            cbConfigData: configData?.contactorConfigData,
            checked: CBAssetList[selectedValues?.selectedAssetCB]?.uiData?.contactor
          },
        });
      }
      if(configData?.cbConfigData.contactor&&configData?.contactorConfigData.name&&configData?.cbConfigData.name){
        updateAssetCbHistory(selectedValues?.selectedAssetCB);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "Circuit Breaker Configured Successfully");
      }else if(configData?.cbConfigData.motorized&&configData?.cbConfigData.name){
        updateAssetCbHistory(selectedValues?.selectedAssetCB);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "Circuit Breaker Configured Successfully");
      }else if(configData?.cbConfigData.name){
        updateAssetCbHistory(selectedValues?.selectedAssetCB);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "Circuit Breaker Configured Successfully");
      }else{
        callSnackbar(`error`,embLabels.mandatoryFields);
      }
    }else if (/^[a-zA-Z0-9-_& ]+$/.test(configData?.cbConfigData?.name) &&( projectType !== "DaaS ANSI" || projectType !== "DaaS ETO")) {
      if(configData?.cbConfigData?.contactor && configData?.contactorConfigData?.name === ""){
        callSnackbar(`error`,embLabels.mandatoryFields);
        return ;
      }
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CB_CONFIG,
        payload: {
          selectedAssetCB: selectedValues?.selectedAssetCB,
          cbConfigData: configData?.cbConfigData,
        },
      });
      if (
        configData?.contactorConfigData?.name &&
        [embLabels.GRID_CONNECTED,embLabels.ISLANDABLE].includes(siteType) &&
        clientType === embLabels.GENERIC_PROJECT
        &&
        CBAssetList?.[selectedValues?.selectedAssetCB]?.uiData?.contactor
      ) {
        CBAssetListDispatch({
          type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG,
          payload: {
            selectedAssetCB: selectedValues?.selectedAssetCB,
            cbConfigData: configData?.contactorConfigData,
            checked: CBAssetList?.[selectedValues?.selectedAssetCB]?.uiData?.contactor
          },
        });
      }
      if(configData?.cbConfigData?.contactor&&configData?.contactorConfigData?.name&&configData?.cbConfigData?.name){
        updateAssetCbHistory(selectedValues?.selectedAssetCB);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "Circuit Breaker Configured Successfully");
      }else if(configData?.cbConfigData?.motorized&&configData?.cbConfigData?.name){
        updateAssetCbHistory(selectedValues?.selectedAssetCB);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "Circuit Breaker Configured Successfully");
      }
      else if(!configData?.cbConfigData?.contactor && !configData?.cbConfigData?.motorized){
        updateAssetCbHistory(selectedValues?.selectedAssetCB);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "Circuit Breaker Configured Successfully");
      }
      else{
        callSnackbar(`error`,embLabels.mandatoryFields);
      }
    } else {
      callSnackbar("error", embLabels.mandatoryFields);
    }
  };

  const updateCbContactorConfigData = () => {
    if (configData?.contactorConfigData?.name) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG,
        payload: {
          selectedAssetCB: selectedValues?.selectedAssetCB,
          cbConfigData: configData?.contactorConfigData,
        },
      });

      updateAssetCbHistory(selectedValues?.selectedAssetCB);

      updateCbConfigData();
    } else {
      callSnackbar("error", embLabels.mandatoryFields);
    }
  };

  const updateEvCbConfigData = () => {
    if (/^[a-zA-Z0-9-_& ]+$/.test(configData?.cbConfigData?.name)) {
      CBEVListDispatch({
        type: ACTIONS.UPDATE_EV_CB_CONFIG,
        payload: {
          selectedEvCB: selectedValues?.selectedEvCB,
          cbConfigData: configData?.cbConfigData,
        },
      });
      if (
        configData?.contactorConfigData.name 
      ) {
        CBEVListDispatch({
          type: ACTIONS.UPDATE_CB_CONTACTOR_CONFIG_DATA,
          payload: {
            index: selectedValues?.selectedEvCB,
            CBContactor: configData?.contactorConfigData,
            defaultContactor: configData?.contactorConfigData,
            checked: CBEVList[selectedValues?.selectedEvCB]?.uiData?.contactor,
          },
        });
      }
      if(configData?.cbConfigData?.contactor&&configData?.contactorConfigData?.name&&configData?.cbConfigData?.name){
        updateAssetCbHistory(selectedValues?.selectedAssetCB);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        callSnackbar("information", "Circuit Breaker Configured Successfully");
      }else if(configData?.cbConfigData?.motorized&&configData?.cbConfigData?.name){
        updateAssetCbHistory(selectedValues?.selectedAssetCB);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        callSnackbar("information", "Circuit Breaker Configured Successfully");
      }else if(configData?.cbConfigData?.name){
        updateAssetCbHistory(selectedValues?.selectedAssetCB);
        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
        sessionStorage.setItem("componentDataModified",true);
        callSnackbar("information", "Circuit Breaker Configured Successfully");
      }else{
        callSnackbar(`error`,embLabels.mandatoryFields);
      }
    } else {
      callSnackbar("error", embLabels.mandatoryFields);
    }
  };

  const updateLoadCbConfigData = () => {
    if ( /^[a-zA-Z0-9-_& ]+$/.test(configData?.cbConfigData?.name)) {
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_LOAD_CB_CONFIG,
        payload: {
          selectedLoadCB: selectedValues?.selectedLoad,
          cbConfigData: configData?.cbConfigData,
        },
      });

      updateLoadCbHistory(selectedValues?.selectedLoad);

      const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
      setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      sessionStorage.setItem("componentDataModified",true);
      
      // callSnackbar("information", "Circuit Breaker Configured Successfully");
      callSnackbar("information", " Load Configured Successfully");

     
    } else {
      callSnackbar("error", embLabels.mandatoryFields);
   
    }
  };
  const updateRemoteLoadCbConfigData = () => {
    if ( /^[a-zA-Z0-9-_& ]+$/.test(configData?.cbConfigData?.name)) {
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_LOAD_CB_CONFIG,
        payload: {
          selectedLoadCB: selectedValues?.selectedLoadCB,
          cbConfigData: configData?.cbConfigData,
        },
      });

      updateLoadCbHistory(selectedValues?.selectedLoadCB);

      const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
      setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      sessionStorage.setItem("componentDataModified",true);
      // callSnackbar("information", "Circuit Breaker Configured Successfully");
      callSnackbar("information", " Load Configured Successfully");

     
    } else {
      callSnackbar("error", embLabels.mandatoryFields);
    }
  };
  const updatePowerMeterData = () => {
    const projectType = projectTypeValue
    if(/^[a-z0-9-_]+$/.test(configData?.cbConfigData?.name) &&( projectType === "DaaS ANSI" ||  projectType === "DaaS ETO")){
      if (selectedValues?.selectedAssetPM !== "") {
        if (detailsBlock.existingPmAssetDetailsBlockGrid) {
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_EXISTING_POWERMETER_CONFIG,
            payload: {
              selectedAssetPM: selectedValues?.selectedAssetPM,
              cbConfigData: configData?.cbConfigData,
            },
          });
        } else {
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_POWERMETER_CONFIG,
            payload: {
              selectedAssetPM: selectedValues?.selectedAssetPM,
              cbConfigData: configData?.cbConfigData,
            },
          });
        }

        updateAssetPmHistory(selectedValues?.selectedAssetPM);
      }
      if (selectedValues?.selectedEvPM !== "") {
        CBEVListDispatch({
          type: ACTIONS.UPDATE_EV_POWERMETER_CONFIG,
          payload: {
            selectedAssetPM: selectedValues?.selectedEvPM,
            cbConfigData: configData?.cbConfigData,
          },
        });

        updateEvPmHistory(selectedValues?.selectedEvPM);
      }

      if(selectedValues?.selectedLoadPM!=="" ){
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_LOAD_POWERMETER_CONFIG,
          payload: {
            selectedAssetPM: selectedValues?.selectedLoadPM,
            cbConfigData: configData?.cbConfigData,
          },
        });
      }

      const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
      setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      sessionStorage.setItem("componentDataModified",true);
      callSnackbar("information", "Power Meter Configured Successfully");
    }else if ( /^[a-zA-Z0-9-_& ]+$/.test(configData?.cbConfigData?.name) && (projectType !== "DaaS ANSI" || projectType !== "DaaS ETO")) {
      if (selectedValues?.selectedAssetPM !== "") {
        if (detailsBlock.existingPmAssetDetailsBlockGrid) {
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_EXISTING_POWERMETER_CONFIG,
            payload: {
              selectedAssetPM: selectedValues?.selectedAssetPM,
              cbConfigData: configData?.cbConfigData,
            },
          });
        } else {
          CBAssetListDispatch({
            type: ACTIONS.UPDATE_POWERMETER_CONFIG,
            payload: {
              selectedAssetPM: selectedValues?.selectedAssetPM,
              cbConfigData: configData?.cbConfigData,
            },
          });
        }

        updateAssetPmHistory(selectedValues?.selectedAssetPM);
      }
      if (selectedValues?.selectedEvPM !== "") {
        CBEVListDispatch({
          type: ACTIONS.UPDATE_EV_POWERMETER_CONFIG,
          payload: {
            selectedAssetPM: selectedValues?.selectedEvPM,
            cbConfigData: configData?.cbConfigData,
          },
        });

        updateEvPmHistory(selectedValues?.selectedEvPM);
      }

      if(selectedValues?.selectedLoad!==""){
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_LOAD_POWERMETER_CONFIG,
          payload: {
            selectedAssetPM: selectedValues?.selectedLoad,
            cbConfigData: configData?.cbConfigData,
          },
        });
      } else if(selectedValues?.selectedLoadPM!=="" ){
        CBLoadListDispatch({
          type: ACTIONS.UPDATE_LOAD_POWERMETER_CONFIG,
          payload: {
            selectedAssetPM: selectedValues?.selectedLoadPM,
            cbConfigData: configData?.cbConfigData,
          },
        });
      }


      const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
      setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
      sessionStorage.setItem("componentDataModified",true);
      callSnackbar("information", "Power Meter Configured Successfully");
    } else {
      callSnackbar("error", embLabels.mandatoryFields);
    }
  };

  const updateLoadCbPm = ()=>{
    if(CBLoadList[selectedValues?.selectedLoad]?.uiData?.contactor && CBLoadList[selectedValues?.selectedLoad]?.contactorConfigData?.name ==="") {
      callSnackbar(`error`,"Contactor Name is mandatory for contactor type circuit breaker");
      return;
    }
    updateLoadConfig(); 
    // setIsOpenLoadConfig(false);
  }
  const pv1SelectHandler = () => {
    if (UserScope.access.saveSLD) {
      assetDetailsReset();
      const assetBlock = "assetPvDetailsBlock";
      const selectedAssetValue = "selectedPv";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_SELECT,
        payload: {
          index: 3,
        },
      });
      selectedValuesHandler(3, selectedAssetValue, assetBlock);
      selectedSubPvHandler(1);
      PVDetailsDispatch({
        type: ACTIONS.PV_SELECT,
        payload: {
          selectedPv: 3,
          selectSubPv: 1,
          externalId: gsxExternalId?.pvAssetExternalId["4"],
        },
      });
      selectedAssetHandlerPv(3, 1);
      PVDetailsDispatch({
        type: ACTIONS.PV_CONFIGURED_STATUS,
      });
      PVDetailsDispatch({
        type: ACTIONS.PV_CONFIG_DATA,
      });
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const pv2SelectHandler = () => {
    if (UserScope.access.saveSLD) {
      assetDetailsReset();
      const assetBlock = "assetPvDetailsBlock";
      const selectedAssetValue = "selectedPv";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_SELECT,
        payload: {
          index: 4,
        },
      });
      selectedValuesHandler(4, selectedAssetValue, assetBlock);
      selectedSubPvHandler(1);
      PVDetailsDispatch({
        type: ACTIONS.PV_SELECT,
        payload: {
          selectedPv: 4,
          selectSubPv: 1,
        },
      });
      selectedAssetHandlerPv(4, 1);
      PVDetailsDispatch({
        type: ACTIONS.PV_CONFIGURED_STATUS,
      });
      PVDetailsDispatch({
        type: ACTIONS.PV_CONFIG_DATA,
      });
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const pv3SelectHandler = () => {
    if (UserScope.access.saveSLD) {
      assetDetailsReset();
      const assetBlock = "assetPvDetailsBlock";
      const selectedAssetValue = "selectedPv";
      CBAssetListDispatch({
        type: ACTIONS.ASSET_SELECT,
        payload: {
          index: 5,
        },
      });
      selectedValuesHandler(5, selectedAssetValue, assetBlock);
      selectedSubPvHandler(1);
      PVDetailsDispatch({
        type: ACTIONS.PV_SELECT,
        payload: {
          selectedPv: 5,
          selectSubPv: 1,
        },
      });
      selectedAssetHandlerPv(5, 1);
      PVDetailsDispatch({
        type: ACTIONS.PV_CONFIGURED_STATUS,
      });
      PVDetailsDispatch({
        type: ACTIONS.PV_CONFIG_DATA,
      });
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const checkForDuplicateName = (name, currentName) => {
    const ALLNAMES = getAllNames();
    const OTHERNAMES = ALLNAMES?.filter((name) => name !== currentName);

    if (OTHERNAMES.indexOf(name.trim()) !== -1) {
      return true;
    } else {
      return false;
    }
  };

  const getAllNames = () => {
    const ASSETNAMES = CBAssetList.map(
      (assetName) => assetName?.configData?.name
    )?.filter((name) => name !== "");
    const LOADNAME = CBLoadList.map((loadNames) => loadNames?.configData?.name);
    const EVNAMES = CBEVList?.filter((ev) => ev.uiData.status).map(
      (ev) => ev.configData?.name
    );
    const PV1NAME = PVDetails?.pvset1Data.map((pv1names) => pv1names.name);
    const PV2NAME = PVDetails?.pvset2Data.map((pv2names) => pv2names.name);
    const PV3NAME = PVDetails?.pvset3Data.map((pv3names) => pv3names.name);
    return [
      ...ASSETNAMES,
      ...PV1NAME,
      ...PV2NAME,
      ...PV3NAME,
      ...LOADNAME,
      ...EVNAMES,
    ];
  };

  //* add assets start

  const addGensetVerify = () => {
    if (siteType === embLabels.GRID_CONNECTED) {
      callSnackbar(
        `error`,
        `'Always Grid connected' usecase doesn't need Genset system.`
      );
    } else {
      if (useCaseValidGenset) {
        
        // setLoading(true);
        setTimeout(() => {
          addGenset();
        }, 800);
       
      } else {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'BESS Main No Genset' usecase doesn't need Genset system.`
        );
      }
    }
  };

  const addGenset = () => {
    if (UserScope.access.saveSLD) {
      if (checkSLDCount()) {
        if (!CBAssetList[1].uiData.status) {
          assetDetailsReset();
          CBAssetListDispatch({
            type: ACTIONS.ADD_GENSET,
            payload: {
              defaultPreFill: defaultPreFillData[0],
              configData: configData,
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
              defaultPmData: defaultPmData,
              gensetData: gensetAssetData,
              projectKind: projectKind,
              projectTypeValue
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          const runCalculateCoordinatesNew = { componentPush: true };

          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);
          sessionStorage.setItem("componentDataModified",true);
          setLoading(false);
        } else {
          setLoading(false);
          callSnackbar(`error`, `Max one genset is allowed`);
        }
      } else {
        setLoading(false);
        callSnackbar(`error`, `Max 24 circuit breakers are allowed`);
      }
    } else {
      setLoading(false);
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addBattery = () => {
    if (UserScope.access.saveSLD) {
      if (checkSLDCount()) {
        if (!CBAssetList[2].uiData.status) {
          assetDetailsReset();

          CBAssetListDispatch({
            type: ACTIONS.ADD_BESS,
            payload: {
              defaultPreFill: defaultPreFillData[0],
              configData: configData,
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          const runCalculateCoordinatesNew = { componentPush: true };
          sessionStorage.setItem("componentDataModified",true);
          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);

          // this.setState({
          //   batteryCommunicationData: newBatteryData[2].communicationData,
          // });
        } else {
          callSnackbar(`error`, `Max one battery is allowed`);
        }
      } else {
        callSnackbar(`error`, `Max 24 circuit breakers are allowed`);
      }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addPv = () => {
    if (UserScope.access.saveSLD) {
      PVDetailsDispatch({
        type: ACTIONS.ADD_PV_EQUIPMENT,
        payload: {
          CBAssetList: CBAssetList,
        },
      });
      sessionStorage.setItem("componentDataModified",true);
      // const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
      //   setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addPVSetWithCB = () => {
    setConsiderSelected(false)
    const projectType = projectTypeValue
    if (PVDetails?.pvCount) {
      let overLoadAsset = 0;
      let overLoadPvCB = 1;
      let selectedPv = 3;

      if (PVDetails?.existOrNew === "new") {
        if (checkSLDCount()) {
          overLoadAsset = 1;

          if (!CBAssetList[3]?.uiData?.status) {
            selectedPv = 3;
          } else if (!CBAssetList[4]?.uiData?.status) {
            selectedPv = 4;
          } else if (
            !CBAssetList[5]?.uiData?.status &&
            projectType !== "DaaS IEC"
          ) {
            selectedPv = 5;
          } else {
            overLoadPvCB = 0;
          }
        } else {
          overLoadAsset = 0;
        }
      } else if (PVDetails?.existOrNew === "exist") {
        overLoadAsset = 1;
        selectedPv = parseInt(PVDetails?.branchName);
      }

      //* selected pv is  1
      if (selectedPv === 3) {
        assetDetailsReset();
        if (overLoadAsset && overLoadPvCB) {
          CBAssetListDispatch({
            type: ACTIONS.ADD_PV_TO_CBASSET_LIST,
            payload: {
              selectedPv: selectedPv,
              PVDetails: PVDetails,
              configData: configData,
              preFillDefault: defaultPreFillData[0],
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
              projectTypeValue,
              siteType
            },
          });
          if (PVDetails?.existOrNew === "new") {
            countDispatch({
              type: ACTIONS.UPDATE_DER_COUNT,
              payload: { count: 1 },
            });
          }

          const externalIds = JSON.parse(sessionStorage.getItem("externalId"));
          PVDetailsDispatch({
            type: ACTIONS.CONFIRM_ADD_PV_WITH_CB,
            payload: {
              selectedPv: selectedPv,
              externalId:
                externalIds[
                  Math.floor(generateRandom()* (externalIds.length - 11) + 11)
                ],
            },
          });

          const runCalculateCoordinatesNew = { componentPush: true };

          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);
          sessionStorage.setItem("componentDataModified",true);
        } else {
          if ((clientType === "GREENSTRUXURE" || clientType === "GENERIC") && checkSLDCount()) {
            if (projectType === "DaaS IEC") {
              callSnackbar(
                "error",
                `Max 2 circuit breakers are allowed for photovoltaic`
              );
            } else {
              callSnackbar(
                "error",
                `Max 3 circuit breakers are allowed for photovoltaic`
              );
            }
          } else {
            callSnackbar("error", "Max 24 circuit breakers are allowed");
          }
          PVDetailsDispatch({
            type: ACTIONS.RESET_PV_DETAILS,
          });
        }
      }

      //* selected pv is 2
      else if (selectedPv === 4) {
        assetDetailsReset();
        if (overLoadAsset && overLoadPvCB) {
          CBAssetListDispatch({
            type: ACTIONS.ADD_PV_TO_CBASSET_LIST,
            payload: {
              selectedPv: selectedPv,
              PVDetails: PVDetails,
              configData: configData,
              preFillDefault: defaultPreFillData[0],
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
              projectTypeValue,
              siteType,
            },
          });
          if (PVDetails?.existOrNew === "new") {
            countDispatch({
              type: ACTIONS.UPDATE_DER_COUNT,
              payload: { count: 1 },
            });
          }
          const externalIds = JSON.parse(sessionStorage.getItem("externalId"));
          PVDetailsDispatch({
            type: ACTIONS.CONFIRM_ADD_PV_WITH_CB,
            payload: {
              selectedPv: selectedPv,
              externalId:
                externalIds?.[
                  Math.floor(generateRandom() * (externalIds?.length - 11) + 11)
                ],
            },
          });
          const runCalculateCoordinatesNew = { componentPush: true };

          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);
          sessionStorage.setItem("componentDataModified",true);
        } else {
          if (!overLoadPvCB) {
            callSnackbar(
              "error",
              `Max 3 circuit breakers are allowed for photovoltaic`
            );
          } else {
            callSnackbar("error", "Max 24 circuit breakers are allowed");
          }
          PVDetailsDispatch({
            type: ACTIONS.RESET_PV_DETAILS,
          });
        }
      }

      //* selected pv is 3
      else if (selectedPv === 5) {
        assetDetailsReset();
        if (overLoadAsset && overLoadPvCB) {
          CBAssetListDispatch({
            type: ACTIONS.ADD_PV_TO_CBASSET_LIST,
            payload: {
              selectedPv: selectedPv,
              PVDetails: PVDetails,
              configData: configData,
              preFillDefault: defaultPreFillData[0],
              count: count,
              cbCommunicationValues: cbCommunicationValues,
              defaultCbData: defaultCbData,
              projectTypeValue,
              siteType
            },
          });
          if (PVDetails?.existOrNew === "new") {
            countDispatch({
              type: ACTIONS.UPDATE_DER_COUNT,
              payload: { count: 1 },
            });
          }
          const externalIds = JSON.parse(sessionStorage.getItem("externalId"));
          PVDetailsDispatch({
            type: ACTIONS.CONFIRM_ADD_PV_WITH_CB,
            payload: {
              selectedPv: selectedPv,
              externalId:
              externalIds[
                Math.floor(generateRandom() * (externalIds.length - 11) + 11)
              ],
            },
          });

          const runCalculateCoordinatesNew = { componentPush: true };

          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);
          sessionStorage.setItem("componentDataModified",true);
        } else {
          if (!overLoadPvCB) {
            callSnackbar(
              "error",
              `Max 3 circuit breakers are allowed for photovoltaic`
            );
          } else {
            callSnackbar("error", "Max 24 circuit breakers are allowed");
          }
          PVDetailsDispatch({
            type: ACTIONS.RESET_PV_DETAILS,
          });
        }
      }
    }
    setIsAssetConfigChanged(configData);
    
  };

  const addCHPVerify = () => {
    if (!defaultPreFillData[1].remoteMonitoringControl) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Remote monitoring control is required for CHP.`
      );
    } else {
      addCHP();
      sessionStorage.setItem("componentDataModified",true);
    }
  };

  const addCHP = () => {
    if (UserScope.access.saveSLD) {
      if (checkSLDCount()) {
        if (!CBAssetList[6]?.uiData?.status) {
          assetDetailsReset();

          CBAssetListDispatch({
            type: ACTIONS.ADD_CHP,
            payload: {
              defaultPreFill: defaultPreFillData[0],
              configData: configData,
              siteType,
            },
          });
          countDispatch({
            type: ACTIONS.UPDATE_DER_COUNT,
            payload: { count: 1 },
          });

          const runCalculateCoordinatesNew = { componentPush: true };

          setTimeout(() => {
            setRunCalculateCoordinates(runCalculateCoordinatesNew);
          }, 100);
          sessionStorage.setItem("componentDataModified",true);
        } else {
          callSnackbar(`error`, `Max one CHP is allowed`);
        }
      } else {
        callSnackbar(`error`, `Max 24 circuit breakers are allowed`);
      }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addLoad = () => {
    if (UserScope.access.saveSLD) {
      if(checkSLDCount()){
      // if (siteType === embLabels.GRID_CONNECTED) {
      //   callSnackbar(
      //     `error`,
      //     `More than one Load is not allowed in Grid Connected use case.`
      //   );
      // } else 
      if (count.loadCount + count.evCount >= 24) {
        callSnackbar("error", "Max 24 loads are allowed");
      } else if (
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        siteType === embLabels.ISLANDABLE_GSX &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1]?.mode === "FUEL_SAVER" &&
        count.loadCount + count.evCount >= 24
      ) {
        callSnackbar("error", "Max 24 loads are allowed");
      } else {
        if (checkSLDCount()) {
          if (count.loadCount + count.evCount < 24) {
            countDispatch({
              type: ACTIONS.UPDATE_LOAD_COUNT,
              payload: { count: 1 },
            });
            CBLoadListDispatch({
              type: ACTIONS.ADD_LOAD,
              payload: {
                defaultPreData: defaultPreFillData[0],
                count: count,
                cbCommunicationValues: cbCommunicationValues,
                defaultCbData: defaultCbData,
                siteType: siteType,
                pmAssetData: defaultPmData,
                contactor: evContactorData,
               defaults: (projectKind?.defaults && Object.keys(projectKind.defaults).length > 0)? projectKind.defaults: defaultPreFillData[2],
               projectTypeValue: projectTypeValue,
                cb_Load: cbLoadData,
              },
            });
            CBLoadListDispatch({
              type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
              payload: {
                coordinates: coordinates,
                loadSide:loadSide,
                count: count,
                siteType: siteType,
                defaultCbData: defaultCbData,
                projectKind: projectKind,
                switchboardType: switchboardType,
                cb_Load: cbLoadData,
              },
            });

            const runCalculateCoordinatesNew = { componentPush: true };

            setTimeout(() => {
              setRunCalculateCoordinates(runCalculateCoordinatesNew);
            }, 100);
            sessionStorage.setItem("componentDataModified",true);
          }
        } else {
          callSnackbar(`error`, `Max 24 circuit breakers are allowed`);
        }
      }
    }else{
      callSnackbar(`error`, `Max 24 circuit breakers are allowed`);
    }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addRemoteLoad = () => {
    if (UserScope.access.saveSLD) {
        if (checkSLDCount()) {
          if (count.remoteLoadCount<=4) {
            countDispatch({
              type: ACTIONS.UPDATE_REMOTE_LOAD_COUNT,
              payload: { count: 1 },
            });
            CBLoadListDispatch({
              type: ACTIONS.ADD_REMOTE_LOAD,
              payload: {
                defaultPreData: defaultPreFillData[0],
                count: count,
                cbCommunicationValues: cbCommunicationValues,
                defaultCbData: defaultCbData,
                siteType: siteType,
                pmAssetData: defaultPmData,
                cb_Load: cbLoadData,
                projectTypeValue: projectTypeValue
              },
            });
            CBLoadListDispatch({
              type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
              payload: {
                coordinates: coordinates,
                loadSide:loadSide,
                count: count,
                siteType: siteType,
                defaultCbData: defaultCbData,
                projectKind: projectKind,
                switchboardType: switchboardType,
              },
            });

            const runCalculateCoordinatesNew = { componentPush: true };

            setTimeout(() => {
              setRunCalculateCoordinates(runCalculateCoordinatesNew);
            }, 100);
            sessionStorage.setItem("componentDataModified",true);
        } else {
          callSnackbar(`error`, `Max 24 circuit breakers are allowed`);
        }
      }else{
      callSnackbar(`error`, `Max 24 circuit breakers are allowed`);
    }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  }


  const addEv = () => {
    if (UserScope.access.saveSLD) {
      if (count.loadCount + count.evCount >= 24) {
        callSnackbar("error", "Max 24 loads are allowed");
      } else if(count.loadCount==24 &&(projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland)){
        callSnackbar("error", "Please remove one load to add EV");
      }else {
        if (checkSLDCount()) {
          if (!CBEVList[0].uiData.status) {
            assetDetailsReset();

            CBEVListDispatch({
              type: ACTIONS.ADD_EV,
              payload: {
                defaultPreFill: defaultPreFillData[0],
                configData: configData,
                count: count,
                cbCommunicationValues: cbCommunicationValues,
                defaultCbData,
                contactor : evContactorData,
                ev: evDefaultData,
                pmEV: evPMData,
               defaults: (projectKind?.defaults && Object.keys(projectKind.defaults).length > 0)? projectKind.defaults: defaultPreFillData[2],
                isEvce:isEvce
              },
            });

            countDispatch({
              type: ACTIONS.UPDATE_EV_COUNT,
              payload: { count: 1 },
            });

            const runCalculateCoordinatesNew = { componentPush: true };

            setTimeout(() => {
              setRunCalculateCoordinates(runCalculateCoordinatesNew);
            }, 100);
            sessionStorage.setItem("componentDataModified",true);
          } else {
            callSnackbar("error", "Max one EV is allowed");
          }
        } else {
          callSnackbar(`error`, `Max 24 circuit breakers are allowed`);
        }
      }
    } else {
      callSnackbar(
        `error`,
        `${UserScope.role} is not authorized to perform action on this page`
      );
    }
  };

  const addTransferSwitch = () =>
    setAlertMessage(
      `Alert`,
      false,
      ``,
      `Contact SE representative in order to integrate external transfer switch.`
    );

  //* add assets end

  //* remove assets start

  const checkGensetRemoveCondition = () => {
    if (defaultPreFillData[1].mode === "FUEL_SAVER") {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'Genset main, BESS grid tied' usecase requires a generator.`
      );
    } else {
      removeGenset();
    }
  };

  const removeGenset = () => {
    CBAssetListDispatch({
      type: ACTIONS.REMOVE_ASSET_DER,
      payload: {
        index: 1,
        configData,
      },
    });
    setDetailsBlock((prevState) => ({
      ...prevState,
      assetGensetDetailsBlock: false,
    }));
    countDispatch({
      type: ACTIONS.UPDATE_DER_COUNT,
      payload: { count: -1 },
    });

    updateDerHistory(1);
    updateDerStatus(1);
    updateAssetCbHistory(1);

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  const checkBatteryRemoveCondition = () => {
    if (siteType === embLabels.GRID_CONNECTED) {
      // if (!defaultPreFillData[1].exportOptimization) {
      //   removeBattery();
      // } else {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Export management predictive optimization requires a battery system.`
      );
      // }
    } else {
      if (defaultPreFillData[1].mode === "NO_FUEL") {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'BESS main, No Genset' usease requires a battery system. `
        );
      } else if (defaultPreFillData[1].mode === "FUEL_ERASER") {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'BESS main, Genset as backup' usease requires a battery system.`
        );
      } else {
        if (!defaultPreFillData[1].exportOptimization) {
          removeBattery();
        } else {
          setAlertMessage(
            `Alert`,
            false,
            ``,
            `Export management predictive optimization requires a battery system.`
          );
        }
      }
    }
  };

  const removeBattery = () => {
    CBAssetListDispatch({
      type: ACTIONS.REMOVE_ASSET_DER,
      payload: {
        index: 2,
        configData,
      },
    });

    setDetailsBlock((prevState) => ({
      ...prevState,
      assetBatteryDetailsBlock: false,
    }));

    countDispatch({
      type: ACTIONS.UPDATE_DER_COUNT,
      payload: { count: -1 },
    });

    updateDerHistory(2);
    updateDerStatus(2);
    updateAssetCbHistory(2);

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  const removePvWithAlert = (subPv) => {
    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      PVDetails?.pvset1Data?.length === 1
    ) {
      if (architectureType === embLabels.PV_GENSET_ATS) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'‌PV + backup Genset with ATS' usecase requires minimum one PV`
        );
      }
    }
    if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
      PVDetails?.pvset1Data?.length === 1
    ) {
      if (architectureType === embLabels.PV_BESS_NR) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'‌PV + BESS (NR)' usecase requires minimum one PV`
        );
      }
    }
    //  else if (
    //   siteType === embLabels.PV_HYBRIDIZATION &&
    //   PVDetails.pvset1Data.length === 1
    // ) {
    //   setAlertMessage(
    //     `Alert`,
    //     false,
    //     ``,
    //     `'Genset/PV Hybridization' usecase requires minimum one PV`
    //   );
    // } 
    else {
      setSelectedValues((prevState) => ({ ...prevState, selectSubPv: subPv }));

      setConfirmMessage(`Do you confirm to delete pv from  pv set ?`);
    }
  };

  const checkPVCount = () => {
    const isArray1Empty = PVDetails?.pvset1Data?.length === 0;
    const isArray2Empty = PVDetails?.pvset2Data?.length === 0;
    const isArray3Empty = PVDetails?.pvset3Data?.length === 0;
    if(((isArray1Empty&&isArray2Empty&&!isArray3Empty)||
    (isArray1Empty&&!isArray2Empty&&isArray3Empty)||
    (!isArray1Empty&&isArray2Empty&&isArray3Empty))){
      return true;
    }else{
      return false;
    }
  }

  const removePv = () => {
    const isPVEmpty = checkPVCount();
    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      architectureType === embLabels.PV_GENSET_ATS &&
      defaultPreFillData[1]?.mode === "FUEL_SAVER" &&
      isPVEmpty
    ) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'‌PV + backup Genset with ATS' usecase requires minimum one PV`
      );
    } else if (
      siteType === embLabels.ISLANDABLE_GSX &&
      architectureType === embLabels.PV_GENSET_ATS &&
      defaultPreFillData[1]?.mode !== "FUEL_SAVER"
    ) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'‌PV + backup Genset with ATS' usecase requires minimum one PV`
      );
    }else if(siteType===embLabels.ISLANDABLE&&
      defaultPreFillData[1]?.mode === "FUEL_ERASER"&&
      isPVEmpty
    ){
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'‌BESS Main Genset as backup' usecase requires minimum one PV`
      );
    } else if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
      isPVEmpty
    ) {
      if (architectureType === embLabels.PV_BESS_NR) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'‌PV + BESS (NR)' usecase requires minimum one PV1`
        );
      }
    } else if (
      siteType === embLabels.GRID_CONNECTED &&
      isPVEmpty
    ) {
      setAlertMessage(`Alert`, false, ``, ` usecase requires minimum one PV1`);
    } else if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
      isPVEmpty
    ) {
      if (architectureType === embLabels.PV_BESS_NR) {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          `'‌PV + BESS (NR)' usecase requires minimum one PV1`
        );
      }
    } 
    else if (siteType === embLabels.PV_HYBRIDIZATION && isPVEmpty) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'Genset/PV Hybridization' usecase requires minimum one PV`
      );
    }
    else if(siteType===embLabels.ISLANDABLE&&isPVEmpty){
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `'No Genset' usecase requires minimum one PV`
      );
    } else {
      CBAssetListDispatch({
        type: ACTIONS.REMOVE_ASSET_DER_PV,
        payload: {
          selectedPv: PVDetails?.selectedPv,
        },
      });
      setDetailsBlock((prevState) => ({
        ...prevState,
        assetPvDetailsBlock: false,
      }));

      countDispatch({
        type: ACTIONS.UPDATE_DER_COUNT,
        payload: { count: -1 },
      });

      let removedPvSet;
      switch (PVDetails?.selectedPv) {
        case 3:
          removedPvSet = "pvset1Data";
          break;
        case 4:
          removedPvSet = "pvset2Data";

          break;
        case 5:
          removedPvSet = "pvset3Data";

          break;
        default:
          break;
      }
      PVDetailsDispatch({
        type: ACTIONS.REMOVE_ALL_PV_FROM_SET,
        payload: {
          removedPvSet: removedPvSet,
        },
      });

      updatePvHistoryFull(PVDetails?.selectedPv);
      updateAssetCbHistory(PVDetails?.selectedPv);
      updatePvHistoryGroupPower(PVDetails?.selectedPv);

      const runCalculateCoordinatesNew = { componentPush: true };

      setTimeout(() => {
        setRunCalculateCoordinates(runCalculateCoordinatesNew);
      }, 100);
      sessionStorage.setItem("componentDataModified",true);
    }
  };

  const removeCHP = () => {
    CBAssetListDispatch({
      type: ACTIONS.REMOVE_ASSET_DER,
      payload: {
        index: 6,
        configData,
      },
    });
    setDetailsBlock((prevState) => ({
      ...prevState,
      assetCHPDetailsBlock: false,
    }));
    countDispatch({
      type: ACTIONS.UPDATE_DER_COUNT,
      payload: { count: -1 },
    });

    updateDerHistory(6);
    updateDerStatus(7);
    updateAssetCbHistory(6);

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };
const checkRemoteLoads = (index)=>{
  const load = CBLoadList[index];
  if (load?.uiData?.isRemoteLoad === true) {
    return true;
  }else{
    return false;
  }
 
}
  const removeLoad = (index) => {
    if (siteType === embLabels.GRID_CONNECTED && !isExportOptimization) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Asset configuration needs minimum one load.`
      );
    } else if ((parseInt(count.loadCount) === 1) && !checkRemoteLoads(index)) {
      setAlertMessage(
        `Alert`,
        false,
        ``,
        `Asset configuration needs minimum one load.`
      );
    } else {
      CBLoadListDispatch({
        type: ACTIONS.REMOVE_LOAD,
        payload: {
          selectedLoad: index,
        },
      });

      
      if(CBLoadList[index].uiData.isRemoteLoad){
        countDispatch({
          type: ACTIONS.UPDATE_REMOTE_LOAD_COUNT,
          payload: { count: -1 },
        });
      }else{
        countDispatch({
          type: ACTIONS.UPDATE_LOAD_COUNT,
          payload: { count: -1 },
        });
      }

      // setDetailsBlock((prevState) => ({
      //   ...prevState,
      //   loadDetailsBlock: false,
      // }));

      updateLoadHistory(index);
      updateLoadCbHistory(index);

      const runCalculateCoordinatesNew = { componentPush: true };

      setTimeout(() => {
        setRunCalculateCoordinates(runCalculateCoordinatesNew);
      }, 100);
      sessionStorage.setItem("componentDataModified",true);
    }
  };

  const removeEv = () => {
    CBEVListDispatch({
      type: ACTIONS.REMOVE_ASSET_EV,
      payload: {
        index: 0,
        configData,
      },
    });
    setDetailsBlock((prevState) => ({
      ...prevState,
      evDetailsBlock: false,
    }));

    countDispatch({
      type: ACTIONS.UPDATE_EV_COUNT,
      payload: { count: -1 },
    });

    updateDerHistory(5);
    updateDerStatus(5);
    updateAssetCbHistory(6);

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  //* remove assets end

  const isNoAssetSelected = () =>
    Object.keys(detailsBlock).every((block) => !detailsBlock[block]);

  const checkSLDCount = () =>
   cbCount?.assetCbCount >= 24 ? false : true;

  const isValidCBName = (value) =>
    /^[a-zA-Z0-9_-\s]*$/.test(value) ? true : false;
  const isValidName = (value) => /^[a-zA-Z0-9 ]+$/.test(value)? true: false;
  const callSnackbar = useCallback((type, message) => {
    try {
      setSnackBar({ type, message });
      snackBarRef.current.open = true
    } catch (error) {
      console.log("error in snack bar")
    }
  }, []);

  const setAlertMessage = (title, isRoute, routePath, message) => {
    setAlert({
      title,
      isRoute,
      routePath,
      message,
      alertPopUpStatus: true,
    });
  };

  const closeAlertMessage = useCallback(() => {
    setAlert({
      message: "",
      alertPopUpStatus: false,
      title: "",
      isRoute: false,
      routePath: "",
    });
    if (alert.isRoute) {
      let { history } = props;
      history.push({
        pathname: `/${alert.routePath}`,
      });
    }
  }, [alert, props]);

  const setConfirmMessage = (message) => {
    setConfirm({
      confirmPopupStatus: true,
      confirmMessage: message,
    });
  };

  const closeConfirmMessage = () => {
    setConfirm({
      confirmPopupStatus: false,
      confirmMessage: "",
    });
  };
  const closeConfirmMessageRemote = () => {
    setRemoteConfirm({
      confirmPopupStatus: false,
      confirmMessage: "",
    });
  }
  const okConfirmMessageRemote = () => {
    if((["MGaaS ANSI","DaaS ANSI", "DaaS ETO"].includes(projectTypeValue)&&[embLabels.ISLANDABLE,embLabels.ISLANDABLE_GSX].includes(siteType))&&switchboardType===embLabels.EXISTING_SWITCHBOARD){
      handleSwitchboardTypeChangeGSX("NEW_SWITCHBOARD");
  }
  closeConfirmMessageRemote();
  }

  const okConfirmMessage = (e, isConfirmed) => {
    if (PVDetails?.selectedPv === 3) {
      if (PVDetails?.pvset1Data.length > 1) {
        let pvConStatusOne = true;

        PVDetails?.pvset1Data?.forEach((pv1, index) => {
          if (index !== selectedValues?.selectSubPv - 1 && !pv1.status) {
            pvConStatusOne = false;
          }
        });

        CBAssetListDispatch({
          type: ACTIONS.REDUCE_PV_COUNT_FROM_CB,
          payload: {
            selectedPv: 3,
            pvConStatusOne: pvConStatusOne,
          },
        });

        PVDetailsDispatch({
          type: ACTIONS.REMOVE_PV_FROM_SET,
          payload: {
            selectedPv: selectedValues?.selectedPv,
            subPv: selectedValues?.selectSubPv,
          },
        });

        if (!PVDetails?.pvset1Data?.[0]?.assetDetails?.length) {
          const newAssetDetailsDisplay = { ...assetDetailsDisplay };
          Object.keys(newAssetDetailsDisplay).forEach(
            (details) => (newAssetDetailsDisplay[details] = "")
          );
          setAssetDetailsDisplay(newAssetDetailsDisplay);
        }

        //this.calculatePvStatusConfigured(newPvData1Set);

        let subPv = selectedValues?.selectSubPv - 1;

        updatePvHistory(subPv, 3);

        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);

        pv1SelectHandler();
      } else {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          "Unable to delete. Minimum one Pv should be is present in PV set"
        );
      }
    }
    if (PVDetails?.selectedPv === 4) {
      if (PVDetails?.pvset2Data?.length > 1) {
        let pvConStatusOne = true;

        PVDetails?.pvset2Data?.forEach((pv2, index) => {
          if (index !== selectedValues?.selectSubPv - 1 && !pv2?.status) {
            pvConStatusOne = false;
          }
        });

        CBAssetListDispatch({
          type: ACTIONS.REDUCE_PV_COUNT_FROM_CB,
          payload: {
            selectedPv: 4,
            pvConStatusOne: pvConStatusOne,
          },
        });

        PVDetailsDispatch({
          type: ACTIONS.REMOVE_PV_FROM_SET,
          payload: {
            selectedPv: selectedValues?.selectedPv,
            subPv: selectedValues?.selectSubPv,
          },
        });

        if (!PVDetails?.pvset2Data?.[0]?.assetDetails?.length) {
          const newAssetDetailsDisplay = { ...assetDetailsDisplay };
          Object.keys(newAssetDetailsDisplay).forEach(
            (details) => (newAssetDetailsDisplay[details] = "")
          );

          setAssetDetailsDisplay(newAssetDetailsDisplay);
        }

        //this.calculatePvStatusConfigured(newPvData1Set);

        let subPv = selectedValues?.selectSubPv - 1;

        updatePvHistory(subPv, 4);

        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);

        pv2SelectHandler();
      } else {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          "Unable to delete. Minimum one Pv should be is present in PV set"
        );
      }
    }
    if (PVDetails?.selectedPv === 5) {
      if (PVDetails?.pvset3Data?.length > 1) {
        let pvConStatusOne = true;

        PVDetails?.pvset3Data.forEach((pv3, index) => {
          if (index !== selectedValues?.selectSubPv - 1 && !pv3?.status) {
            pvConStatusOne = false;
          }
        });

        CBAssetListDispatch({
          type: ACTIONS.REDUCE_PV_COUNT_FROM_CB,
          payload: {
            selectedPv: 5,
            pvConStatusOne: pvConStatusOne,
          },
        });

        PVDetailsDispatch({
          type: ACTIONS.REMOVE_PV_FROM_SET,
          payload: {
            selectedPv: selectedValues?.selectedPv,
            subPv: selectedValues?.selectSubPv,
          },
        });

        if (!PVDetails?.pvset3Data?.[0]?.assetDetails.length) {
          const newAssetDetailsDisplay = { ...assetDetailsDisplay };
          Object.keys(newAssetDetailsDisplay).forEach(
            (details) => (newAssetDetailsDisplay[details] = "")
          );

          setAssetDetailsDisplay(newAssetDetailsDisplay);
        }

        //this.calculatePvStatusConfigured(newPvData1Set);

        let subPv = selectedValues?.selectSubPv - 1;

        updatePvHistory(subPv, 5);

        const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
        setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);

        pv3SelectHandler();
      } else {
        setAlertMessage(
          `Alert`,
          false,
          ``,
          "Unable to delete. Minimum one Pv should be is present in PV set"
        );
      }
    }
    closeConfirmMessage();
  };

  const closePvDetailsBlock = () => {
    PVDetailsDispatch({
      type: ACTIONS.CLOSE_PVDISPLAY_CONTENT,
      payload: {
        selectSubPv: PVDetails?.selectSubPv,
        selectedPv: PVDetails?.selectedPv,
      }
    });
  };

  const isCopyAllButtonDisabled = (selectedPv) => {
    switch (selectedPv) {
      case 3:
        const configured1pv = PVDetails?.pvset1Data?.filter((pv1) => pv1.status);
        const configured1pvSameAsset = configured1pv.every(
          (pv1) =>
            pv1?.assetDetails[0]?.assetId ===
            configured1pv[0]?.assetDetails[0]?.assetId
        );
        if (PVDetails?.pvset1Data?.every((pv1) => pv1.status)) return false;
        else return configured1pvSameAsset && configured1pv.length;
      case 4:
        const configured2pv = PVDetails?.pvset2Data?.filter((pv2) => pv2.status);
        const configured2pvSameAsset = configured2pv.every(
          (pv2) =>
            pv2?.assetDetails[0]?.assetId ===
            configured2pv[0]?.assetDetails[0]?.assetId
        );
        if (PVDetails?.pvset2Data?.every((pv2) => pv2.status)) return false;
        else return configured2pvSameAsset && configured2pv.length;
      case 5:
        const configured3pv = PVDetails?.pvset3Data?.filter((pv3) => pv3.status);
        const configured3pvSameAsset = configured3pv.every(
          (pv3) =>
            pv3?.assetDetails[0]?.assetId ===
            configured3pv[0]?.assetDetails[0]?.assetId
        );
        if (PVDetails?.pvset3Data?.every((pv3) => pv3.status)) return false;
        else return configured3pvSameAsset && configured3pv.length;
      default:
        break;
    }
  };

  const copyAllPvs = () => {
    PVDetailsDispatch({
      type: ACTIONS.COPY_ALL_PV,
    });
    PVDetailsDispatch({
      type: ACTIONS.PV_CONFIGURED_STATUS,
    });

    // this.updatePvHistory(index, selectedPV);
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    sessionStorage.setItem("componentDataModified",true);
    callSnackbar("information", "PV Configured Successfully");
  };

  //* LOCAL STORAGE

  const assetEditStatusUpdateDER = (e, type, status) => {
    let derHistory = JSON.parse(sessionStorage.getItem("derHistory"));
    switch (type) {
      case embLabels.BESS:
        derHistory.BESS[e.target.name] = e.target.value;
        checkUpdatedStatus(2, status);
        break;

      case embLabels.GENSET:
        derHistory.Genset[e.target.name] = e.target.value;
        checkUpdatedStatus(1, status);
        break;

      case embLabels.UTILITY:
        derHistory.Utility[e.target.name] = e.target.value;
        checkUpdatedStatus(0, status);
        break;

      case embLabels.EV:
        derHistory.EV[e.target.name] = e.target.value;
        checkUpdatedStatus(5, status);
        break;

      case embLabels.CHP:
        derHistory.CHP[e.target.name] = e.target.value;
        checkUpdatedStatus(7, status);
        break;

      case embLabels.HYBRID:
        derHistory.Hybrid[e.target.name] = e.target.value;
        checkUpdatedStatus(9, status);
        break;

      default:
        break;
    }
    sessionStorage.setItem("derHistory", JSON.stringify(derHistory));
  };

  const assetEditStatusUpdateLoad = (e, status, selectedLoad) => {
    let loadHistory = [];
    if (sessionStorage.getItem("loadHistory") !== "") {
      loadHistory = JSON.parse(sessionStorage.getItem("loadHistory"));
    }

    if (loadHistory[selectedLoad] === undefined) {
      loadHistory[selectedLoad] = {};
    }
    if (loadHistory[selectedLoad] === null) {
      loadHistory[selectedLoad] = {};
    }
    let loadHistoryRef = loadHistory[selectedLoad];
    loadHistoryRef[e.target.name] = e.target.value;
    loadHistory[selectedLoad] = loadHistoryRef;
    sessionStorage.setItem("loadHistory", JSON.stringify(loadHistory));
    checkUpdatedStatus(4, status);
  };

  const assetEditStatusUpdateAssetCB = (e, status, selectedAssetCb) => {
    const dataConfig = { ...configData?.cbConfigData };
    const {name, value, checked, type} = e?.target;
    let cbAssetHistory = [];
    if (sessionStorage.getItem("cbAssetHistory") !== "") {
      cbAssetHistory = JSON.parse(sessionStorage.getItem("cbAssetHistory"));
    }

    if (cbAssetHistory[selectedAssetCb] === undefined) {
      cbAssetHistory[selectedAssetCb] = {};
    }
    if (cbAssetHistory[selectedAssetCb] === null) {
      cbAssetHistory[selectedAssetCb] = {};
    }

    let cbAssetHistoryRef = cbAssetHistory[selectedAssetCb];
    if(cbAssetHistoryRef) return;
    if (name === "motorized") {
      if (
        [embLabels.GRID_CONNECTED,embLabels.ISLANDABLE].includes(siteType) &&
        clientType === embLabels.GENERIC_PROJECT &&
       ( projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO")
      ) {
        if(checked){
          if(cbAssetHistoryRef?.contactor){
            cbAssetHistoryRef[name] = checked;
            cbAssetHistoryRef.contactor = !checked;
            dataConfig[name] = checked;
            dataConfig.contactor = !checked;
          }else{
            cbAssetHistoryRef[name] = checked;
            dataConfig[name] = checked;
          }
        }else{
          cbAssetHistoryRef[name] = checked;
          dataConfig[name] = checked;
        }
      } else {
        cbAssetHistoryRef[name] = true;
      }
    } else if(name === "contactor"){
      if (
        siteType === embLabels.GRID_CONNECTED &&
        clientType === embLabels.GENERIC_PROJECT &&
       ( projectTypeValue === "MGaaS IEC" || projectTypeValue === "MGaaS ETO")
      ) {
        if(e?.target?.checked){
          if(cbAssetHistoryRef?.motorized){
            cbAssetHistoryRef[name] = checked;
            cbAssetHistoryRef.motorized = !checked;
            dataConfig[name] = checked;
            dataConfig.motorized = !checked;
          }else{
            cbAssetHistoryRef[name] = checked;
            dataConfig[name] = checked;
          }
        }else{
          cbAssetHistoryRef[name] = checked;
          dataConfig[name] = checked;
        }
    } else {
        cbAssetHistoryRef[name] = true;
      }
    }else {
      if((projectKind?.isDaasAnsi || projectKind?.isDaasEto) && name === "name" ){
        cbAssetHistoryRef[name] = value.toLowerCase();
      dataConfig[name] = value?.toLowerCase();
      }else{
        cbAssetHistoryRef[name] = value;
      dataConfig[name] = value;
      }
      
    }
    cbAssetHistory[selectedAssetCb] = cbAssetHistoryRef;
    setConfigData((prevState) => ({ ...prevState, cbConfigData: dataConfig }));
    sessionStorage.setItem("cbAssetHistory", JSON.stringify(cbAssetHistory));
    checkUpdatedStatus(6, status);
  };

  const assetEditStatusUpdateLoadCb = (e, status, selectedLoadCb) => {
    let cbLoadHistory = [];
    if (sessionStorage.getItem("cbLoadHistory") !== "") {
      cbLoadHistory = JSON.parse(sessionStorage.getItem("cbLoadHistory"));
    }

    if (cbLoadHistory[selectedLoadCb] === undefined) {
      cbLoadHistory[selectedLoadCb] = {};
    }

    if (cbLoadHistory[selectedLoadCb] === null) {
      cbLoadHistory[selectedLoadCb] = {};
    }

    let cbLoadHistoryRef = cbLoadHistory[selectedLoadCb];
    if (e.target.name === "motorized") {
      cbLoadHistoryRef[e.target.name] = e.target.checked;
    }else if(e.target.name === "contactor") {
      cbLoadHistoryRef[e.target.name] = e.target.checked;
    } else {
      cbLoadHistoryRef[e.target.name] = e.target.value;
    }
    cbLoadHistory[selectedLoadCb] = cbLoadHistoryRef;
    sessionStorage.setItem("cbLoadHistory", JSON.stringify(cbLoadHistory));
    checkUpdatedStatus(6, status);
  };

  const assetEditStatusUpdateEvCb = (e, status, selectedEvCb) => {
    let cbEvHistory = [];
    if (sessionStorage.getItem("cbEvHistory") !== "") {
      cbEvHistory = JSON.parse(sessionStorage.getItem("cbEvHistory"));
    }

    if (cbEvHistory[selectedEvCb] === undefined) {
      cbEvHistory[selectedEvCb] = {};
    }

    if (cbEvHistory[selectedEvCb] === null) {
      cbEvHistory[selectedEvCb] = {};
    }

    let cbEvHistoryRef = cbEvHistory[selectedEvCb];
    if (e.target.name === "motorized") {
      cbEvHistoryRef[e.target.name] = e.target.checked;
    } else {
      cbEvHistoryRef[e.target.name] = e.target.value;
    }

    cbEvHistory[selectedEvCb] = cbEvHistoryRef;
    sessionStorage.setItem("cbEvHistory", JSON.stringify(cbEvHistory));
    checkUpdatedStatus(6, status);
  };

  const assetEditStatusUpdatePv = (e, status, selectedPv, selectedSubPvRaw) => {
    let selectedSubPv = selectedSubPvRaw - 1;
    const onlyNumber = /^(\d+(\.\d+)?|)$/;
    let pvHistory = JSON.parse(sessionStorage.getItem("pvHistory"));
    if (selectedPv === 3) {
      if (pvHistory.pv1[selectedSubPv] === undefined) {
        pvHistory.pv1[selectedSubPv] = {};
      }
      if (pvHistory.pv1[selectedSubPv] === null) {
        pvHistory.pv1[selectedSubPv] = {};
      }
      let pvHistoryRef = pvHistory.pv1[selectedSubPv];

      switch (e.target.name) {
        case "groupName":
          pvHistoryRef[e.target.name] = e.target.value;
          break;
        case "group_max_power":
          if (onlyNumber.test(e.target.value) && e.target.value <= 99999) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        case "max_power":
          if (!isNaN(e.target.value)) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        default:
          pvHistoryRef[e.target.name] = e.target.value;
          break;
      }

      pvHistory.pv1[selectedSubPv] = pvHistoryRef;
    } else if (selectedPv === 4) {
      if (pvHistory.pv2[selectedSubPv] === undefined) {
        pvHistory.pv2[selectedSubPv] = {};
      }
      if (pvHistory.pv2[selectedSubPv] === null) {
        pvHistory.pv2[selectedSubPv] = {};
      }
      let pvHistoryRef = pvHistory.pv2[selectedSubPv];
      switch (e.target.name) {
        case "groupName":
          pvHistoryRef[e.target.name] = e.target.value;
          break;
        case "group_max_power":
          if (onlyNumber.test(e.target.value) && e.target.value <= 99999) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        case "max_power":
          if (!isNaN(e.target.value)) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        default:
          pvHistoryRef[e.target.name] = e.target.value;
          break;
      }
      pvHistory.pv2[selectedSubPv] = pvHistoryRef;
    } else if (selectedPv === 5) {
      if (pvHistory.pv3[selectedSubPv] === undefined) {
        pvHistory.pv3[selectedSubPv] = {};
      }
      if (pvHistory.pv3[selectedSubPv] === null) {
        pvHistory.pv3[selectedSubPv] = {};
      }
      let pvHistoryRef = pvHistory.pv3[selectedSubPv];
      switch (e.target.name) {
        case "groupName":
          pvHistoryRef[e.target.name] = e.target.value;
          break;
        case "group_max_power":
          if (onlyNumber.test(e.target.value) && e.target.value <= 99999) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        case "max_power":
          if (!isNaN(e.target.value)) {
            pvHistoryRef[e.target.name] = e.target.value;
          }
          break;
        default:
          pvHistoryRef[e.target.name] = e.target.value;
          break;
      }
      pvHistory.pv3[selectedSubPv] = pvHistoryRef;
    }
    sessionStorage.setItem("pvHistory", JSON.stringify(pvHistory));
    checkUpdatedStatus(3, status);
    setIsAssetConfigChanged(pvHistory);
  };

  const assetEditStatusUpdateAssetPM = (e, status, selectedAssetPm) => {
    let pmAssetHistory = [];
    if (sessionStorage.getItem("pmAssetHistory") !== "") {
      pmAssetHistory = JSON.parse(sessionStorage.getItem("pmAssetHistory"));
    }

    if (pmAssetHistory[selectedAssetPm] === undefined) {
      pmAssetHistory[selectedAssetPm] = {};
    }
    if (pmAssetHistory[selectedAssetPm] === null) {
      pmAssetHistory[selectedAssetPm] = {};
    }

    let pmAssetHistoryRef = pmAssetHistory[selectedAssetPm];
    pmAssetHistoryRef[e.target.name] = e.target.value;
    pmAssetHistory[selectedAssetPm] = pmAssetHistoryRef;
    sessionStorage.setItem("pmAssetHistory", JSON.stringify(pmAssetHistory));
    checkUpdatedStatus(8, status, selectedAssetPm);
  };

  const assetEditStatusUpdateEvPM = (e, status, selectedAssetPm) => {
    let pmEvHistory = [];
    if (sessionStorage.getItem("pmEvHistory") !== "") {
      pmEvHistory = JSON.parse(sessionStorage.getItem("pmEvHistory"));
    }

    if (pmEvHistory[selectedAssetPm] === undefined) {
      pmEvHistory[selectedAssetPm] = {};
    }
    if (pmEvHistory[selectedAssetPm] === null) {
      pmEvHistory[selectedAssetPm] = {};
    }

    let pmAssetHistoryRef = pmEvHistory[selectedAssetPm];
    pmAssetHistoryRef[e.target.name] = e.target.value;
    pmEvHistory[selectedAssetPm] = pmAssetHistoryRef;
    sessionStorage.setItem("pmEvHistory", JSON.stringify(pmEvHistory));
    checkUpdatedStatus(8, status);
  };

  const checkUpdatedStatus = (type, status, selectedAsset) => {
    let derStatus = [];
    if (sessionStorage.getItem("derStatus") !== "") {
      derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    }

    derStatus[type] = status;

    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    detailsModifiedStataus();
  };

  const detailsModifiedStataus = (selectedAsset) => {
    const assests = ["Utility","Genset","BESS","PV","Load","EV"];
    let derStatus = [];
    if (sessionStorage.getItem("derStatus") !== "") {
      derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    }
    sessionStorage.setItem("assetEditStatus", "");
    let assetEditStatus = [];
    for (let i = 0; i < derStatus.length; i++) {
      if (derStatus[i] === true) {
        switch (i) {
          case 0:
            assetEditStatus.push("Utility");
            assetEditStatus.push(true);
            break;
          case 1:
            assetEditStatus.push("Genset");
            assetEditStatus.push(true);
            break;
          case 2:
            assetEditStatus.push("BESS");
            assetEditStatus.push(true);
            break;
          case 3:
            assetEditStatus.push("PV");
            assetEditStatus.push(true);
            break;
          case 4:
            assetEditStatus.push("Load");
            assetEditStatus.push(true);
            break;
          case 5:
            assetEditStatus.push("EV");
            assetEditStatus.push(true);
            break;
          case 6:
            assetEditStatus.push("CB");
            assetEditStatus.push(true);
            break;
          case 7:
            assetEditStatus.push("CHP");
            assetEditStatus.push(true);
            break;
          case 8:
            assetEditStatus.push(`Power meter`);
            assetEditStatus.push(true);
            break;
          case 9:
            assetEditStatus.push("Hybrid");
            assetEditStatus.push(true);
            break;
          default:
            break;
        }
        sessionStorage.setItem("assetEditStatus", assetEditStatus);
        break;
      }
    }
  };

  const updateDerHistory = (index) => {
    let derHistory = JSON.parse(sessionStorage.getItem("derHistory"));
    if (index === 0) {
      derHistory.Utility = {};
    } else if (index === 1) {
      derHistory.Genset = {};
    } else if (index === 2) {
      derHistory.BESS = {};
    } else if (index === 5) {
      derHistory.EV = {};
    } else if (index === 7) {
      derHistory.CHP = {};
    } else if (index === 9) {
      derHistory.Hybrid = {};
    }

    sessionStorage.setItem("derHistory", JSON.stringify(derHistory));
  };

  const updateLoadHistory = (index) => {
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let loadHistory = [];
    if (derStatus[4] === true) {
      loadHistory = JSON.parse(sessionStorage.getItem("loadHistory"));
    }

    if (loadHistory.length) {
      delete loadHistory[index];
    }
    sessionStorage.setItem("loadHistory", JSON.stringify(loadHistory));

    if (loadHistory.length) {
      let status = false;
      for (let i = 0; i < loadHistory.length; i++) {
        if (loadHistory[i] === null) {
          status = status === false ? false : true;
        } else if (loadHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
      derStatus[4] = status;
    } else {
      derStatus[4] = false;
    }
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    detailsModifiedStataus();
  };

  const updateEvCbHistory = (index) => {
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let cbEvHistory = [];
    if (derStatus[6] === true) {
      cbEvHistory = JSON.parse(sessionStorage.getItem("cbEvHistory"));
    }

    if (cbEvHistory.length) {
      delete cbEvHistory[index];
    }

    sessionStorage.setItem("cbEvHistory", JSON.stringify(cbEvHistory));
    checkCBStatus();
  };

  const updateLoadCbHistory = (index) => {
    if(sessionStorage.getItem("derStatus")){
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let cbLoadHistory = [];
    if (derStatus[6] === true && sessionStorage.getItem("cbLoadHistory")) {
      cbLoadHistory = JSON.parse(sessionStorage.getItem("cbLoadHistory"));
    }

    if (cbLoadHistory.length) {
      delete cbLoadHistory[index];
    }
    sessionStorage.setItem("cbLoadHistory", JSON.stringify(cbLoadHistory));}
    checkCBStatus();
  };

  const updateAssetCbHistory = (index) => {
    if(sessionStorage.getItem("derStatus")){
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let cbAssetHistory = [];
    if (derStatus[6] === true) {
      cbAssetHistory = sessionStorage?.getItem("cbAssetHistory") &&JSON?.parse(sessionStorage?.getItem("cbAssetHistory"));
    }

    if (cbAssetHistory.length) {
      delete cbAssetHistory[index];
    }
  
    sessionStorage.setItem("cbAssetHistory", JSON.stringify(cbAssetHistory));
  }
    checkCBStatus();
  };

  const updateAssetPmHistory = (index) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let pmAssetHistory = [];
    if (derStatus[8] === true) {
      pmAssetHistory = JSON.parse(sessionStorage.getItem("pmAssetHistory"));
    }
  

    if (pmAssetHistory.length) {
      delete pmAssetHistory[index];
    }

    sessionStorage.setItem("pmAssetHistory", JSON.stringify(pmAssetHistory));
  }
    checkPmStatus();
  };

  const updateEvPmHistory = (index) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let pmEvHistory = [];
    if (derStatus[8] === true) {
      pmEvHistory = JSON.parse(sessionStorage.getItem("pmEvHistory"));
    }
  

    if (pmEvHistory.length) {
      delete pmEvHistory[index];
    }
    sessionStorage.setItem("pmEvHistory", JSON.stringify(pmEvHistory))}
    checkPmStatus();
  };

  const checkCBStatus = () => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));

    let cbLoadHistory = [];
    if (sessionStorage.getItem("cbLoadHistory") === "") {
      cbLoadHistory = [];
    } else {
      cbLoadHistory = JSON.parse(sessionStorage.getItem("cbLoadHistory"));
    }
    let status = false;
    if (cbLoadHistory.length) {
      for (let i = 0; i < cbLoadHistory.length; i++) {
        if (cbLoadHistory[i] === null) {
          status = status === false ? false : true;
        } else if (cbLoadHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }
  

    let cbAssetHistory = [];
    if (sessionStorage.getItem("cbAssetHistory") === "") {
      cbAssetHistory = [];
    } else {
      cbAssetHistory = JSON.parse(sessionStorage.getItem("cbAssetHistory"));
    }

    if (cbAssetHistory.length) {
      for (let i = 0; i < cbAssetHistory.length; i++) {
        if (cbAssetHistory[i] === null) {
          status = status === false ? false : true;
        } else if (cbAssetHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }

    let cbEvHistory = [];
    if (sessionStorage.getItem("cbEvHistory") === "") {
      cbEvHistory = [];
    } else {
      cbEvHistory = JSON.parse(sessionStorage.getItem("cbEvHistory"));
    }
    if (cbEvHistory.length) {
      for (let i = 0; i < cbEvHistory.length; i++) {
        if (cbEvHistory[i] === null) {
          status = status === false ? false : true;
        } else if (cbEvHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }

    derStatus[6] = status;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
  }
    detailsModifiedStataus();
  };

  const checkPmStatus = () => {
    if(sessionStorage.getItem("derStatus")){
    
    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));

    let pmAssetHistory = [];
    if (sessionStorage.getItem("pmAssetHistory") === "") {
      pmAssetHistory = [];
    } else {
      pmAssetHistory = JSON.parse(sessionStorage.getItem("pmAssetHistory"));
    }
    let status = false;
    if (pmAssetHistory.length) {
      for (let i = 0; i < pmAssetHistory.length; i++) {
        if (pmAssetHistory[i] === null) {
          status = status === false ? false : true;
        } else if (pmAssetHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }

    let pmEvHistory = [];
    if (sessionStorage.getItem("pmEvHistory") === "") {
      pmEvHistory = [];
    } else {
      pmEvHistory = JSON.parse(sessionStorage.getItem("pmEvHistory"));
    }

    if (pmEvHistory.length) {
      for (let i = 0; i < pmEvHistory.length; i++) {
        if (pmEvHistory[i] === null) {
          status = status === false ? false : true;
        } else if (pmEvHistory[i] === undefined) {
          status = status === false ? false : true;
        } else {
          status = true;
        }
      }
    } else {
      status = status === false ? false : true;
    }

    derStatus[8] = status;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
  }
    detailsModifiedStataus();
  };

  const updatePvHistoryFull = (mainIndex) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let pvHistory = JSON.parse(sessionStorage.getItem("pvHistory"));
    let status = false;
    if (mainIndex === 3) {
      pvHistory.pv1 = [];
      status = false;
    } else if (mainIndex === 4) {
      pvHistory.pv2 = [];
      status = false;
    } else if (mainIndex === 5) {
      pvHistory.pv3 = [];
      status = false;
    }

    derStatus[3] = status;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    sessionStorage.setItem("pvHistory", JSON.stringify(pvHistory));
  }
    detailsModifiedStataus();
  };

  const updatePvHistory = (subIndex, mainIndex) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    let pvHistory = JSON.parse(sessionStorage.getItem("pvHistory"));
    let status = false;
    if (mainIndex === 3) {
      if (pvHistory.pv1.length) {
        delete pvHistory.pv1[subIndex];
        for (let i = 0; i < pvHistory.pv1.length; i++) {
          if (pvHistory.pv1[i] === null) {
            status = status === false ? false : true;
          } else if (pvHistory.pv1[i] === undefined) {
            status = status === false ? false : true;
          } else {
            status = true;
          }
        }
      } else {
        status = false;
      }
    } else if (mainIndex === 4) {
      if (pvHistory.pv2.length) {
        delete pvHistory.pv2[subIndex];
        for (let i = 0; i < pvHistory.pv2.length; i++) {
          if (pvHistory.pv2[i] === null) {
            status = status === false ? false : true;
          } else if (pvHistory.pv2[i] === undefined) {
            status = status === false ? false : true;
          } else {
            status = true;
          }
        }
      } else {
        status = false;
      }
    } else if (mainIndex === 5) {
      if (pvHistory.pv3.length) {
        delete pvHistory.pv3[subIndex];
        for (let i = 0; i < pvHistory.pv2.length; i++) {
          if (pvHistory.pv2[i] === null) {
            status = status === false ? false : true;
          } else if (pvHistory.pv3[i] === undefined) {
            status = status === false ? false : true;
          } else {
            status = true;
          }
        }
      } else {
        status = false;
      }
    }

    derStatus[3] = status;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    sessionStorage.setItem("pvHistory", JSON.stringify(pvHistory));
  }
    detailsModifiedStataus();
  };

  const updateDerStatus = (index) => {
    if(sessionStorage.getItem("derStatus")){

    let derStatus = JSON.parse(sessionStorage.getItem("derStatus"));
    derStatus[index] = false;
    sessionStorage.setItem("derStatus", JSON.stringify(derStatus));
    }
    detailsModifiedStataus();
  };

  const updatePvHistoryGroupPower = (selectedPv) => {
    let pvGroupPower = JSON.parse(sessionStorage.getItem("pvGroupPower"));
    if (selectedPv === 3) {
      pvGroupPower.pv1 = "";
    } else if (selectedPv === 4) {
      pvGroupPower.pv2 = "";
    } else if (selectedPv === 5) {
      pvGroupPower.pv3 = "";
    }
    sessionStorage.setItem("pvGroupPower", JSON.stringify(pvGroupPower));
  };

  const FindNode = () => document.getElementById("SLD-Image");

  useImperativeHandle(ref, () => ({
    FindNode,
  }));

  const getCorespondingPlateCapacity = (obj, key) => {
    const objNew = JSON.parse(obj);
    for (const objKey in objNew) {
      if (objKey === key) {
        return objNew[objKey];
      }
    }
    return null;
  };
 // Function to filter based on hybrid model
const filterHybridModel = (data, model) =>{
  const storageCapacityKey = `${model}_storageCapacity`;
  const timeCapacityKey = `${model}_timeCapacity`;

  const storageCapacity = JSON.parse(data.find(item => item.type === storageCapacityKey)?.value) || [];
  const timeCapacity = JSON.parse(data.find(item => item.type === timeCapacityKey)?.value) || [];

  return {
     storageCapacity,
      timeCapacity
  };
}
  const handleChangeBattery = (e) => {
    const {name, value} = e.target;
    
    if(name === "selectBatterySystemModel"){     
      const {storageCapacity, timeCapacity} = filterHybridModel(defaultComponentData?.defaultComponentData?.assetAttributes, value);
      setBatterySystemA2EConfig(prev=>{
        setConfigData((prevState) => ({
          ...prevState,
          configData:{ 
            ...prevState.configData,
            // hybridModels:hybridModels,
            namePlateEnergy:storageCapacity,
            time_capacity:timeCapacity
            },
        }));
        return {
          ...prev,
          namePlateEnergy:storageCapacity,
          namePlateCapacity:timeCapacity,

        }
      }
    );
    CBAssetListDispatch({
      type: ACTIONS.UPDATE_BATTERY_CONFIG,
      payload: {
        index: 7,
        name: name,
        value:value,
        storageCapacity:storageCapacity,
        timeCapacity:timeCapacity,
      },
    });
    }
    if(name  === "usableStorageCapacity"){
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_BATTERY_CONFIG,
        payload: {
          index: 7,
          name: name,
          value:value,
          storageCapacity:"",
          timeCapacity:"",
          hybrid:defaultComponentData?.defaultComponentData?.hybrid?defaultComponentData?.defaultComponentData?.hybrid:defaultComponentData?.defaultComponentData,
        },
      });
    }
    setIsAssetConfigChanged(configData);
  };
  const handleChangeBessHybridBatteryRack = (e, index) => {
    setBatterySystemA2EConfig(prev=>{
      return {
        ...prev,
        namePlateEnergy:e.target.value,
      }
    }
  );
    const plateCapacityValue = getCorespondingPlateCapacity(
      configData?.configData?.corresponding_name_plate_capacity,
      e.target.value
    );
    CBAssetListDispatch({
      type: ACTIONS.UPDATE_BATTERY_CAPACITY_ON_BATTERY_RACK,
      payload: {
        index: 2,
        storage_capacity_hr_value: e.target.value,
        capacity: plateCapacityValue,
      },
    });
    let configDataNew = { ...configData?.configData };
    configDataNew["storage_capacity_hr_value"] = e.target.value;
    configDataNew["capacity"] = plateCapacityValue;
    setConfigData((prevState) => ({ ...prevState, configData: configDataNew }));
  };

  const handleSwitchboardTypeChangeGSX = (switchType) => {
    setSwitchboardType(switchType);
    let x21, x22, x11, y11, y21, x12, y12, y22;
    if(switchType===embLabels.NEW_SWITCHBOARD){
      const removeRemoteLoad = [];
      const loadData = [...CBLoadList]
      loadData.forEach((load,index)=>{
        if(load.uiData.isRemoteLoad){
          removeRemoteLoad.push(index)
           countDispatch({
            type:  ACTIONS.UPDATE_REMOTE_LOAD_COUNT,
            payload: {count: -1}
          });
        }
      })
      if(removeRemoteLoad?.length>0){
        CBLoadListDispatch({
          type:  ACTIONS.REMOVE_REMOTE_LOAD,
          payload: {
            indexes: removeRemoteLoad
          }
        });
        
      }
    }
    assetDetailsReset();
    if (
      siteType === embLabels.ISLANDABLE &&
      projectTypeValue !== "MGaaS ANSI"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count, siteType:siteType, projectKind: projectKind, switchboardType },
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count },
      });
    }

    if (siteType === embLabels.GRID_CONNECTED && clientType === "GENERIC") {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GRIDCONNECTED,
        payload: { coordinates: coordinates },
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GRIDCONNECTED,
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
        payload: { coordinates: coordinates },
      });
    }
    if (
      (siteType === embLabels.ISLANDABLE_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1].mode === "FUEL_SAVER") ||
      (siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType,
          clientType,
          mode: defaultPreFillData[1]?.mode,
          loadSide:loadSide,
        }
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });
    }
    let coOrdinates = {
      x11,
      y11,
      x21,
      y21,
      x12,
      y12,
      x22,
      y22,
    };

    // --------------------

    if (
      siteType === embLabels.ISLANDABLE &&
      projectTypeValue !== "MGaaS ANSI"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count, siteType:siteType, projectKind: projectKind ,switchboardType },
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES,
        payload: { coordinates: coordinates, count: count },
      });
    }
    if (siteType === embLabels.PV_HYBRIDIZATION) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVHYBRIDIZATION,
        payload: { coordinates: coordinates,switchType:switchType },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVHYBRIDIZATION,
      });
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "426",
          y11: "360",
          x21: "815",
          y21: "360",
        },
      }));

      checkAssetStatus();
    }

    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      clientType === embLabels.GREENSTRUXURE_PROJECT &&
      architectureType === embLabels.PV_GENSET_ATS &&
      defaultPreFillData[1].mode !== "FUEL_SAVER"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS,
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS_OP,
        payload: "switchType",
      });

      checkAssetStatus();
    }

    if (
      (siteType === embLabels.ISLANDABLE_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1].mode === "FUEL_SAVER") ||
      (siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType,
          clientType,
          mode: defaultPreFillData[1]?.mode,
          loadSide:loadSide,
        }
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });

      checkAssetStatus();
    }

    if (
      (siteType === embLabels.GRID_CONNECTED_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_BESS_NR) ||
      (siteType === embLabels.GRID_CONNECTED &&
        projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType: switchboardType,
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind,
        }
      });

      checkAssetStatus();
    }

    if (
      siteType === embLabels.GENSET_PVBESS_A2E &&
      clientType === embLabels.A2E_PROJECT
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GENSET_PVBESS_A2E,
        payload: { coordinates: coordinates },
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVHYBRIDIZATION,
      });
      // setCoordinates((prevCoordinates) => ({
      //   ...prevCoordinates,
      //   busbarCordinates: {
      //     ...prevCoordinates.busbarCordinates,
      //     x11: "426",
      //     y11: "360",
      //     x21: "815",
      //     y21: "360",
      //   },
      // })
      // );

      checkAssetStatus();
    }

    // ---------------

    if (projectTypeValue === "DaaS IEC") {
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVBESS_NR,
        payload: switchType,
      });
    }
    if(isMgaasIecIsland || isMGaaSETOIsland){
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_ISLANDABLE,
        payload: {
          switchType: switchboardType,
          mode: defaultPreFillData[1]?.mode,
          projectKind: projectKind,
        },
      });
    }
    const coOrdinateLists = coOrdinateValidator(
      coOrdinates,
      switchType,
      siteType,
      projectTypeValue,
      count,
      rectangleWidth,
      loadSide,
      clientType,
      defaultPreFillData[1]?.mode,
      projectKind,
    );
    setRectangleWidth(coOrdinateLists.rectangleWidth);
    setCoordinates((prevCoordinates) => ({
      ...prevCoordinates,
      busbarCordinates: {
        ...prevCoordinates.busbarCordinates,
        ...coOrdinateLists.cooridinates,
      },
    }));
    if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
     ( projectTypeValue === "DaaS ANSI" ||  projectTypeValue === "DaaS ETO")
    ) {
      setLoadSide(coOrdinateLists.loadSide);
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType,  
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind
        }
      });
    }
    if (
      siteType === embLabels.GRID_CONNECTED &&
      projectTypeValue === "MGaaS ANSI"
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType,
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind
        }
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS_OP,
        payload: "switchType",
      });
    }

    if (
      siteType === embLabels.GRID_CONNECTED_GSX &&
      projectTypeValue === "DaaS IEC"
    ) {
      setRectangleWidth(coOrdinateLists.rectangleWidth);
      setLoadSide(coOrdinateLists.loadSide);
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType,
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind
        }
      });
    }

    if (
      siteType === embLabels.ISLANDABLE_GSX &&
      projectTypeValue === "DaaS IEC"
    ) {
      setRectangleWidth(coOrdinateLists.rectangleWidth);
      setLoadSide(coOrdinateLists.loadSide);
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType,
          clientType:"",
          mode: "",
          loadSide:loadSide,
        }
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });
    }

    //000000000000000000000000

    setSwitchboardType(switchType);
    if (siteType === embLabels.GRID_CONNECTED && clientType === "GENERIC") {
      let x21 =
        count.derCount === 2
          ? "695"
          : count.derCount === 3
          ? "910"
          : count.derCount === 4
          ? "1015"
          : count.derCount === 5
          ? switchType === embLabels.EXISTING_SWITCHBOARD
            ? "1145"
            : "1045"
          : "795";

      if (switchType === "EXISTING_SWITCHBOARD") {
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          xDerGrid: "480",
          xDerCBDiff: "700",
          yDerGrid: "243",
          yDerCBDiff: "370",
          xDerGridPM: "605",
          yDerGridPM: "227.5",
          cbEV: {
            xDerEV: 597.5,
            yDerEV: 492,
            xDerPM: 545,
            yDerPM: 487.5,
            x1DerEVCB: 675,
            y1DerEVCB: 570,
            x2DerEVCB: 675,
            y2DerEVCB: 464,
          },
          busbarCordinates: {
            ...prevCoordinates.busbarCordinates,
            x11: "126",
            y11: "280",
            x21: "345",
            y21: "280",
            x12: "620",
            y12: "470",
            x22: x21,
            y22: "470",
          },
        }));
      } else {
        let x21 =
          count.derCount === 2
            ? "695"
            : count.derCount === 3
            ? "810"
            : count.derCount === 4
            ? "915"
            : count.derCount === 5
            ? "1045"
            : "795";

        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          xDerGrid: "370",
          xDerCBDiff: "590",
          yDerGrid: "141",
          yDerCBDiff: "269",
          xDerGridPM: "495",
          yDerGridPM: "127.5",
          cbEV: {
            xDerEV: 477.5,
            yDerEV: 553,
            xDerPM: 425,
            yDerPM: 617.5,
            x1DerEVCB: 555,
            y1DerEVCB: 463,
            x2DerEVCB: 555,
            y2DerEVCB: 367,
          },
          busbarCordinates: {
            ...prevCoordinates.busbarCordinates,
            x11: "426",
            y11: "370",
            x21: x21,
            y21: "370",
            x12: "700",
            y12: "470",
            x22: "900",
            y22: "470",
          },
        }));
      }

      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_GRIDCONNECTED,
        payload: { coordinates: coordinates },
      });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GRIDCONNECTED,
      });
      CBEVListDispatch({
        type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
        payload: { coordinates: coordinates },
      });
    }
    if (
      (siteType === embLabels.ISLANDABLE_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_GENSET_ATS &&
        defaultPreFillData[1].mode === "FUEL_SAVER") ||
      (siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI")
    ) {
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
        payload: {
          switchType,
          clientType,
          mode: defaultPreFillData[1]?.mode,
          loadSide:loadSide,
        }
      });
      // CBLoadListDispatch({
      //   type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVGENSET_ATS,
      // });

      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_GENSET_LOAD,
        payload: { coordinates: coordinates, count: count, projectKind: projectKind, switchboardType: switchboardType },
      });

      let x22;
      if (count.derCount <= 3 && count.loadCount <= 4) {
        x22 = "1095";
      } else if (count.derCount <= 4 && count.loadCount <= 4) {
        siteType === "GRID_CONNECTED_GSX" ||
        (siteType === "ISLANDABLE_GSX" &&
          (switchType === "" || switchType === embLabels.EXISTING_SWITCHBOARD))
          ? (x22 = "1095")
          : (x22 = "510");
      } else if (count.derCount <= 4 && count.loadCount === 5) {
        switchType === embLabels.NEW_SWITCHBOARD &&
        siteType === "ISLANDABLE_GSX"
          ? (x22 = 570)
          : (x22 = "1170");
      } else if (count.loadCount === 10) {
        switchType === embLabels.NEW_SWITCHBOARD &&
        siteType === "ISLANDABLE_GSX"
          ? (x22 = 650)
          : (x22 = "1250");
      } else {
        {
          siteType === "ISLANDABLE_GSX" &&
          switchType === embLabels.NEW_SWITCHBOARD
            ? (x22 = "620")
            : (x22 = "1170");
        }
      }

      // x21: "594",

      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "158",
          y11: "285",
          x21: "330",
          y21: "285",
          x12: "630",
          y12: "430",
          x22: x22,
          y22: "430",
        },
      }));
    }

    if (
      (siteType === embLabels.GRID_CONNECTED_GSX &&
        clientType === embLabels.GREENSTRUXURE_PROJECT &&
        architectureType === embLabels.PV_BESS_NR) ||
      (projectTypeValue === "MGaaS ANSI" &&
        siteType === embLabels.GRID_CONNECTED)
    ) {
      const x21 = count.derCount === 2 ? "815" : "715";
      CBAssetListDispatch({
        type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
        payload: {
          switchType,
          mode: "",
          clientType:"",
          loadSide:loadSide,
          projectKind:projectKind
        }
      });
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_CBLOADLIST_COORDINATES_PVBESS_NR,
        payload: switchType,
      });
      let x22;
      if (count.derCount > 3) {
        setRectangleWidth(530);
        if (
          ["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) &&
          (switchType === "" || switchType === embLabels.EXISTING_SWITCHBOARD)
        ) {
          x22 = 1065;
        } else {
          siteType === "ISLANDABLE_GSX" &&
          switchType === embLabels.NEW_SWITCHBOARD
            ? (x22 = 690)
            : (x22 = 640);
          setRectangleWidth(730);
        }
      } else {
        if (
          !["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) ||
          (siteType !== "ISLANDABLE_GSX" &&
            (switchType === "" ||
              switchType === embLabels.EXISTING_SWITCHBOARD))
        ) {
          setRectangleWidth(420);
          x22 = 965;
        } else {
          setRectangleWidth(580);
          !["GRID_CONNECTED_GSX", "GRID_CONNECTED"].includes(siteType) ||
          (siteType !== "ISLANDABLE_GSX" &&
            (switchType !== "" ||
              switchType !== embLabels.EXISTING_SWITCHBOARD))
            ? (x22 = 510)
            : (x22 = 965);
        }
      }
      setCoordinates((prevCoordinates) => ({
        ...prevCoordinates,
        busbarCordinates: {
          ...prevCoordinates.busbarCordinates,
          x11: "168",
          y11: "283",
          x21: "408",
          y21: "283",
          x12: "630",
          y12: "430",
          x22,
          y22: "430",
        },
      }));

      checkAssetStatus();
    }
    if(siteType === embLabels.ISLANDABLE && projectTypeValue === "MGaaS ANSI"){
      if(switchboardType === embLabels.EXISTING_SWITCHBOARD){
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 250,
            yDerEV: 290,
            xDerPM: 475,
            yDerPM: 490,
            x1DerEVCB: 608,
            y1DerEVCB: 570,
            x2DerEVCB: 608,
            y2DerEVCB: 470,
          },
                
        }));
      }else{
        setCoordinates((prevCoordinates) => ({
          ...prevCoordinates,
          cbEV: {
            xDerEV: 80,
            yDerEV: 320,
            xDerPM: 25,
            yDerPM: 320,
            x1DerEVCB: 377.5,
            y1DerEVCB: 398.5,
            x2DerEVCB: 378.5,
            y2DerEVCB: 300,
          },  
             
        }));
      }
    }
    if(switchboardType===embLabels.EXISTING_SWITCHBOARD&&(isMgaasAnsiIsland||isDaasAnsiIsland ||isDaasEtoIsland)){
      CBLoadListDispatch({
        type: ACTIONS.UPDATE_REMOTE_LOAD_COORDINATES,
        payload: { coordinates: coordinates,loadSide:loadSide, count: count ,siteType:siteType, projectKind: projectKind,switchboardType},
      });
    }
    CBEVListDispatch({
      type: ACTIONS.UPDATE_CBEVLIST_COORDINATES_GRIDCONNECTED,
      payload: { coordinates: coordinates, count: count },
    });

    setCoordinates((prevCoordinates) => ({
      ...prevCoordinates,
      busbarCordinates: {
        ...prevCoordinates.busbarCordinates,
        ...coOrdinateLists.cooridinates,
      },
    }));
    setRectangleWidth(coOrdinateLists.rectangleWidth);

    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    const runCalculateCoordinatesNew = { componentPush: false };
    setRunCalculateCoordinates(runCalculateCoordinatesNew);
    sessionStorage.setItem("componentDataModified",true);
  };
 
 
  const handleSetLoadSide = (e) => {
    setLoadSide(e.target.value);
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
   if(isMgaasAnsiIsland || isDaasAnsiIsland || isDaasEtoIsland){
    CBAssetListDispatch({
      type: ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVGENSET_ATS_SETTING_MODE,
      payload: {
        switchType: switchboardType,
        mode: defaultPreFillData[1]?.mode,
        clientType: "GENERIC",
        loadSide:e.target.value,
      },
    });
   }
   
   if(isDaasAnsiGrid || isDaasEtoGrid || isMgaasAnsiGrid){
    CBAssetListDispatch({
      type:ACTIONS.UPDATE_CBASSETLIST_COORDINATES_PVBESS_NR,
      payload: {
        switchType: switchboardType,
        mode: defaultPreFillData[1]?.mode,
        clientType: "GENERIC",
        loadSide:e.target.value,
        projectKind:projectKind
      },
    });
   }
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    sessionStorage.setItem("componentDataModified",true);

  };

  const onAddPvExisiting = () => {
    CBAssetListDispatch({
      type: ACTIONS.ADD_PV_EXISTING,
    });
    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  const onAddBatteryExisting = () => {
    CBAssetListDispatch({
      type: ACTIONS.ADD_BESS_EXISTIING,
    });
    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };

  const removeExistingPm = () => {
    CBAssetListDispatch({
      type: ACTIONS.REMOVE_ASSET_EXISTING,
      payload: {
        selectedPv: selectedValues?.selectedAssetPM,
      },
    });
    setDetailsBlock((prevState) => ({
      ...prevState,
      existingPmAssetDetailsBlockGrid: false,
    }));

    const runCalculateCoordinatesNew = { componentPush: true };

    setTimeout(() => {
      setRunCalculateCoordinates(runCalculateCoordinatesNew);
    }, 100);
    sessionStorage.setItem("componentDataModified",true);
  };
 const handleEnergyReserve = (index, isChecked) => {
  const dataConfig = { ...configData?.configData };
     if(isChecked){
      dataConfig["SoC_min_optimization"] = 40;
     }else{
        dataConfig["SoC_min_optimization"] = 12;
     }
      setConfigData((prevState) => ({
        ...prevState,
        configData: dataConfig,
      }));
    // assetEditStatusUpdateDER(e, embLabels.BESS, true);
    // setIsAssetConfigChanged(configData);
    CBAssetListDispatch({
      type: ACTIONS.UPDATE_ENERGY_RESERVE,
      payload: {
        index: index,
        value:isChecked
      },
    });
 }
  const handleCbAssetRequired = (index,e ) => {
    if(cbCount?.assetCbCount === 24 && e.target.checked){
    callSnackbar("error", "Error in enabling Circuit Breakers due to maximum Circuit Breaker count used");
    return 

    }
    if(cbCount?.assetCbCount <= 24){
    let dummyCbData = null;
    if (siteType === embLabels.GRID_CONNECTED) {
      dummyCbData = { ...defaultDummyCbData };
    }

    CBAssetListDispatch({
      type: ACTIONS.CB_ASSET_REQUIRED,
      payload: {
        index: index,
        defaultCbData: defaultCbData,
        defaultValues: defaultPreFillData[0],
        dummyCbData,
      },
    });
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
  }else{
    
    callSnackbar("error", "Max 24 circuit breakers are allowed");
  }
  };

  const handleLoadCBAssetRequired = (index,e) => {
    const newLoadData = _.cloneDeep(CBLoadList);
    if(cbCount?.assetCbCount === 24 && e.target.checked){
      callSnackbar("error", "Error in enabling Circuit Breakers due to maximum Circuit Breaker count used");
      return 
  
      }
      
      if(cbCount?.assetCbCount <= 24){
        if(!e.target.checked){
          setCurrentProject((prevData) => ({
              ...prevData,
              flexName: configData?.cbConfigData?.name,
            }));
            let cbConfigDataNew = { ...configData?.cbConfigData };
             const cbUniqueName = crypto.randomUUID();
            cbConfigDataNew.name =  `${"LOAD_"+ (index + 1) +"_CB_" +cbUniqueName}`;
            setConfigData((prevState) => {
                    CBLoadListDispatch({
                type: ACTIONS.UPDATE_HANDLE_LOAD_CB_CONFIG,
                payload: {
                  selectedLoadCB: index,
                  cbConfigData:cbConfigDataNew,
                },
              });
            return { ...prevState,
              cbConfigData: cbConfigDataNew,
            }
            });
            
        }else{
            let numbersList = [];
            let LoadListLength =0;
            let cbConfigDataNew = { ...configData?.cbConfigData };
            
            const configNameArray = newLoadData.map(
              (loadData) => loadData?.cbConfigData?.name
            );

            configNameArray.forEach((item) => {
              const match = item?.match(/\d+/);
              if (match) {
                const number = parseInt(match[0], 10);
                if (!numbersList.includes(number)) {
                  numbersList.push(number);
                }
              }
            });

            function getNextAvailableLength(currentLength) {
              if (numbersList.includes(currentLength)) {
                return getNextAvailableLength(currentLength + 1);
              }
              return currentLength;
            }

            LoadListLength = getNextAvailableLength(newLoadData.length);

            // Set new name
            cbConfigDataNew.name = currentProject?.flexName ||`CB Load ${LoadListLength}`;

             
             setConfigData((prevState) => {
                  CBLoadListDispatch({
                type: ACTIONS.UPDATE_HANDLE_LOAD_CB_CONFIG,
                payload: {
                  selectedLoadCB: index,
                  cbConfigData:cbConfigDataNew,
                },
              });
              return {...prevState,
              cbConfigData: cbConfigDataNew,}
            });

           
        }
        CBLoadListDispatch({
          type: ACTIONS.LOAD_CB_ASSET_REQUIRED,
          payload:{
            index: index,
            defaultCbData: defaultCbData,
            defaultValues: defaultPreFillData[0],
          }
        });
   setTimeout(()=>{
    setIsAssetConfigChanged(index);
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
   },1000)
  }
  
}
    const handleEVCbChange =(e) =>{
      if (e.target.checked && checkSLDCount()) {
        CBEVListDispatch({ type: ACTIONS.EV_ASSET_CB_REQUIRED });
        setTimeout(() => {
            const runGenerateComponentsBlockNew = { generateComponentsBlock: true };  
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
          }, 100);
      } else {
        if (e.target.checked === false) {
          CBEVListDispatch({ type: ACTIONS.EV_ASSET_REMOVE_CB });
          setTimeout(() => {
            const runGenerateComponentsBlockNew = { generateComponentsBlock: true };  
            setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
          }, 100);

        } else {
          callSnackbar("error", "Max 24 loads are allowed");
        }

      }
    }

  const handlePmAssetRequired = (index) => {
    CBAssetListDispatch({
      type: ACTIONS.PV_ASSET_PM_REQUIRED,
      payload: {
        index: index,
        defaultPmData: defaultPmData,
        defaultValues: defaultPreFillData[0],
      },
    });
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
  };
  const handleBessController = (index, e) => {
    const checked = e.target.checked;
    if(checked === false){
     setConfigData((prevState) => {
    return {
     ...prevState, configData:{
      ...prevState.configData,
       quantityOfBess:1,
      perUnitMaxPower:0,
      perUnitMaxEnergy:0,
      max_power:bessControllerPrevValue?.max_power,
      capacity:bessControllerPrevValue?.capacity,
     }
    }
   });
   }else{
     setConfigData((prevState) => {
    return {
     ...prevState, configData:{
      ...prevState.configData,
      max_power:prevState.configData?.quantityOfBess * prevState.configData?.perUnitMaxPower,
      capacity:prevState.configData?.quantityOfBess * prevState.configData?.perUnitMaxEnergy,
     }
    }
   });
   }
    CBAssetListDispatch({
      type: ACTIONS.BESS_CONTROLLER,
      payload: {
        index: index,
        isChecked:checked
      },
    });
   
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
  };

  const handleLoadPmAssetRequired = (index) => {
    CBLoadListDispatch({
      type: ACTIONS.LOAD_PM_ASSET_REQUIRED,
      payload:{
        index: index,
        defaultPmData: defaultPmData,
        defaultValues: defaultPreFillData[0],
      }
    })
  }

  const handleEmAssetRequired = (index) => {
    CBAssetListDispatch({
      type: ACTIONS.PV_ASSET_EM_REQUIRED,
      payload: {
        index: index,
        defaultPmData: defaultPmData,
        defaultValues: defaultPreFillData[0],
        projectTypeValue
      },
    });
  };
  const handleRemoteMain = ()=>{
    setRemoteMain(prev => !prev);
    const runGenerateComponentsBlockNew = { generateComponentsBlock: true };
    setRunGenerateComponentsBlock(runGenerateComponentsBlockNew);
    const runCalculateCoordinatesNew = { componentPush: false };
    setRunCalculateCoordinates(runCalculateCoordinatesNew);
    sessionStorage.setItem("componentDataModified",true);
  }
  //* LOCAL STORAGE
  // JSX starts here
  return (
    <MyErrorBoundary>
      <div className={`container-fluid h-100 container-margin`}>
        <se-loading loading={loading}></se-loading>
        <ProjectStatus />

        <div
          className={`${loading ? "se-block-disabled" : ""} row h-100 mt-2`}
          style={displayPage ? {} : { display: "none" }}
        >
          <AddEquipment
            spanishCodeRealTime = {spanishCodeRealTime}
            loading={loading}
            siteType={siteType}
            clientType={clientType}
            switchboardType={switchboardType}
            handleSwitchboardTypeChangeGSX={handleSwitchboardTypeChangeGSX}
            remoteMain={remoteMain}
            setRemoteMain={setRemoteMain}
            handleRemoteMain={handleRemoteMain}
            architectureType={architectureType}
            onAddGensetVerify={addGensetVerify}
            onAddBattery={addBattery}
            onAddPv={addPv}
            onAddCHPVerify={addCHPVerify}
            onAddLoad={addLoad}
            onAddRemoteLoad={addRemoteLoad}
            onAddEv={addEv}
            onAddTransferSwitch={addTransferSwitch}
            gridSettingMode={defaultPreFillData[1]?.mode}
            projectStatus={projectStatusData?.projectStatus}
            siteCreated={siteCreated}
            count={count}
            PVDetails={PVDetails}
            availableDer={availableDer}
            useCases={useCases}
            handleSetLoadSide={handleSetLoadSide}
            loadSide={loadSide}
            onAddPvExisiting={onAddPvExisiting}
            onAddBatteryExisting={onAddBatteryExisting}
            allowSwitchBoard={
              CBAssetList[2].uiData.existingPmRequired ||
              CBAssetList[3].uiData.existingPmRequired
            }
            CBAssetList={CBAssetList}
            projectKind={projectKind}
            CBEVList={CBEVList}
            setRemoteConfirm={setRemoteConfirm}
            okConfirmMessageRemote={okConfirmMessageRemote}
            closeConfirmMessage={closeConfirmMessage}
            remoteConfirm={remoteConfirm}
            closeConfirmMessageRemote={closeConfirmMessageRemote}
            isAllowMultipleLoads = {isAllowMultipleLoads}
            isExportOptimization = {isExportOptimization}
           
          />
          <div className="col-sm-8 col-md-8 col-lg-8 custom-project-container background-SLD ">
            
<svg 

    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 0
    }}

 width="100vw" height="100vh" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <pattern id="tinySquares" x="0" y="0" width="2" height="2" patternUnits="userSpaceOnUse">
      <rect x="0" y="0" width="3" height="3" fill="var(--se-svgline-bg)" stroke="var(--se-svg-background)" strokeWidth="0.1"/>
    </pattern>
  </defs>
  <rect x="0" y="0" width="100" height="100" fill="url(#tinySquares)" />
</svg>

            <DesignAssetDescription
              siteCreated={siteCreated}
              projectStatusData={projectStatusData}
              checkAssetStatus = {checkAssetStatus}
              saveDraftComponentData = {saveDraftComponentData}
              setIsOpen= {setIsOpen}
            />
            <div className="row mt-5">
              <DesignAssetProvider
                value={{
                  clientType,
                  coordinates,
                  CBAssetList,
                  CBEVList,
                  CBLoadList,
                  PVDetails,
                  UserScope,
                  sldLoadCompleted,
                  count,
                  siteType,
                  switchboardType,
                  architectureType,
                  rectangleWidth,
                  pv1SelectHandler,
                  pv2SelectHandler,
                  pv3SelectHandler,
                  CBAssetListDispatch,
                  CBLoadListDispatch,
                  CBEVListDispatch,
                  PVDetailsDispatch,
                  assetDetailsReset,
                  callSnackbar,
                  selectedValuesHandler,
                  selectedSubPvHandler,
                  selectedValues,
                  selectedAssetHandler,
                  selectedAssetHandlerPv,
                  assetConfigDataHandler,
                  cbConfigDataHandler,
                  newSBCbConfigDataHandler,
                  loadConfigDataHandler,
                  loadCbConfigDataHandler,
                  pmConfigDataHandler,
                  existingPmConfigDataHandler,
                  loadpmConfigDataHandler,
                  evpmConfigDataHandler,
                  evConfigDataHandler,
                  evCbConfigDataHandler,
                  padNumberFormat,
                  detailsBlock,
                  loadSide,
                  projectTypeValue,
                  remoteMain,
                  projectKind,
                  isAntiIslandingRelayEnable,
                  loadSelectHandler,
                  isAllowMultipleLoads,
                  isExportOptimization,
                }}
              >
                {clientType === embLabels.A2E_PROJECT &&
                  siteType === embLabels.GENSET_PVBESS_A2E && <A2ESLD />}
                {/* This calls mgaas iec islandable */}
                {clientType === embLabels.GENERIC_PROJECT &&
                  siteType === embLabels.ISLANDABLE &&
                  !["MGaaS ANSI", "MGaaS ETO"].includes(projectTypeValue) && (
                    <IslandableSLD />
                  )}
                {/* This calls mgaas iec grid connected */}
                {clientType === embLabels.GENERIC_PROJECT &&
                  siteType === embLabels.GRID_CONNECTED &&
                  !["MGaaS ANSI", "MGaaS ETO"].includes(projectTypeValue) && (
                    <GridConnectedRosette />
                  )}

                {isMGaaSETOGrid && <GridEtoSLD />}
                {isMGaaSETOIsland && projectTypeValue === "MGaaS ETO" && (
                  <IslandableEtoSLD />
                )}

                {clientType === embLabels.GENERIC_PROJECT &&
                  siteType === embLabels.PV_HYBRIDIZATION && (
                    // <PVHybridizationSLD />
                    <GensetPvHybridEto />
                  )}
                {/* for daas it never calls , IES never calls, Mgaas no call*/}
                {clientType === embLabels.GREENSTRUXURE_PROJECT &&
                  siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  (defaultPreFillData[1].mode === "GENSET_MAIN_NO_BESS" ||
                    defaultPreFillData[1].mode === "NO_FUEL") && (
                    <PvGensetAtsSLD />
                  )}
                {/* daas ansi grid connected / mgaas ansi islandable */}
                {((clientType === embLabels.GREENSTRUXURE_PROJECT &&
                  siteType === embLabels.ISLANDABLE_GSX &&
                  architectureType === embLabels.PV_GENSET_ATS &&
                  defaultPreFillData[1].mode === "FUEL_SAVER") ||
                  (clientType === embLabels.GENERIC_PROJECT &&
                    siteType === embLabels.ISLANDABLE &&
                    projectTypeValue === "MGaaS ANSI")) && <GensetPvBessSLD />}
                {/* Daas Ansi/ mgaas ansi gridconnected || Daas ansi Islandable*/}
                {((clientType === embLabels.GREENSTRUXURE_PROJECT &&
                  siteType === embLabels.GRID_CONNECTED_GSX &&
                  architectureType === embLabels.PV_BESS_NR) ||
                  (clientType === embLabels.GENERIC_PROJECT &&
                    siteType === embLabels.GRID_CONNECTED &&
                    projectTypeValue === "MGaaS ANSI")) && <PvBessNrSLD />}
              </DesignAssetProvider>
            </div>
          </div>

          {/* configuration*/}
          <div
            className={`col-sm-2 col-md-2 col-lg-2 custom-configuration-container border se-white-background ${
              siteCreated ||
              projectStatusData?.projectStatus === "COMPLETED" ||
              projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
                ? "se-block-disabled"
                : ""
            } `}
          >
            <div className="row">
              <div className="col-md-12 pl-0 pr-0  se-white-background ">
                <div className="col-md-12 mt-1 p-2 se-life-green bold border-bottom">
                  CONFIGURATION
                </div>
              
              </div>
              <AssetBlockContextProvider
                value={{
                  spanishCodeRealTime,
                  assetDetailsReset,
                  UserScope,
                  callSnackbar,
                  CBLoadListDispatch,
                  selectedValuesHandler,
                  loadConfigDataHandler,
                  loadCbConfigDataHandler,
                  switchboardType,
                  siteType,
                  loadSide,
                  clientType,
                  configData,
                  defaultsMinMax,
                  assetDetailsDisplay,
                  projectTypeValue,
                  projectKind,
                  siteType,
                  architectureType,
                  selectedValues,
                  PVDetails,
                  gsxExternalId,
                  CBAssetList,
                  CBEVList,
                  CBLoadList,
                  batterySystemA2EConfig,
                  jsonData,
                  isContactorEnabled,
                  CBAssetListDispatch,
                  CBEVListDispatch,
                  PVDetailsDispatch,
                  handleUtilityChange,
                  handleGensetChange,
                  handleBatteryChange,
                  handleChpChange,
                  handleHybridChange,
                  handleLoadChange,
                  handleEvChange,
                  handleCBConfigChange,
                  handleCBContactorConfigChange,
                  handleCBConfigChangeLoad,
                  handleCBConfigChangeEv,
                  updateUtilitytConfig,
                  updateGensetConfig,
                  updateBatteryConfig,
                  updateChpConfig,
                  updateHybridConfig,
                  updatePvArrayConfig,
                  updateLoadConfig,
                  updateEvConfig,
                  updatePowerMeterData,
                  updateCbConfigData,
                  updateCbContactorConfigData,
                  updateLoadCbConfigData,
                  updateEvCbConfigData,
                  setAssetSelection,
                  selectedAssetHandlerPv,
                  assetEditStatusUpdateDER,
                  assetEditStatusUpdateAssetCB,
                  assetEditStatusUpdateLoad,
                  assetEditStatusUpdateLoadCb,
                  assetEditStatusUpdateEvCb,
                  assetEditStatusUpdateAssetPM,
                  assetEditStatusUpdateEvPM,
                  assetEditStatusUpdatePv,
                  checkGensetRemoveCondition,
                  checkBatteryRemoveCondition,
                  removeCHP,
                  removePvWithAlert,
                  removePv,
                  removeLoad,
                  removeEv,
                  isCopyAllButtonDisabled,
                  copyAllPvs,
                  arrayMaxPowerFinder,
                  calculateMaxAvailableUtilityPower,
                  calculateMaxAvailableLoadPower,
                  calculateMaxAvailableGensetPower,
                  handleChangeBattery,
                  handleChangeBessHybridBatteryRack,
                  gridSettingMode: defaultPreFillData[1]?.mode,
                  removeExistingPm,
                  defaultCbData,
                  handleCbAssetRequired,
                  handleEnergyReserve,
                  handlePmAssetRequired,
                  handleEmAssetRequired,
                  handleBessController,
                  isBessController,
                  projectType,
                  switchboardType,
                  projectKind,
                  handleLoadCBAssetRequired,
                  handleLoadPmAssetRequired,
                  checkAssetStatus,
                  setIsOpenLoadConfig,
                  selectedLoadIndx,
                  detailsBlock,
                  updateRemoteLoadCbConfigData,
                  isEvce,
                  setPrevPvGroupNames,
                  count,
                  callSnackbar,
                  checkSLDCount,
                  handleEVCbChange
                }}
              >
                {detailsBlock.assetUtilityDetailsBlock && <UtilityAsset />}
                {detailsBlock.assetGensetDetailsBlock &&
                  [embLabels.GRID_CONNECTED, embLabels.ISLANDABLE].includes(
                    siteType
                  ) && <GensetAsset />}
                {detailsBlock.assetGensetDetailsBlock &&
                  [embLabels.PV_HYBRIDIZATION].includes(siteType) && (
                    <GensetAsset />
                  )}
                {detailsBlock.assetGensetDetailsBlock &&
                  (([embLabels.ISLANDABLE_GSX].includes(siteType) &&
                    architectureType === embLabels.PV_GENSET_ATS) ||
                    ([embLabels.GENSET_PVBESS_A2E].includes(siteType) &&
                      clientType === embLabels.A2E_PROJECT)) && (
                    <GensetAssetPvHyb />
                  )}
                {detailsBlock.assetBatteryDetailsBlock && <BatteryAsset />}
                {detailsBlock.assetPvDetailsBlock && <PVAsset />}
                {detailsBlock.assetCHPDetailsBlock && <CHPAsset />}
                {detailsBlock.assetHybridDetailsBlock && <HybridAsset />}
                {detailsBlock.assetBessHybridDetailsBlock && (
                  <BessHybridAsset />
                )}
                {/* {detailsBlock.loadDetailsBlock && <LoadAsset />} */}
                {detailsBlock.loadDetailsBlock && <LoadAssetDetails cbCount ={cbCount}/>}
                {detailsBlock.cbLoadDetailsBlock &&   <RemoteLoadCbDetails />
                }
                {detailsBlock.evDetailsBlock && <EvCluster />}
                {detailsBlock.cbEvDetailsBlock && (
                  <EvCB detailsBlock={detailsBlock} />
                )}
                {detailsBlock.cbAssetDetailsBlock && (
                  <CircuitBreakerDetails
                    siteType={siteType}
                    architectureType={architectureType}
                    selectedValues={selectedValues}
                  />
                )}
                {detailsBlock.newSBCbAssetDetailsBlock && <GsxNewSBCbDetails />}
                {(detailsBlock.cbAssetDetailsBlockA2E ||
                  detailsBlock.pmAssetDetailsBlockA2E) && (
                  <CbPmDetailsA2E detailsBlock={detailsBlock} />
                )}
                {(detailsBlock.cbAssetDetailsBlockGrid ||
                  detailsBlock.pmAssetDetailsBlockGrid) && (
                  <CbPmDetailsGrid detailsBlock={detailsBlock} />
                )}
                {detailsBlock.existingPmAssetDetailsBlockGrid && (
                  <ExistingPmDetailsGrid detailsBlock={detailsBlock} />
                )}
                {detailsBlock.hardWiredCbDetailsBlockGrid && (
                  <HardWiredSBCbDetails />
                )}
                {isNoAssetSelected() && <NoAssetSelected />}
              </AssetBlockContextProvider>
            </div>
          </div>
        </div>

        <Snackbar snackBar={snackBar} ref={snackBarRef} />
        <AlertIcon alert={alert} onClose={closeAlertMessage} />
        
        <Confirm
          confirm={confirm}
          onClose={closeConfirmMessage}
          onOk={okConfirmMessage}
        />

        <AssetSelectionDER
          assetInfo={assetInfo}
          cbDer = {cbDer}
          onSelectManufacturer={selectManufacturer}
          closeAssetSelectionBlock={closeAssetSelectionBlock}
          onSelectAssetInModal={selectAssetFromList}
          CBLoadList={CBLoadList}
          defaultsMinMax={defaultsMinMax}
          projectKind={projectKind}
          switchboardType = {switchboardType}
          remoteMain = {remoteMain}
          selectedValues = {selectedValues}
          isSelectSpanishCode = {isSelectSpanishCode}
          siteType={siteType}
        />

        <AssetSelectionPV
          siteType={siteType}
          architectureType={architectureType}
          assetDetailsDisplay={assetDetailsDisplay}
          PVDetails={PVDetails}
          gsxExternalId={gsxExternalId}
          onHandlePvChange={handlePvChange}
          onsetAssetSelection={setAssetSelection}
          assetEditStatusUpdatePv={assetEditStatusUpdatePv}
          defaultsMinMax={defaultsMinMax}
          onClosePvDetailsBlock={closePvDetailsBlock}
          onUpdatePvConfig={updatePvConfig}
        />
        <LoadConfigDetailsModal
          isOpenLoadConfig={isOpenLoadConfig}
          setIsOpenLoadConfig={setIsOpenLoadConfig}
          configData={configData}
          isLoadNameUnique = {isLoadNameUnique}
          handleLoadChange={handleLoadChange}
          updateLoadConfig={updateLoadConfig}
          removeLoad={removeLoad}
          calculateMaxAvailableLoadPower={calculateMaxAvailableLoadPower}
          projectKind={projectKind}
          CBLoadList={CBLoadList}
          selectedValues={selectedValues}
          handleLoadCBAssetRequired={handleLoadCBAssetRequired}
          handleLoadPmAssetRequired={handleLoadPmAssetRequired}
          siteType={siteType}
          updateLoadCbConfigData={updateLoadCbConfigData}
          handleCBConfigChangeLoad={handleCBConfigChangeLoad}
          assetEditStatusUpdateLoadCb={assetEditStatusUpdateLoadCb}
          setAssetSelection={setAssetSelection}
          assetDetailsDisplay={assetDetailsDisplay}
          updateLoadCbPm = {updateLoadCbPm}
          CBAssetList = {CBAssetList}
            CBEVList = {CBEVList}
            assetInfo = {assetInfo}
            handleCBContactorConfigChangeLoad ={handleCBContactorConfigChangeLoad}
        />
        <AddPvModals
        spanishCodeRealTime = {spanishCodeRealTime}
          CBAssetList={CBAssetList}
          siteType={siteType}
          clientType={clientType}
          architectureType={architectureType}
          PVDetails={PVDetails}
          onPvDetailsDispatch={PVDetailsDispatch}
          onAddPVSetWithCB={addPVSetWithCB}
          gridSettingMode={defaultPreFillData[1]?.mode}
          projectKind={projectKind}
        />
      <DraggableModal isOpen={isOpen} onClose={()=>setIsOpen(prev=>!prev)}  projectKind={projectKind} assetDetails = {assetDetails}/>
      </div>
    </MyErrorBoundary>
  );
});

export default DesignAsset;
